/**
 * TeamSystem Impact - i18n Configuration
 * Internazionalizzazione IT/EN con react-i18next
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Traduzioni italiane
export const translationsIT = {
  common: {
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Successo',
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    create: 'Crea',
    search: 'Cerca',
    filter: 'Filtra',
    export: 'Esporta',
    import: 'Importa',
    close: 'Chiudi',
    confirm: 'Conferma',
    yes: 'Sì',
    no: 'No',
  },
  consent: {
    subtitle: 'vuole accedere a TeamSystem Impact',
    actingAs: 'Accederà come:',
    destination: 'L’autorizzazione verrà consegnata a:',
    scopesUnrecognised: 'I permessi richiesti da questa applicazione non esistono in piattaforma: non è un problema del tuo ruolo. Segnalalo a chi l’ha configurata.',
    willBeAbleTo: 'Potrà:',
    authorize: 'Autorizza',
    authorizing: 'Autorizzo...',
    deny: 'Annulla',
    loading: 'Un istante...',
    unknownClient: 'Client AI',
    invalidRequest: 'Richiesta di accesso incompleta o non valida.',
    errorLoading: 'Non riesco a leggere la richiesta di accesso.',
    errorAuthorizing: 'Autorizzazione non riuscita. Riprova.',
    nothingToGrant: 'Il tuo ruolo non consente nessuno dei permessi richiesti, quindi non c’è nulla da autorizzare.',
    someDenied: 'Alcuni permessi richiesti non sono compresi, perché il tuo ruolo non li prevede.',
    scopes: {
      'dma:read': 'Leggere la doppia materialità (temi, IRO, valutazioni)',
      'dma:write': 'Modificare la doppia materialità',
      'datacapture:read': 'Leggere i dati raccolti e lo stato delle campagne',
      'datacapture:write': 'Inserire e modificare i dati raccolti',
      'datacapture:config': 'Configurare la raccolta dati (ruoli, campagne, assegnazioni)',
      'pm:read': 'Leggere task e attività',
      'pm:write': 'Creare e aggiornare task',
      'engagement:read': 'Leggere i questionari agli stakeholder',
      'engagement:write': 'Inviare risposte ai questionari',
      'admin:read': 'Leggere le anagrafiche e le viste amministrative',
      'ma:write': 'Scrivere nei fascicoli delle acquisizioni (M&A)',
      unknown: 'Permesso non riconosciuto',
    },
  },
  auth: {
    login: 'Accedi',
    logout: 'Esci',
    loginWithMicrosoft: 'Accedi con Microsoft',
    welcome: 'Benvenuto in TeamSystem Impact',
    loggingIn: 'Autenticazione in corso...',
    loginError: 'Errore durante l\'autenticazione',
    sessionExpired: 'Sessione scaduta. Effettua nuovamente l\'accesso.',
    tagline: 'Piattaforma ESG per la conformità CSRD. Doppia materialità, raccolta dati e reporting ESRS in un unico strumento.',
    allRightsReserved: 'Tutti i diritti riservati',
    loginErrorMicrosoft: 'Errore durante il login con Microsoft',
  },
  header: {
    subtitle: 'Piattaforma ESG & CSRD',
    profile: 'Profilo',
    openMenu: 'Apri il menu di navigazione',
    toggleLight: 'Passa al tema chiaro',
    toggleDark: 'Passa al tema scuro',
    userMenu: 'Menu account utente',
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Benvenuto, {{name}}',
    overview: 'Panoramica della gestione ESG e conformità CSRD',
    esgScore: 'Score ESG',
    completamento: 'Completamento',
    materiality: 'Materialità',
    materialitySubtitle: 'Topic materiali',
    dataCapture: 'Raccolta Dati',
    dataCaptureSubtitle: 'Datapoint completati',
    reporting: 'Reporting',
    reportStatus: 'In Review',
    reportDeadline: 'Scadenza: 31/03/2025',
    taxonomy: 'Tassonomia EU',
    availableModules: 'Moduli Disponibili',
    doubleMateriality: 'Doppia Materialità',
    doubleMaterialityDesc: 'Valutazione IRO e matrice di materialità',
    dataMultiCountry: 'Data Capture Multi-Country',
    dataMultiCountryDesc: 'Raccolta dati ESRS con delega country',
    executiveDashboard: 'Dashboard Executive',
    executiveDashboardDesc: 'KPI ESG aggregati per C-level',
    taxonomyModule: 'Tassonomia Green EU',
    taxonomyModuleDesc: 'Eligibility, alignment e KPI Art. 8',
    esrsStandards: 'Standard ESRS',
    available: 'Disponibile',
    comingSoon: 'Coming Soon',
    dmaCompleted: 'Completata',
    dmaInProgress: 'In corso',
    contributorSubtitle: 'Le tue attività su Impact per l\'anno {{year}}',
    unreadTitle: 'Notifiche nuove',
    openInbox: 'Apri la posta in arrivo',
    allRead: 'Nessuna novità',
    datapointsToFill: 'Datapoint da compilare',
    goToCollection: 'Vai a Raccolta',
    datapointsToValidate: 'Datapoint da validare',
    goToValidation: 'Vai a Validazione',
    datapointsToConsolidate: 'Datapoint da consolidare',
    goToConsolidation: 'Vai a Consolidamento',
    dmaAssessments: 'Valutazioni DMA',
    openYourAssessments: 'Apri le tue valutazioni',
    noAssignments: 'Non hai attività assegnate per l\'anno {{year}}. Riceverai una notifica quando ti verranno assegnati datapoint o valutazioni.',
    totalIros: 'IRO Totali',
    yearLabel: 'Anno {{year}}',
    assessmentTitle: 'Assessment',
    irosAssessed: 'IRO valutati',
    path: {
      heading: 'Il respiro della compliance',
      subheading: 'Anno {{year}} · TeamSystem Impact',
      statusNotStarted: 'Non iniziata',
      statusInProgress: 'Avviata',
      statusCompleted: 'Conclusa',
      engagement: 'Stakeholder Engagement',
      engagementDesc: 'Ascolto degli stakeholder',
      dma: 'Doppia Materialità',
      dmaDesc: 'Valutazione di impatto e finanziaria',
      collection: 'Raccolta Dati',
      collectionDesc: 'Compilazione dei datapoint di sostenibilità',
      reporting: 'Reporting',
      reportingDesc: 'Pubblicazione della rendicontazione',
      comingSoon: 'Prossimamente',
      chipCampaigns: '{{n}} campagne',
      chipResponses: '{{n}} risposte',
      chipMaterialIros: '{{n}} IRO materiali',
      chipAreas: '{{n}} macro aree materiali',
      chipDatapoints: '{{n}} datapoint',
      chipFrameworks: '{{n}} framework',
      chipOverdue: '{{n}} in ritardo',
      openFullScreen: 'Apri a schermo intero',
      engCampaigns: 'Campagne dell\'anno',
      engResponses: 'Risposte raccolte',
      engCampaignsList: 'Campagne',
      engOpenModule: 'Apri Engagement',
      engEmpty: 'Nessuna campagna di engagement per quest\'anno.',
      dmaTotal: 'IRO totali',
      dmaMaterial: 'IRO materiali',
      dmaAreas: 'Macro aree',
      dmaTopAreas: 'Macroaree più materiali',
      dmaOpenMatrix: 'Apri la matrice di materialità',
      colReports: 'Report della raccolta',
      colDatapoints: 'datapoint',
      colCompleted: 'compilati',
      colOpenModule: 'Apri Raccolta',
      colEmpty: 'Nessun report di raccolta per quest\'anno.',
      colReportKpis: 'KPI chiave',
      colCompiled: 'Compilati',
      colValidated: 'Validati',
      colOpenReport: 'Vai a Report Assessment',
    },
  },
  navigation: {
    dashboard: 'Dashboard',
    dma: 'Doppia Materialità',
    dma_full: 'Analisi Doppia Materialità',
    dma_catalog: 'Catalogo IRO',
    dma_assessment: 'Valutazioni',
    dma_campaigns: 'Campagne',
    dma_materiality: 'Materialità',
    dma_matrix: 'Matrice Materialità',
    dma_settings: 'Impostazioni Anno',
    dma_report: 'Report DMA',
    materiality: 'Doppia Materialità',
    data: 'Dati',
    data_configuration: 'Configurazione',
    data_collection: 'Raccolta',
    data_validation: 'Validazione',
    data_roles: 'Ruoli Data Capture',
    data_report_assessment: 'Report Assessment',
    data_documents: 'Libreria',
    dataCapture: 'Raccolta Dati',
    reporting: 'Report',
    reporting_reports: 'Rapporti',
    reporting_csrd: 'Report CSRD',
    reporting_executive: 'Sintesi Esecutiva',
    taxonomy: 'Tassonomia EU',
    taxonomy_overview: 'Panoramica',
    taxonomy_activities: 'Attività Economiche',
    ma: 'M&A',
    inbox: 'Notifiche',
    engagement: 'Engagement',
    agent_tokens: 'Token Agente',
    settings: 'Impostazioni',
    settings_info: 'Informazioni',
    settings_year_management: 'Gestione Anno',
    settings_connections: 'Connessioni AI',
    settings_sustainability: 'Piattaforma Sostenibile',
    settings_users: 'Gestione Utenti',
    users: 'Utenti',
    audit: 'Audit Trail',
    menuTitle: 'Navigazione',
    closeMenu: 'Chiudi navigazione',
    skipToContent: 'Vai al contenuto principale',
  },
  notifications: {
    title: 'Notifiche',
    markAllRead: 'Segna tutte come lette',
    empty: 'Nessuna notifica',
    emptyDesc: 'Quando riceverai nuove notifiche, appariranno qui.',
    justNow: 'Adesso',
  },
  materiality: {
    title: 'Doppia Materialità',
    iroAssessment: 'Valutazione IRO',
    stakeholders: 'Stakeholder',
    matrix: 'Matrice di Materialità',
    impacts: 'Impatti',
    risks: 'Rischi',
    opportunities: 'Opportunità',
  },
  dma: {
    setupWizard: {
      assessmentYear: 'Anno Valutazione',
      groupCompanies: 'Società Gruppo',
      geographies: 'Geografie',
      valueChain: 'Catena Valore',
      stakeholders: 'Stakeholder',
      naceCodes: 'Codici NACE',
      review: 'Revisione',
      assessmentYearTitle: 'Anno di Valutazione',
      assessmentYearDesc: "Seleziona l'anno di riferimento per la valutazione di materialità.",
      year: 'Anno',
      groupCompaniesTitle: 'Società del Gruppo',
      groupCompaniesDesc: 'Aggiungi le società incluse nel perimetro di rendicontazione.',
      companyName: 'Nome Società',
      country: 'Paese',
      consolidated: 'Consolidata',
      parentCompany: 'Capogruppo',
      add: 'Aggiungi',
      name: 'Nome',
      yes: 'Sì',
      no: 'No',
      noCompanyAdded: 'Nessuna società aggiunta',
      geographiesTitle: 'Geografie Attive',
      geographiesDesc: "Seleziona i paesi in cui opera l'organizzazione.",
      valueChainTitle: 'Catena del Valore',
      valueChainDesc: 'Seleziona le posizioni della catena del valore rilevanti per la valutazione.',
      stakeholdersTitle: 'Categorie Stakeholder',
      stakeholdersDesc: "Seleziona le categorie di stakeholder rilevanti per l'organizzazione.",
      naceCodesTitle: 'Codici NACE',
      naceCodesDesc: "Aggiungi i codici NACE delle attività economiche dell'organizzazione.",
      naceCode: 'Codice NACE',
      naceExample: 'es. 62.01',
      description: 'Descrizione',
      primary: 'Primario',
      code: 'Codice',
      noNaceAdded: 'Nessun codice NACE aggiunto',
      reviewTitle: 'Revisione Configurazione',
      completeness: 'Completezza',
      notes: 'Note (opzionale)',
      cancel: 'Annulla',
      back: 'Indietro',
      next: 'Avanti',
      saveChanges: 'Salva Modifiche',
      createSetup: 'Crea Setup',
      editDmaSetup: 'Modifica Setup DMA',
      newDmaSetup: 'Nuovo Setup DMA',
      saveError: 'Errore durante il salvataggio',
      italy: 'Italia',
      spain: 'Spagna',
      france: 'Francia',
      switzerland: 'Svizzera',
      albania: 'Albania',
      denmark: 'Danimarca',
      turkey: 'Turchia',
      israel: 'Israele',
      upstream: 'Upstream',
      operations: 'Operazioni Proprie',
      downstream: 'Downstream',
      upstreamDesc: 'Fornitori, materie prime, approvvigionamento',
      operationsDesc: 'Produzione, servizi, sedi operative',
      downstreamDesc: 'Distribuzione, clienti, fine vita prodotto',
      employees: 'Dipendenti',
      customers: 'Clienti',
      suppliers: 'Fornitori',
      investors: 'Investitori',
      localCommunities: 'Comunità Locali',
      regulators: 'Regolatori',
      partners: 'Partner',
      other: 'Altri',
    },
    assessmentPrepareDialog: {
      prepareAssessment: 'Prepara Assessment',
      selectStakeholder: 'Seleziona Stakeholder',
      selectIros: 'Seleziona IRO',
      sendOptions: 'Opzioni di Invio',
      confirm: 'Conferma',
      targetStakeholder: 'Stakeholder di Riferimento',
      searchStakeholder: 'Cerca stakeholder interno...',
      noStakeholderSelected: 'Nessuno stakeholder selezionato',
      stakeholderRole: 'Ruolo',
      stakeholderAreas: 'Aree di competenza',
      autoIncludeAssigned: 'Includi IRO con stakeholder assegnato',
      autoIncludeAssignedHint: 'Pre-seleziona automaticamente gli IRO dove questo stakeholder è tra i valutatori assegnati',
      irosAlreadyAssigned: 'IRO già assegnati a questo stakeholder',
      irosNotAssigned: 'IRO non ancora assegnati',
      code: 'Codice',
      name: 'Nome',
      esrsArea: 'Area ESRS',
      type: 'Tipo',
      status: 'Stato',
      campaign: 'Campagna',
      noAssignedIros: 'Nessun IRO già assegnato a questo stakeholder',
      noUnassignedIros: 'Tutti gli IRO sono già assegnati',
      selectedIros: 'IRO selezionati',
      loadingAssignments: 'Caricamento assegnazioni...',
      newCount: 'nuovi',
      sendTo: 'Invia a',
      sendToStakeholder: 'Invia allo stakeholder stesso',
      sendToEmail: 'Invia a un indirizzo email specifico',
      fillOnBehalf: 'Compila per conto dello stakeholder',
      fillOnBehalfHint: "Compilerai direttamente l'assessment per conto dello stakeholder selezionato",
      emailRecipient: 'Indirizzo Email',
      emailRecipientName: 'Nome del Destinatario',
      viewpointNote: 'Il destinatario email fornirà il punto di vista ma non rappresenta lo stakeholder.',
      assessmentType: 'Tipo di Assessment',
      impact: 'Solo Impatto',
      financial: 'Solo Finanziario',
      both: 'Entrambi',
      deadline: 'Scadenza',
      notes: 'Note per il valutatore',
      summary: 'Riepilogo Assessment',
      willBeSentTo: 'Sarà inviato a',
      willFillDirectly: "Compilerai direttamente l'assessment per conto di",
      viaEmail: 'via email',
      irosToAssess: 'IRO da valutare',
      cancel: 'Annulla',
      back: 'Indietro',
      next: 'Avanti',
      createAndSend: 'Crea e Invia',
      createDraft: 'Salva come Bozza',
      fillNow: 'Compila ora',
      selectAtLeastOneIro: 'Seleziona almeno un IRO',
      enterValidEmail: 'Inserisci un indirizzo email valido',
      errorCreating: "Errore durante la creazione dell'assessment",
      emailRecipientViewpoint: 'Destinatario email (punto di vista)',
    },
    campaignDetail: {
      campaignNotFound: 'Campagna non trovata',
      statusDraft: 'Bozza',
      statusActive: 'Attiva',
      statusCompleted: 'Completata',
      statusCancelled: 'Annullata',
      statusPending: 'In Attesa',
      statusInProgress: 'In Corso',
      irosInCampaign: 'IRO nella Campagna',
      assignedStakeholders: 'Stakeholder Assegnati',
      completion: 'Completamento',
      proposalsToReview: 'Proposte da Revisionare',
      stakeholder: 'Stakeholder',
      iroProposals: 'Proposte IRO',
      proposeNewIro: 'Proponi Nuovo IRO',
      code: 'Codice',
      name: 'Nome',
      esrsArea: 'Area ESRS',
      type: 'Tipo',
      status: 'Stato',
      actions: 'Azioni',
      impact: 'Impatto',
      risk: 'Rischio',
      opportunity: 'Opportunità',
      assess: 'Valuta',
      view: 'Visualizza',
      date: 'Data',
      description: 'Descrizione',
      rationale: 'Motivazione',
      assignStakeholder: 'Assegna Stakeholder',
      email: 'Email',
      assessmentType: 'Tipo Valutazione',
      progress: 'Progresso',
      noStakeholderAssigned: 'Nessuno stakeholder assegnato',
      financial: 'Finanziario',
      both: 'Entrambi',
      pending: 'In attesa',
      completed: 'Completata',
      noProposals: 'Nessuna proposta da revisionare',
      proposedBy: 'Proposto da',
      suggestedName: 'Nome Suggerito',
      review: 'Revisiona',
      assignTitle: 'Assegna Stakeholder alla Campagna',
      selectUser: 'Seleziona Utente',
      instructions: 'Istruzioni (opzionali)',
      cancel: 'Annulla',
      assign: 'Assegna',
      reviewProposal: 'Revisiona Proposta IRO',
      notes: 'Note (opzionali)',
      reject: 'Respingi',
      approve: 'Approva',
      filterByAssessment: 'Filtra per Valutazioni',
      allIros: 'Tutti gli IRO',
      assessed: 'Valutati',
      notAssessed: 'Non valutati',
      assessments: 'Valutazioni',
      assessedBy: 'Valutato da',
      noAssessments: 'Nessuna valutazione',
      closeAssessment: 'Chiudi Assessment',
      closeAssessmentConfirm: 'Sei sicuro di voler chiudere il tuo assessment? Non potrai più modificare le valutazioni.',
      reopenAssessment: 'Riapri',
      cancelAssessment: 'Annulla',
      assessmentClosed: 'Il tuo assessment è chiuso',
      viewOnly: 'Solo visualizzazione',
      cancelled: 'Annullato',
    },
    iroDetail: {
      backToList: 'Torna alla lista',
      back: 'Indietro',
      iroNotFound: 'IRO non trovato',
      invalidIroId: 'ID IRO non valido',
      edit: 'Modifica',
      submitForValidation: 'Invia per Validazione',
      reject: 'Respingi',
      validate: 'Valida',
      approveMateriality: 'Approva Materialità',
      details: 'Dettagli',
      materialityAssessment: 'Valutazione Materialità',
      multiStakeholder: 'Multi-Stakeholder',
      auditTrail: 'Audit Trail',
      statusDraft: 'Bozza',
      statusInValidation: 'In Validazione',
      statusValidated: 'Validato',
      statusMaterial: 'Materiale',
      statusNotMaterial: 'Non Materiale',
      scale1: '1 - Minimo',
      scale2: '2 - Basso',
      scale3: '3 - Medio',
      scale4: '4 - Alto',
      likelihood1: '1 - Remoto (<1%)',
      likelihood2: '2 - Improbabile (1-10%)',
      likelihood3: '3 - Possibile (10-50%)',
      likelihood4: '4 - Molto Probabile (>50%)',
      rm1: '1 - Iniziale (assenza processi)',
      rm2: '2 - Gestito (processi parziali)',
      rm3: '3 - Ottimizzato (best practice)',
      iroType: 'Tipo IRO',
      esrsArea: 'Area ESRS',
      subTopic: 'Sotto-Topic',
      description: 'Descrizione',
      relatedTopics: 'Topic Correlati',
      impactMateriality: 'Materialità Impatto',
      financialMateriality: 'Materialità Finanziaria',
      score: 'Punteggio',
      assessImpact: 'Valuta Impatto',
      assessFinancial: 'Valuta Finanziario',
      notAssessed: 'Non ancora valutato',
      scale: 'Scala',
      scope: 'Ampiezza',
      irremediability: 'Irrimediabilità',
      probability: 'Probabilità',
      likelihood: 'Probabilità Occorrenza',
      ecoFinancialImpact: 'Impatto Economico-Finanziario',
      reputationalImpact: 'Impatto Reputazionale',
      operationalImpact: 'Impatto Operativo',
      rmMaturityLevel: 'Maturità Risk Management',
      notes: 'Note',
      cancel: 'Annulla',
      save: 'Salva',
      materialityDecision: 'Decisione Materialità',
      material: 'Materiale',
      notMaterial: 'Non Materiale',
      approvingOrgan: 'Organo Approvante',
      rationale: 'Motivazione',
      rejectReason: 'Motivo Respingimento',
      approve: 'Approva',
      macroCategory: 'Macro-categoria',
      macroCategoryNone: 'Non assegnata',
      descriptionLabel: 'Descrizione',
      timeHorizon: 'Orizzonte Temporale',
      shortTerm: 'Breve termine',
      mediumTerm: 'Medio termine',
      longTerm: 'Lungo termine',
      riskType: 'Tipo di Rischio',
      opportunityType: 'Tipo di Opportunità',
      impactNature: 'Natura Impatto',
      actual: 'Attuale',
      potential: 'Potenziale',
      impactDirection: 'Direzione Impatto',
      positive: 'Positivo',
      negative: 'Negativo',
      geographies: 'Geografie',
      valueChain: 'Catena del Valore',
      affectedStakeholders: 'Stakeholder Coinvolti',
      impactMaterialityTitle: 'Materialità di Impatto',
      financialMaterialityTitle: 'Materialità Finanziaria',
      modifyBtn: 'Modifica',
      compileBtn: 'Compila',
      overallScores: 'Punteggi Complessivi',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      overallScore: 'Overall Score',
      materialChip: 'MATERIALE',
      notMaterialChip: 'NON MATERIALE',
      consolidatedScoresTitle: 'Punteggi Consolidati (Multi-Stakeholder)',
      fromAssessments: 'da valutazioni',
      consolidatedOn: 'Consolidato il',
      noConsolidatedScores: 'Nessun punteggio consolidato disponibile. I punteggi verranno calcolati automaticamente quando gli stakeholder completano le loro valutazioni.',
      assessorsConfigured: 'valutatori configurati per questo IRO',
      scoresConsolidatedOn: 'Punteggi consolidati il',
      configure: 'Configura',
      multiStakeholderNotConfigured: 'Valutazione Multi-Stakeholder Non Configurata',
      addAssessorsToEnable: 'Aggiungi valutatori per abilitare la valutazione multi-stakeholder per questo IRO.',
      usePanelToAdd: 'Usa il pannello "Valutatori Configurati" sopra per aggiungere i valutatori.',
      dateTime: 'Data/Ora',
      user: 'Utente',
      action: 'Azione',
      field: 'Campo',
      previousValue: 'Valore Precedente',
      newValue: 'Nuovo Valore',
      noAuditLog: 'Nessuna attività registrata.',
      delete: 'Elimina',
      confirmDelete: 'Conferma Eliminazione',
      deleteConfirmMsg: "Sei sicuro di voler eliminare l'IRO",
      deleteWarning: 'Questa azione non può essere annullata.',
      deleteNonDraftWarning: 'Questo IRO non è in stato bozza. Eliminandolo verranno persi tutti i dati di assessment e validazione associati.',
      adjustedChip: 'Aggiustato',
      adjustScores: 'Aggiusta punteggi',
      removeAdjustment: 'Rimuovi aggiustamento',
      adjustedBy: 'Aggiustato da',
      adjustedAt: 'Aggiustato il',
      adjustmentRationale: 'Motivazione',
      originalScores: 'Punteggi originali',
      adjustmentHistory: 'Storico aggiustamenti',
      removed: 'Rimosso',
      by: 'da',
    },
    dataCapturePanel: {
      csrdDataCollection: 'Raccolta Dati CSRD',
      newDataPoint: 'Nuovo Data Point',
      editDataPoint: 'Modifica Data Point',
      toCompile: 'Da compilare',
      draft: 'Bozza',
      inValidation: 'In validazione',
      validated: 'Validato',
      approved: 'Approvato',
      numeric: 'Quantitativo',
      text: 'Qualitativo',
      boolean: 'Sì/No',
      date: 'Data',
      file: 'File',
      selection: 'Selezione',
      annual: 'Annuale',
      semiAnnual: 'Semestrale',
      quarterly: 'Trimestrale',
      monthly: 'Mensile',
      oneTime: 'Una tantum',
      total: 'Totale',
      completed: 'Completati',
      completion: 'Completamento',
      code: 'Codice',
      name: 'Nome',
      esrs: 'ESRS',
      type: 'Tipo',
      value: 'Valore',
      status: 'Stato',
      actions: 'Azioni',
      rowsPerPage: 'Righe per pagina',
      insert: 'Inserisci',
      insertValue: 'Inserisci valore',
      editValue: 'Modifica valore',
      submitForValidation: 'Invia per validazione',
      validate: 'Valida',
      reject: 'Rifiuta',
      approve: 'Approva',
      editDefinition: 'Modifica definizione',
      delete: 'Elimina',
      save: 'Salva',
      saveValue: 'Salva Valore',
      cancel: 'Annulla',
      search: 'Cerca...',
      all: 'Tutti',
      esrsStandard: 'Standard ESRS',
      none: 'Nessuno',
      description: 'Descrizione',
      esrsDisclosure: 'Disclosure ESRS',
      esrsDisclosurePlaceholder: 'es. E1-6',
      dataType: 'Tipo Dato',
      unit: 'Unità di Misura',
      unitPlaceholder: 'es. tCO2eq, MWh, EUR',
      frequency: 'Frequenza',
      deadline: 'Scadenza',
      dataOwner: 'Data Owner',
      emailDataOwner: 'Email Data Owner',
      required: 'Obbligatorio',
      mandatoryEsrs: 'Mandatory ESRS',
      quantitative: 'Quantitativo',
      notes: 'Note',
      methodology: 'Metodologia di calcolo',
      methodologyHelper: 'Descrivi come è stato calcolato o raccolto questo dato',
      noDataPointFound: 'Nessun data point trovato',
      confirmDelete: 'Sei sicuro di voler eliminare questo data point?',
      rejectReason: 'Motivo del rifiuto:',
      loadError: 'Errore nel caricamento',
      saveError: 'Errore nel salvataggio',
      deleteError: "Errore nell'eliminazione",
      saveValueError: 'Errore nel salvataggio del valore',
      operationError: "Errore nell'operazione",
      yes: 'Sì',
      no: 'No',
      e1: 'E1 - Cambiamento Climatico',
      e2: 'E2 - Inquinamento',
      e3: 'E3 - Risorse Idriche',
      e4: 'E4 - Biodiversità',
      e5: 'E5 - Economia Circolare',
      s1: 'S1 - Forza Lavoro Propria',
      s2: 'S2 - Lavoratori Catena Valore',
      s3: 'S3 - Comunità Interessate',
      s4: 'S4 - Consumatori e Utenti',
      g1: 'G1 - Condotta Aziendale',
      valueLabel: 'Valore',
      dateLabel: 'Data',
    },
    methodologyInfo: {
      valuesTitle: 'Cosa significano i valori',
    },
    methodology: {
      pageTitle: 'Nota Metodologica — Analisi di Doppia Materialità {{year}}',
      exportPdf: 'Esporta PDF',
      generating: 'Generazione...',
      pdfHeaderLabel: 'TEAMSYSTEM S.P.A. — DOCUMENTO INTERNO',
      pdfDocTitle: 'Nota Metodologica\nAnalisi di Doppia Materialità {{year}}',
      pdfFooter: 'TeamSystem S.p.A. · Nota Metodologica DMA {{year}} · Generato il {{date}}',
      pdfFileName: 'nota-metodologica-dma',
      colFunction: 'Funzione',
      colContacts: 'Referenti',
      colTopic: 'TeamSystem Topic',
      colDescription: 'Descrizione',
      s1Title: '1. Introduzione',
      s1p1: 'La presente nota metodologica descrive il processo adottato da TeamSystem S.p.A. (di seguito “TeamSystem”) per l’aggiornamento dell’analisi di doppia materialità (Double Materiality Assessment, DMA) relativa all’esercizio {{year}}.',
      s1p2: 'L’analisi di doppia materialità è stata condotta per la prima volta nel 2024, con il supporto di consulenti esterni (ERM), e ha portato all’identificazione di un insieme strutturato di impatti, rischi e opportunità (di seguito “IRO”) materiali per il Gruppo. Nel 2025, TeamSystem ha internalizzato il processo, affidandolo all’ESG and Impact Team interno sotto la supervisione metodologica di ERM, garantendo così continuità rispetto all’impostazione dell’anno precedente e, al contempo, un progressivo rafforzamento delle competenze interne.',
      s1p3: 'L’obiettivo dell’analisi {{year}} è duplice:',
      s1Bullets: 'aggiornare la valutazione degli IRO già identificati nel 2024, alla luce delle evoluzioni del contesto interno ed esterno;\nintegrare eventuali nuovi impatti, rischi e opportunità emersi nel corso dell’anno.',
      s2Title: '2. Quadro di riferimento normativo e metodologico',
      s2p1: 'L’analisi è condotta in conformità con i requisiti previsti dalla normativa vigente in materia di rendicontazione di sostenibilità, con particolare riferimento a:',
      s2Bullets: 'Decreto Legislativo n. 125 del 6 settembre 2024, che recepisce nell’ordinamento italiano la Direttiva (UE) 2022/2464 (CSRD);\nDirettiva (UE) 2022/2464 del Parlamento Europeo e del Consiglio, relativa alla rendicontazione societaria di sostenibilità;\nRegolamento Delegato (UE) 2023/2772 della Commissione, che integra la Direttiva 2013/34/UE con i principi di rendicontazione di sostenibilità (ESRS);\nEFRAG IG 1: Implementation Guidance sulla valutazione della materialità;\nEFRAG IG 2: Implementation Guidance sulla catena del valore.',
      s3Title: '3. Il principio di Doppia Materialità',
      s3p1: 'Il principio di doppia materialità, introdotto dalla CSRD, prevede che una tematica di sostenibilità possa essere rilevante da una prospettiva di impatto, da una prospettiva finanziaria, o da entrambe:',
      s3ImpactTitle: 'Materialità d’impatto (Inside-out)',
      s3ImpactBody: 'Una tematica è materiale dal punto di vista degli impatti quando riguarda gli effetti effettivi o potenziali, positivi o negativi, che TeamSystem genera sulle persone e/o sull’ambiente nel breve, medio o lungo termine.',
      s3FinancialTitle: 'Materialità finanziaria (Outside-in)',
      s3FinancialBody: 'Una tematica è materiale dal punto di vista finanziario quando genera rischi e/o opportunità che hanno o potrebbero ragionevolmente avere un’influenza materiale sullo sviluppo, sulla posizione finanziaria, sui risultati economici, sui flussi di cassa, sull’accesso ai finanziamenti o sul costo del capitale di TeamSystem.',
      s4Title: '4. Processo di aggiornamento {{year}}',
      s4StartTitle: 'Punto di partenza: la lista IRO 2024',
      s4StartBody: 'Il processo {{year}} è partito dalla lista di IRO identificati e validati nel corso dell’analisi precedente. Questa lista è stata utilizzata come base per la raccolta delle valutazioni aggiornate da parte degli stakeholder interni, garantendo coerenza e comparabilità nel tempo.',
      s4InvolveTitle: 'Coinvolgimento degli stakeholder interni',
      s4InvolveBody: 'Per raccogliere le valutazioni aggiornate e identificare eventuali nuove tematiche, TeamSystem ha coinvolto i responsabili delle principali funzioni aziendali attraverso un processo strutturato di survey. Le funzioni coinvolte sono state:',
      s4Functions: 'Direzione Legale e Compliance\nCyber Security\nProcurement e Supply Chain\nRicerca e Sviluppo (R&D)\nMergers & Acquisitions\nMarketing\nSales e Commerciale\nRisorse Umane\nFacility Management\nHR Internazionale\nDigital Impact',
      s4After1: 'A ciascun referente è stato inviato un questionario strutturato, corredato da materiale informativo di supporto. Per i soggetti che ne hanno fatto richiesta, la compilazione è stata facilitata attraverso un incontro diretto con il team ESG, con l’obiettivo di garantire la qualità e la completezza delle risposte.',
      s4After2: 'Oltre alla valutazione degli IRO di competenza, ai responsabili di funzione è stato chiesto di segnalare eventuali nuove tematiche emerse nel corso del {{year}} e rilevanti per la propria area.',
      s5Title: '5. Struttura e contenuto delle survey',
      s5Intro: 'Le survey sono state strutturate in tre sezioni principali, corrispondenti alle tre tipologie di IRO analizzate.',
      s5ImpactsTitle: 'Impatti',
      s5ImpactsBody: 'Gli impatti rappresentano gli effetti che TeamSystem ha, o potrebbe avere, sulle persone e sull’ambiente. Possono essere effettivi o potenziali, positivi o negativi, e sono collocati lungo la catena del valore (upstream, operations, downstream). Per ciascun impatto, i rispondenti hanno espresso una valutazione numerica su scala 1–4 rispetto ai seguenti criteri:',
      s5ImpactsBullets: 'Scala (Scale): la magnitudine o intensità dell’impatto — quanto è forte l’effetto?\nEstensione (Scope): l’ampiezza dell’effetto — quanti e quali stakeholder sono coinvolti?\nIrrimediabilità (Irremediability): quanto l’impatto e i suoi effetti sono irreversibili e permanenti? (applicabile esclusivamente agli impatti negativi)\nProbabilità (Likelihood): quanto è probabile che l’impatto si manifesti nell’orizzonte temporale di riferimento?',
      s5RisksTitle: 'Rischi',
      s5RisksBody: 'I rischi identificano le tematiche che, dal punto di vista finanziario, reputazionale o operativo, hanno o potrebbero avere effetti significativi su TeamSystem. Per ciascun rischio, i rispondenti hanno espresso una valutazione su scala 1–4 rispetto ai seguenti criteri:',
      s5RisksBullets: 'Impatto Operativo: quanto il tema può influire sui processi, le risorse o le attività operative di TeamSystem?\nImpatto Reputazionale (negativo): quanto può incidere negativamente sulla reputazione, sull’immagine e sulla fiducia degli stakeholder?\nImpatto Economico-Finanziario: quali effetti può avere su ricavi, EBITDA e flussi di cassa? (raccolto, non usato nel punteggio: v. §10)\nProbabilità (Likelihood): quanto è probabile che il rischio si manifesti nell’orizzonte temporale di riferimento?',
      s5OppTitle: 'Opportunità',
      s5OppBody: 'Le opportunità identificano le tematiche che potrebbero generare benefici per TeamSystem dal punto di vista operativo, reputazionale o finanziario. Per ciascuna opportunità, i rispondenti hanno espresso una valutazione su scala 1–4 rispetto ai seguenti criteri:',
      s5OppBullets: 'Impatto Operativo: quanto il tema può generare miglioramenti nei processi, nelle risorse o nelle attività operative di TeamSystem?\nImpatto Reputazionale (positivo): quanto può migliorare la reputazione, l’immagine e la fiducia degli stakeholder?\nImpatto Economico-Finanziario: quali effetti può avere su ricavi, EBITDA e flussi di cassa? (raccolto, non usato nel punteggio: v. §10)\nProbabilità (Likelihood): quanto è probabile che l’opportunità si concretizzi nell’orizzonte temporale di riferimento?',
      s6Title: '6. Calcolo dei punteggi',
      s6AggTitle: 'Aggregazione delle valutazioni',
      s6AggBody: 'Per ciascun IRO valutato da più funzioni, i punteggi sono stati aggregati calcolando, per ogni criterio, la media delle valutazioni ricevute, ponderata per il peso attribuito a ciascun valutatore (a parità di peso coincide con la media aritmetica). Questo approccio garantisce che la valutazione finale rifletta la visione complessiva dell’organizzazione, bilanciando le diverse prospettive funzionali.',
      s6ImpactsTitle: 'Impatti',
      s6ImpactsBody: 'La gravità (severity) è calcolata come media di Scala, Estensione e — per i soli impatti negativi — Irrimediabilità. Il punteggio finale è ottenuto moltiplicando la gravità per la Probabilità. Nel ciclo corrente la probabilità è applicata a tutti gli impatti, effettivi e potenziali, per scelta metodologica (gli ESRS la prevedono per i soli impatti potenziali); la distinzione sarà introdotta nel prossimo ciclo di analisi:',
      s6ImpactsFormula: 'Impact Score = Gravità (media di Scale, Scope, Irremediability) × Likelihood',
      s6RoTitle: 'Rischi e Opportunità',
      s6RoBody: 'Il punteggio è calcolato selezionando il valore più alto tra Impatto Operativo e Impatto Reputazionale, e moltiplicandolo per la Probabilità:',
      s6RoFormula: 'Score = max(Impatto Operativo, Impatto Reputazionale) × Likelihood',
      s6MinMax: 'Il punteggio massimo ottenibile è 16 (4 × 4), mentre il minimo è 1 (1 × 1).',
      s7Title: '7. Definizione della soglia di materialità',
      s7p1: 'Una volta calcolati gli score di tutti gli IRO, vengono fissate due soglie di materialità: una per il punteggio di impatto, applicata agli impatti, e una per il punteggio finanziario, applicata a rischi e opportunità. Ogni IRO è materiale se il suo punteggio raggiunge o supera la soglia del proprio tipo; altrimenti è classificato come non materiale.',
      s7p2: 'Le soglie sono fissate nella configurazione della DMA di ciascun anno, in modo da garantire coerenza con l’analisi dell’anno precedente, pur tenendo conto dell’evoluzione del contesto e della maggiore granularità delle valutazioni {{year}}.',
      s8Title: '8. Aggregazione dei risultati per macrocategoria (TeamSystem Topic) e per standard ESRS',
      s8p1: 'Per offrire una visione aggregata e leggibile dei risultati, gli IRO sono raggruppati in macrocategorie tematiche (TeamSystem Topics), che includono ad esempio: Climate & Energy, Data Privacy and Cybersecurity, Talent Training & Development, ecc. Ogni macrocategoria è rappresentata nella matrice da due valori:',
      s8Bullets: 'il punteggio di impatto più elevato tra gli impatti appartenenti al topic (asse orizzontale);\nil punteggio finanziario più elevato tra i rischi e le opportunità appartenenti al topic (asse verticale).',
      s8Note: 'Per ciascuno standard ESRS è inoltre calcolato un punteggio di sintesi, pari alla somma del punteggio di impatto più elevato e del punteggio finanziario più elevato. Il calcolo considera tutti gli IRO valutati, materiali e non materiali.',
      s9Title: '9. Visualizzazione dei risultati: la matrice di doppia materialità',
      s9p1: 'I risultati dell’analisi sono rappresentati attraverso la matrice di doppia materialità, che posiziona le macrocategorie tematiche lungo due assi:',
      s9Bullets: 'Asse orizzontale — Materialità d’impatto: derivata dagli impatti, considerando il punteggio di impatto più elevato all’interno del topic.\nAsse verticale — Materialità finanziaria: derivata da rischi e opportunità, considerando il punteggio più alto tra i due.',
      s9p2: 'Un tema è materiale se raggiunge o supera almeno una delle due soglie, d’impatto o finanziaria; i temi che le raggiungono entrambe (quadrante in alto a destra) sono considerati prioritari. La matrice consente di identificare visivamente le tematiche di maggiore rilevanza e di comunicarne i risultati in modo immediato agli stakeholder interni ed esterni.',
      s10Title: '10. Aspetto finanziario degli IRO',
      s10p1: 'L’analisi {{year}} non include una valutazione quantitativa esplicita dell’impatto finanziario degli IRO (es. stima in termini di ricavi, costi o valore di mercato). Le survey raccolgono già un indicatore dell’impatto economico-finanziario, su scala 1–4, che però non entra nel calcolo del punteggio: potrà essere progressivamente integrato nelle analisi future, in linea con l’evoluzione dei requisiti normativi e delle best practice di settore.',
      s11Title: '11. Macrocategorie tematiche (TeamSystem Topics)',
      s11p1: 'Di seguito si riportano le macrocategorie tematiche adottate nell’analisi, con la relativa descrizione:',
      s11Descriptions: 'Impatti legati alle condizioni climatiche, alle emissioni di gas serra e ai consumi energetici lungo la catena del valore.\nConsumo idrico nelle operazioni di TeamSystem, incluso quello relativo alla catena del valore upstream.\nPratiche di economia circolare relative alle apparecchiature tecnologiche, per minimizzare la produzione di rifiuti e prolungarne la vita utile.\nSoddisfazione lavorativa complessiva e work-life balance dei dipendenti.\nPratiche di salute e sicurezza per la tutela della salute fisica e mentale dei lavoratori.\nIniziative per garantire diversità, equità e inclusione, tra cui parità di genere e inclusività.\nOpportunità di formazione e sviluppo professionale per i dipendenti.\nRispetto dei diritti umani e del lavoro da parte di fornitori, partner, appaltatori e prestatori di servizi.\nCoinvolgimento e supporto alle comunità locali e relazioni costruttive con le autorità del territorio.\nMisure di protezione dei dati e di cybersecurity che riguardano dipendenti, lavoratori della catena del valore, clienti e utenti software.\nMisure per garantire una rendicontazione chiara, aperta e accessibile a tutti gli stakeholder rilevanti.\nIntegrazione di criteri di sostenibilità nei prodotti e servizi, inclusa l’accessibilità per tutti i consumatori.\nDinamiche organizzative interne e iniziative per garantire trasparenza, accountability e condotta aziendale responsabile.\nPratiche etiche che orientano il comportamento aziendale, inclusa la conformità legale, fiscale e regolamentare.',
    },
    assessmentForm: {
      impactAssessment: 'Valutazione Impatto',
      financialAssessment: 'Valutazione Finanziaria',
      scale: 'Scala',
      scope: 'Ampiezza',
      irremediability: 'Irrimediabilità',
      probability: 'Probabilità',
      likelihood: 'Probabilità Occorrenza',
      ecoFinancialImpact: 'Impatto Economico-Finanziario',
      reputationalImpact: 'Impatto Reputazionale',
      operationalImpact: 'Impatto Operativo',
      notes: 'Note (opzionali)',
      cancel: 'Annulla',
      submitAssessment: 'Invia Valutazione',
      updateAssessment: 'Aggiorna Valutazione',
      deadline: 'Scadenza',
      successMessage: 'Valutazione inviata con successo!',
      impactScore: 'Punteggio Impatto',
      financialScore: 'Punteggio Finanziario',
      myAssessment: 'La Mia Valutazione',
      onlyImpact: 'Solo Impatto',
      onlyFinancial: 'Solo Finanziario',
      both: 'Entrambi',
      statusCompleted: 'Completata',
      statusRevised: 'Revisionata',
      statusInProgress: 'In corso',
      statusCarriedOver: 'Da confermare',
      confirmInherited: 'Conferma',
      inheritedBanner: 'Valutazione ereditata dall\'anno precedente — conferma se va bene così, oppure modifica i valori.',
      deadlinePassed: 'La scadenza è passata',
      scaleLabel: 'Scala: quanto è grave l\'impatto',
      scopeLabel: 'Portata: quanti soggetti/ambiente coinvolto',
      probabilityLabel: 'Probabilità di accadimento',
      ecoFinancialLabel: 'Impatto Eco-Finanziario',
      reputationalLabel: 'Impatto Reputazionale',
      operationalLabel: 'Impatto Operativo',
      calculatedImpactScore: 'Score Impatto Calcolato',
      calculatedFinancialScore: 'Score Finanziario Calcolato',
      reopenIroTitle: 'Riaprire IRO?',
      reopenIroMessage: 'Questo IRO è già stato finalizzato. Vuoi riaprirlo per aggiungere una nuova valutazione? Questa azione verrà registrata nell\'audit trail.',
      reopenConfirm: 'Sì, riapri e salva',
      notApplicable: 'N/A',
      scale1: '1 - Minimo',
      scale2: '2 - Basso',
      scale3: '3 - Medio',
      scale4: '4 - Alto',
      likelihood1: '1 - Remoto (<1%)',
      likelihood2: '2 - Improbabile (1-10%)',
      likelihood3: '3 - Possibile (10-50%)',
      likelihood4: '4 - Molto Probabile (>50%)',
    },
    matrix: {
      title: 'Materialità',
      year: 'Anno',
      consolidateScores: 'Consolida punteggi',
      consolidateConfirmTitle: 'Consolida punteggi IRO',
      consolidateConfirmMsg: 'Ricalcola i punteggi di tutti gli IRO a partire dagli assessment stakeholder e applica le soglie di materialità. Continuare?',
      consolidating: 'Consolidamento in corso...',
      saveThresholds: 'Salva materialità',
      refresh: 'Aggiorna',
      cancel: 'Annulla',
      thresholdConfig: 'Configurazione Soglie di Materialità',
      impactThreshold: 'Soglia Impact Score (Impatti)',
      financialThreshold: 'Soglia Financial Score (Rischi e Opportunità)',
      macroAreaTitle: 'Aggregazione per Macro-area ESRS',
      esrs: 'ESRS',
      name: 'Nome',
      maxImpact: 'Max Impact',
      maxFinancial: 'Max Financial',
      macroScore: 'Macro Score',
      material: 'Materiale?',
      materialIROs: 'IRO Materiali',
      nonMaterialIROs: 'IRO Non Materiali',
      code: 'Codice',
      iroName: 'Nome',
      type: 'Tipo',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      assessed: 'Valutati',
      materialLabel: 'Materiali',
      nonMaterialLabel: 'Non Materiali',
      noAssessment: 'Senza Assessment',
      noData: 'Nessun dato disponibile',
      thresholdsSaved: 'Soglie salvate con successo',
      macroCategoryTitle: 'Aggregazione per Macro-categoria',
      category: 'Categoria',
      nIRO: 'N. IRO',
      tabESRS: 'Per ESRS',
      tabMacroCategory: 'Per Macro-categoria',
      forceMaterial: 'Forza Materiale',
      forceNonMaterial: 'Forza Non Materiale',
      forceConfirmTitle: 'Forza decisione materialità',
      forceConfirmMaterial: 'Vuoi forzare questo IRO come MATERIALE? Questa azione sovrascrive il risultato del calcolo automatico.',
      forceConfirmNonMaterial: 'Vuoi forzare questo IRO come NON MATERIALE? Questa azione sovrascrive il risultato del calcolo automatico.',
      confirm: 'Conferma',
      forced: 'Forzato',
      dotDetailTitle: 'IRO Materiali',
      impacts: 'Impatti',
      risks: 'Rischi',
      opportunities: 'Opportunità',
      score: 'Score',
      close: 'Chiudi',
      noMaterialIRO: 'Nessun IRO materiale',
      typeImpact: 'Impatto',
      typeRisk: 'Rischio',
      typeOpportunity: 'Opportunità',
      invalidThresholds: 'Valori soglia non validi',
      tabAnalysis: 'Analisi',
      tabPrevYearComparison: 'Confronto Anno Precedente',
      tabNewIros: 'Nuovi IRO',
      tabScoreRedistribution: 'Ridistribuzione Punteggi',
      tabMethodology: 'Metodologia',
      materialityMatrix: 'Matrice di Materialità',
      topic: 'topic',
      topics: 'topic',
      smaller: 'Riduci',
      larger: 'Ingrandisci',
      macroCategories: 'Macro-categorie',
      newBadge: 'Nuovo',
      openFullDetail: 'Apri scheda completa',
    },
    assessmentDialog: {
      assessIRO: 'Valuta IRO',
      assessmentDetails: 'Dettaglio Assessment',
      loading: 'Caricamento...',
      errorLoading: 'Errore nel caricamento dell\'IRO',
      retry: 'Riprova',
      skipIRO: 'Salta IRO',
      skipConfirm: 'Sei sicuro di voler saltare questo IRO? Non potrai più valutarlo in questa campagna.',
      skipping: 'Salto in corso...',
      assessor: 'Valutatore',
      impactScore: 'Score Impatto',
      financialScore: 'Score Finanziario',
      submittedAt: 'Inviato il',
      status: 'Stato',
      pending: 'In attesa',
      completed: 'Completato',
      iroReference: 'IRO di riferimento',
      assessmentType: 'Tipo Valutazione',
      impact: 'Impatto',
      financial: 'Finanziario',
      both: 'Entrambi',
      notYetAssessed: 'Non ancora valutato',
      fillAssessment: 'Compila Valutazione',
      you: 'Tu',
      close: 'Chiudi',
    },
    quickAdd: {
      title: 'Aggiungi Valutazione Rapida',
      step1: 'Seleziona IRO',
      step2: 'Compila Valutazione',
      searchExisting: 'Cerca esistente',
      createNew: 'Crea nuovo',
      searchPlaceholder: 'Cerca per nome o codice IRO...',
      noOptions: 'Nessun IRO trovato',
      loading: 'Caricamento...',
      name: 'Nome',
      type: 'Tipo',
      esrsStandard: 'Standard ESRS',
      description: 'Descrizione (opzionale)',
      impact: 'Impatto',
      risk: 'Rischio',
      opportunity: 'Opportunità',
      impactDirection: 'Direzione Impatto',
      impactNature: 'Natura Impatto',
      positive: 'Positivo',
      negative: 'Negativo',
      actual: 'Attuale',
      potential: 'Potenziale',
      riskType: 'Tipo Rischio',
      physical: 'Fisico',
      transition: 'Transizione',
      systemic: 'Sistemico',
      opportunityType: 'Tipo Opportunità',
      resourceEfficiency: 'Efficienza Risorse',
      productsServices: 'Prodotti e Servizi',
      markets: 'Mercati',
      resilience: 'Resilienza',
      reputation: 'Reputazione',
      next: 'Avanti',
      back: 'Indietro',
      cancel: 'Annulla',
      forAssessor: 'Per conto di',
      creatingIro: 'Creazione IRO in corso...',
      requiredField: 'Campo obbligatorio',
    },
    page: {
      iroCatalog: 'Catalogo IRO',
      year: 'Anno',
      stakeholderAssessment: 'Assessment Stakeholder',
      activeCampaigns: 'Campagne di Assessment Attive',
      assignedAssessments: 'Valutazioni IRO Assegnate',
      assessmentCampaigns: 'Campagne di Assessment',
      proposeNewIro: 'Proponi Nuovo IRO',
      materialityMatrix: 'Matrice di Materialità',
      dmaSetup: 'Setup DMA',
      editSetup: 'Modifica Setup',
      createSetup: 'Crea Setup',
      createNewSetup: 'Crea Nuovo Setup',
      noSetupConfigured: 'Nessun setup configurato per l\'anno',
      configCompleteness: 'Completezza Configurazione',
      groupCompanies: 'Società del Gruppo',
      activeGeographies: 'Geografie Attive',
      valueChain: 'Catena del Valore',
      stakeholderCategories: 'Categorie Stakeholder',
      naceCodes: 'Codici NACE',
      materialityThresholds: 'Soglie di Materialità',
      impactScoreThreshold: 'Soglia Impact Score',
      financialScoreThreshold: 'Soglia Financial Score',
      noSetupWarning: 'Nessun setup DMA configurato per l\'anno {year}. Contatta l\'amministratore per configurare il perimetro.',
      impact: 'Impatto',
      financial: 'Finanziario',
      both: 'Entrambi',
      deadline: 'Scadenza',
      companies: 'Società',
      geographies: 'Geografie',
      stakeholders: 'Stakeholder',
      prepareAssessment: 'Prepara Assessment',
      noAssessmentsAssigned: 'Nessuna valutazione assegnata',
      contactAdminAssignment: 'Contatta l\'amministratore per ricevere un\'assegnazione.',
    },
    tabImageBanner: {
      explanatoryInfographic: 'Infografica esplicativa',
      uploadLandscapeImage: 'Carica immagine landscape',
      clickOrDrag: 'Clicca o trascina qui',
      uploadFailed: 'Caricamento immagine non riuscito',
      removeFailed: 'Rimozione immagine non riuscita',
    },
    matrixIcons: {
      overlapping: '{{count}} sovrapposti — clicca per esplorare',
    },
    scoreAdjustment: {
      title: 'Aggiusta Punteggi',
      originalScores: 'Punteggi Originali',
      newScores: 'Nuovi Punteggi',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      rationale: 'Motivazione (opzionale)',
      cancel: 'Annulla',
      save: 'Salva Aggiustamento',
      noChange: 'Almeno un punteggio deve differire dall\'originale',
      enterValidScore: 'Inserire almeno un punteggio valido',
    },
    comparisonPanel: {
      comparison: 'Confronto',
      othersAverage: 'Media altri valutatori',
      previousYear: 'Anno Precedente',
      myPreviousYear: 'Mia valutazione',
      impactScore: 'Impatto',
      financialScore: 'Finanziario',
      noOtherAssessments: 'Nessun altro valutatore',
      noPreviousYear: 'Nessun dato anno precedente',
      assessors: 'valutatori',
    },
    cardFlow: {
      assessmentCardFlow: 'Flusso Valutazione',
      of: 'di',
      progress: 'Progresso',
      completed: 'completati',
      prev: 'Precedente',
      next: 'Successivo',
      skip: 'Salta',
      saveAndContinue: 'Salva e Continua',
      confirmAndSubmitAll: 'Conferma e Invia Tutti',
      close: 'Chiudi',
      loading: 'Caricamento...',
      errorLoading: 'Errore nel caricamento',
      allCompleted: 'Tutti gli assessment sono stati completati!',
      submitSuccess: 'Tutti gli assessment sono stati inviati con successo!',
      onBehalfOf: 'Per conto di',
      comparison: 'Confronto',
      iroCompleted: 'Assessment completato per questo IRO',
    },
    campaignIros: {
      iroCode: 'Codice IRO',
      iroName: 'Nome IRO',
      esrsArea: 'Area ESRS',
      assessmentType: 'Tipo',
      impactScore: 'Score Impatto',
      financialScore: 'Score Finanziario',
      status: 'Stato',
      assessor: 'Valutatore',
      pending: 'In attesa',
      completed: 'Completata',
      skipped: 'Saltato',
      impact: 'Impatto',
      financial: 'Finanziario',
      both: 'Entrambi',
      noIros: 'Nessun IRO in questa campagna',
      loadingError: 'Errore nel caricamento dei dati',
      progress: 'Progresso',
    },
    cloneYear: {
      cloneYear: 'Clona Anno',
      sourceYear: 'Anno Sorgente',
      targetYear: 'Anno Destinazione',
      selectData: 'Seleziona i dati da copiare',
      dmaSetup: 'Configurazione DMA',
      dmaSetupDesc: 'Perimetro, paesi, value chain, stakeholder categories',
      iros: 'Catalogo IRO',
      irosDesc: 'Tutti gli IRO dell\'anno',
      assessments: 'Copia anche le valutazioni',
      assessmentsDesc: 'Mantiene i punteggi di materialità degli IRO (altrimenti il nuovo anno parte da rivalutare). Richiede il Catalogo IRO.',
      campaigns: 'Campagne Assessment',
      campaignsDesc: 'Struttura campagne (senza valutazioni)',
      documents: 'Biblioteca Documenti',
      documentsDesc: 'Copia i documenti della Libreria nel nuovo anno (marcati "da rivedere")',
      externalStakeholders: 'Stakeholder Esterni',
      externalStakeholdersDesc: 'Globali, non legati all\'anno',
      internalStakeholders: 'Stakeholder Interni',
      internalStakeholdersDesc: 'Organi ESG (globali)',
      clone: 'Clona',
      cancel: 'Annulla',
      cloning: 'Clonazione in corso...',
      alwaysIncluded: 'Sempre incluso',
      globalData: 'Dati globali',
      success: 'Clonazione completata',
      done: 'Fatto',
      skippedTitle: 'Alcuni IRO non sono stati clonati perché incompleti:',
      skippedHint: 'Completa i campi mancanti su questi IRO nell\'anno di origine e riprova, se vuoi includerli.',
    },
    assessorConfig: {
      configuredAssessors: 'Valutatori Configurati',
      addAssessor: 'Aggiungi Valutatore',
      assessor: 'Valutatore',
      assessmentType: 'Tipo Valutazione',
      weight: 'Peso',
      normalizedWeight: 'Peso Normalizzato',
      assignmentDate: 'Data Assegnazione',
      actions: 'Azioni',
      edit: 'Modifica',
      remove: 'Rimuovi',
      assessors: 'valutatori',
      totalWeight: 'Peso totale',
      deadline: 'Scadenza',
      noAssessorsConfigured: 'Nessun valutatore configurato. Aggiungi valutatori per abilitare la valutazione multi-stakeholder.',
      editAssessor: 'Modifica Valutatore',
      selectUser: 'Seleziona Utente',
      impactOnly: 'Solo Impatto',
      financialOnly: 'Solo Finanziario',
      both: 'Entrambi',
      weightDescription: 'Il peso determina l\'importanza relativa della valutazione di questo stakeholder nel calcolo della media ponderata.',
      cancel: 'Annulla',
      save: 'Salva',
      add: 'Aggiungi',
      confirmRemoveAssessor: 'Sei sicuro di voler rimuovere questo valutatore?',
    },
    esgOrgan: {
      internalStakeholders: 'Stakeholder Interni (Organi ESG)',
      addOrgan: 'Aggiungi Organo',
      editOrgan: 'Modifica Organo',
      name: 'Nome',
      type: 'Tipo',
      description: 'Descrizione',
      members: 'Membri',
      status: 'Stato',
      meetingFrequency: 'Frequenza Riunioni',
      actions: 'Azioni',
      save: 'Salva',
      cancel: 'Annulla',
      delete: 'Elimina',
      confirmDelete: 'Sei sicuro di voler eliminare questo organo?',
      noOrgans: 'Nessun organo ESG configurato',
      manageMembers: 'Gestisci Membri',
      addMember: 'Aggiungi Membro',
      role: 'Ruolo',
      title: 'Titolo',
      activeMembers: 'Membri Attivi',
      collapseOrgan: 'Comprimi organo',
      expandOrgan: 'Espandi organo',
      deleteOrgan: 'Elimina organo',
    },
    newIros: {
      title: 'Nuovi IRO rispetto al 2025',
      subtitle: 'Impatti, rischi e opportunità che sono stati aggiunti quest\'anno e non erano presenti nella DMA 2025.',
      impacts: 'Impatti',
      risks: 'Rischi',
      opportunities: 'Opportunità',
      name: 'Nome',
      code: 'Codice',
      type: 'Tipo',
      noNew: 'Nessun nuovo IRO rispetto al 2025.',
      total: 'Totale nuovi IRO',
      material: 'Materiale',
      nonMaterial: 'Non Materiale',
    },
    yearComparison: {
      title: 'Confronto Matrici per Macro-categoria',
      prevYear: 'Anno di Confronto ({{year}})',
      currYear: 'Anno Corrente ({{year}})',
      compareWith: 'Confronta con anno',
      fromSystem: 'Anno di confronto (dal sistema)',
      manual: 'Inserimento manuale',
      addRow: 'Aggiungi',
      confirm: 'Conferma',
      edit: 'Modifica',
      name: 'Macro-categoria',
      delta: "Variazioni rispetto all'anno di confronto",
      noData: 'Nessun dato',
      noChanges: 'Nessuna variazione',
      newInMatrix: 'Nuove nella matrice',
      removed: 'Rimosse dalla matrice',
      matrixAria: 'Matrice di materialità {{title}}',
    },
    stakeholderManager: {
      externalStakeholders: 'Stakeholder Esterni',
      addStakeholder: 'Aggiungi Stakeholder',
      editStakeholder: 'Modifica Stakeholder',
      name: 'Nome',
      category: 'Categoria',
      description: 'Descrizione',
      phone: 'Telefono',
      address: 'Indirizzo',
      influenceLevel: 'Livello Influenza',
      dependencyLevel: 'Livello Dipendenza',
      priorityScore: 'Score Priorità',
      actions: 'Azioni',
      save: 'Salva',
      cancel: 'Annulla',
      delete: 'Elimina',
      confirmDelete: 'Sei sicuro di voler eliminare questo stakeholder?',
      noStakeholders: 'Nessuno stakeholder configurato',
      filterByCategory: 'Filtra per categoria',
      allCategories: 'Tutte le categorie',
    },
    dmaSettings: {
      settings: 'Impostazioni Anno',
      year: 'Anno',
      externalStakeholders: 'Stakeholder Esterni',
      countries: 'Paesi',
      internalStakeholders: 'Stakeholder Interni',
      macroCategories: 'Macro-Categorie',
      cloneYear: 'Clona Anno',
      currentYear: 'Anno Corrente',
      workingYear: 'Anno di Lavoro',
      startNewYear: 'Avvia Nuovo Anno',
      newYear: 'Nuovo Anno',
      cloneFromCurrent: 'Clona configurazione dall\'anno corrente',
      cloneDesc: 'Copia framework, template, filtro DMA e ruoli assegnati. I dati delle campagne NON vengono copiati.',
      create: 'Crea',
      cancel: 'Annulla',
      activeCountries: 'Paesi Attivi',
      selectCountries: 'Seleziona i paesi attivi',
      save: 'Salva',
      noSetupForYear: 'Nessun setup configurato per questo anno',
      createSetup: 'Crea Setup',
      yearCreated: 'Anno creato con successo',
      countriesSaved: 'Paesi salvati con successo',
      addCategory: 'Aggiungi Categoria',
      order: 'Ordine',
      code: 'Codice',
      nameIT: 'Nome (IT)',
      nameEN: 'Nome (EN)',
      actions: 'Azioni',
      editCategory: 'Modifica Categoria',
      deleteCategory: 'Elimina Categoria',
      confirmDelete: 'Sei sicuro di voler eliminare questa macro-categoria?',
      categoryDeleted: 'Categoria eliminata',
      categorySaved: 'Categoria salvata',
      noCategories: 'Nessuna macro-categoria configurata',
      default: 'Default',
      custom: 'Custom',
      delete: 'Elimina',
      yearLifecycle: {
        title: 'Archivia ed elimina anni',
        description: 'Archivia un anno per nasconderlo dai menu mantenendone i dati (reversibile). Solo un anno archiviato può essere eliminato definitivamente dal database.',
        statusActive: 'Attivo',
        statusArchived: 'Archiviato',
        archive: 'Archivia',
        restore: 'Ripristina',
        deletePermanently: 'Elimina definitivamente',
        cannotArchiveActive: "Non puoi archiviare l'anno di lavoro attualmente selezionato",
        noYears: 'Nessun anno disponibile',
        archived: 'Anno {{year}} archiviato',
        restored: 'Anno {{year}} ripristinato',
        deleted: 'Anno {{year}} eliminato definitivamente',
        archiveConfirmTitle: "Archiviare l'anno {{year}}?",
        archiveConfirmText: "L'anno verrà nascosto dai menu ma i suoi dati resteranno nel database. Potrai ripristinarlo in qualsiasi momento.",
        deleteTitle: "Eliminare definitivamente l'anno {{year}}?",
        deletePreviewIntro: 'Verranno eliminati definitivamente dal database:',
        deletePreviewEmpty: 'Questo anno non contiene dati: verrà semplicemente rimosso dall\'elenco.',
        deletePreviewTotal: 'Totale elementi',
        deleteWarningIrreversible: "Questa operazione è irreversibile: i dati non potranno essere recuperati.",
        continue: 'Continua',
        deleteConfirmInstruction: "Per confermare, digita l'anno ({{year}}) qui sotto:",
        typeYearPlaceholder: 'Digita {{year}}',
        entities: {
          iros: 'Valutazioni IRO',
          campaigns: 'Campagne di raccolta dati',
          entries: 'Dati compilati',
          consolidations: 'Consolidamenti per paese',
          datapoints: 'Datapoint definiti',
          assignments: 'Assegnazioni datapoint',
          materialityMatrix: 'Matrice di materialità',
          iroAssessments: 'Valutazioni di materialità',
          macroCategories: 'Macro-categorie',
          macroCategoryScores: 'Punteggi macro-categoria',
          engagementCampaigns: 'Campagne di engagement',
          dmaProcesses: 'Processi DMA',
          hrImports: 'Import dati HR',
          dmaSetup: 'Configurazione DMA (perimetro)',
          yearConfig: 'Configurazione anno (raccolta dati)',
          reportingConfig: 'Configurazione reporting',
          consolidatedData: 'Dati consolidati di reporting',
          reportSections: 'Sezioni di report',
          reportingAssignments: 'Assegnazioni di reporting',
          countryProfiles: 'Profili paese',
          legalReviews: 'Revisioni legali',
        },
      },
    },
    iroDetailDialog: {
      close: 'Chiudi',
      description: 'Descrizione',
      macroCategory: 'Macro-categoria',
      timeHorizon: 'Orizzonte temporale',
      consolidatedScores: 'Punteggi Consolidati',
      consolidatedAt: 'Consolidato il',
      noConsolidated: 'Nessun punteggio consolidato',
      stakeholderAssessments: 'Valutazioni Stakeholder',
      assessor: 'Assessore',
      weight: 'Peso',
      status: 'Stato',
      completed: 'completate',
      noAssessments: 'Nessuna valutazione',
      yearComparison: 'Confronto Anno Precedente',
      year: 'Anno',
      noPrevYear: 'Nessun dato anno precedente',
      typeImpact: 'Impatto',
      typeRisk: 'Rischio',
      typeOpportunity: 'Opportunità',
      horizonShort: 'Breve',
      horizonMedium: 'Medio',
      horizonLong: 'Lungo',
      statusPending: 'In attesa',
      statusCompleted: 'Completata',
      statusRevised: 'Revisionata',
      statusSkipped: 'Saltata',
      with: 'con',
      openFullDetail: 'Apri scheda completa',
      loadFailed: 'Caricamento dettagli IRO non riuscito',
    },
    matrixV2: {
      materialityMatrix: 'Matrice di Materialità',
      thresholds: 'Soglie',
      refresh: 'Aggiorna',
      esrsStandard: 'Standard ESRS',
      type: 'Tipo',
      all: 'Tutti',
      impact: 'Impatto',
      risk: 'Rischio',
      opportunity: 'Opportunità',
      configureThresholds: 'Configura Soglie di Materialità',
      impactScoreThreshold: 'Soglia Impact Score',
      financialScoreThreshold: 'Soglia Financial Score',
      save: 'Salva',
      material: 'Materiali',
      watchList: 'Watch List',
      lowPriority: 'Bassa Priorità',
      totalIro: 'Totale IRO',
      financialMaterialityAxis: 'FINANCIAL MATERIALITY (OUTSIDE-IN)',
      impactMaterialityAxis: 'IMPACT MATERIALITY (INSIDE-OUT)',
      impactLabel: 'Impatto',
      financialLabel: 'Finanziario',
      materialLabel: 'MATERIALE',
      topicsScoredBy: '{{count}} topic valutati per impatto e rilevanza finanziaria',
      byEsrsStandard: 'Per Standard ESRS',
      byType: 'Per Tipo',
      byGeography: 'Per Geografia',
      mat: 'mat.',
      chartAria: 'Matrice di doppia materialità: distribuzione IRO per Impatto e Rilevanza Finanziaria',
    },
    campaignManager: {
      assessmentCampaigns: 'Campagne di Assessment',
      year: 'Anno',
      newCampaign: 'Nuova Campagna',
      totalCampaigns: 'Totale Campagne',
      active: 'Attive',
      pendingProposals: 'Proposte in Attesa',
      completed: 'Completate',
      campaignName: 'Nome Campagna',
      status: 'Stato',
      assignments: 'Assegnazioni',
      progress: 'Progresso',
      deadline: 'Scadenza',
      proposals: 'Proposte',
      actions: 'Azioni',
      noCampaigns: 'Nessuna campagna creata per l\'anno',
      viewDetails: 'Visualizza Dettagli',
      startCampaign: 'Avvia Campagna',
      completeCampaign: 'Completa Campagna',
      cancelCampaign: 'Annulla Campagna',
      newAssessmentCampaign: 'Nuova Campagna di Assessment',
      description: 'Descrizione',
      startDate: 'Data Inizio',
      endDate: 'Data Fine',
      selectIros: 'Seleziona IRO da includere',
      selected: 'selezionati',
      code: 'Codice',
      name: 'Nome',
      esrsArea: 'Area ESRS',
      cancel: 'Annulla',
      createCampaign: 'Crea Campagna',
      nameAndIroRequired: 'Nome e almeno un IRO sono richiesti',
      expired: 'Scaduta',
      openInNewTab: 'Apri in nuova scheda',
      statusDraft: 'Bozza',
      statusActive: 'Attiva',
      statusCompleted: 'Completata',
      statusCancelled: 'Annullata',
    },
    proposeIro: {
      proposalSent: 'Proposta Inviata',
      proposalSentDesc: 'La tua proposta di IRO è stata inviata al team ESG per la revisione. Riceverai una notifica quando sarà approvata o rifiutata.',
      backToList: 'Torna alla Lista',
      proposeNewIro: 'Proponi Nuovo IRO',
      infoBanner: 'Proponi un IRO (Impatto, Rischio, Opportunità) che ritieni rilevante per l\'azienda. La tua proposta sarà revisionata dal team ESG.',
      esrsArea: 'Area ESRS',
      type: 'Tipo',
      iroName: 'Nome IRO',
      iroNamePlaceholder: 'es. Emissioni GHG Scope 1 e 2',
      description: 'Descrizione',
      descriptionPlaceholder: 'Descrivi l\'IRO in dettaglio...',
      esrsTopicOptional: 'Topic ESRS (opzionale)',
      esrsTopicPlaceholder: 'es. Mitigazione del cambiamento climatico',
      impactNature: 'Natura Impatto',
      impactDirection: 'Direzione Impatto',
      timeHorizon: 'Orizzonte Temporale',
      valueChainPosition: 'Posizione nella Catena del Valore',
      rationale: 'Motivazione',
      rationalePlaceholder: 'Perché ritieni che questo IRO sia rilevante per l\'azienda?',
      cancel: 'Annulla',
      submitProposal: 'Invia Proposta',
      requiredFields: 'Compila tutti i campi obbligatori',
      typeImpact: 'Impatto',
      typeRisk: 'Rischio',
      typeOpportunity: 'Opportunità',
      natureActual: 'Attuale',
      naturePotential: 'Potenziale',
      directionNegative: 'Negativo',
      directionPositive: 'Positivo',
      horizonShort: 'Breve termine (<1 anno)',
      horizonMedium: 'Medio termine (1-5 anni)',
      horizonLong: 'Lungo termine (>5 anni)',
      vcUpstream: 'Upstream (Fornitori)',
      vcOperations: 'Operations (Attività proprie)',
      vcDownstream: 'Downstream (Clienti/Utenti)',
    },
    scoreRedistribution: {
      currentMaterial: 'Materiali attuali',
      proposedMaterial: 'Materiali proposti',
      adjustments: 'Aggiustamenti',
      willLose: 'Perderanno materialità',
      currentMatrix: 'Matrice Attuale',
      proposedMatrix: 'Matrice Proposta',
      code: 'Codice',
      name: 'Nome',
      type: 'Tipo',
      currentScore: 'Score Attuale',
      proposedScore: 'Score Proposto',
      materialStatus: 'Materialità',
      readOnlyNote: 'Questa vista è di sola consultazione. Nessuna modifica viene applicata ai dati.',
      close: 'Chiudi',
      adjusted: 'Modificato',
      typeImpact: 'Impatto',
      typeRisk: 'Rischio',
      typeOpportunity: 'Opportunità',
      stays: 'Resta',
      loses: 'Perde',
      gains: 'Guadagna',
      notMat: 'Non mat.',
      proposedView: 'Vista proposta',
      noIrosInCategory: 'Nessun IRO in questa categoria',
      yes: 'Sì',
      no: 'No',
      matrixAria: 'Matrice di ridistribuzione punteggi per macro-categoria',
    },
    iroForm: {
      back: 'Indietro',
      newIRO: 'Nuovo IRO',
      editIRO: 'Modifica IRO',
      basicInfo: 'Informazioni Base',
      nameLabel: 'Nome',
      descriptionLabel: 'Descrizione',
      classification: 'Classificazione',
      type: 'Tipo',
      typeImpact: 'Impatto',
      typeRisk: 'Rischio',
      typeOpportunity: 'Opportunità',
      esrsSubTopic: 'Sub-topic ESRS',
      esrsSubTopicPlaceholder: 'es. Climate Change Mitigation',
      macroCategory: 'Macro-categoria',
      macroCategoryNone: 'Nessuna',
      timeHorizon: 'Orizzonte Temporale',
      impactNature: 'Natura Impatto',
      impactNatureActual: 'Attuale',
      impactNaturePotential: 'Potenziale',
      impactDirection: 'Direzione Impatto',
      impactDirectionPositive: 'Positivo',
      impactDirectionNegative: 'Negativo',
      scope: 'Ambito di Applicazione',
      geographies: 'Geografie',
      valueChainPositions: 'Posizioni Catena del Valore',
      affectedStakeholders: 'Stakeholder Coinvolti',
      internalStakeholderAssignment: 'Assegnazione Stakeholder Interni',
      assignedStakeholders: 'Stakeholder Interni Assegnati',
      assignedStakeholdersPlaceholder: 'Seleziona utenti per la valutazione...',
      assignedStakeholdersHelper: 'Gli stakeholder selezionati potranno valutare questo IRO',
      cancel: 'Annulla',
      saveChanges: 'Salva Modifiche',
      createIRO: 'Crea IRO',
      noUsersFound: 'Nessun utente trovato',
      loadingUsers: 'Caricamento utenti...',
      errorSaving: 'Errore durante il salvataggio',
      nameRequired: 'Il nome è obbligatorio',
      descriptionRequired: 'La descrizione è obbligatoria',
      selectAtLeastOneGeography: 'Seleziona almeno una geografia',
      selectAtLeastOneValueChain: 'Seleziona almeno una posizione nella catena del valore',
      selectAtLeastOneStakeholder: 'Seleziona almeno uno stakeholder',
      selectImpactNature: 'Seleziona la natura dell\'impatto',
      selectImpactDirection: 'Seleziona la direzione dell\'impatto',
      riskType: 'Tipo di Rischio',
      selectRiskType: 'Seleziona il tipo di rischio',
      opportunityType: 'Tipo di Opportunità',
      selectOpportunityType: 'Seleziona il tipo di opportunità',
    },
    iroRegistry: {
      type: 'Tipo',
      nameAndDescription: 'Nome / Descrizione',
      macroCategory: 'Macro-categoria',
      actions: 'Azioni',
      createIROIn: 'Crea IRO in',
      view: 'Visualizza',
      edit: 'Modifica',
      delete: 'Elimina',
      duplicate: 'Duplica',
      submitForValidation: 'Invia per Validazione',
      validate: 'Valida',
      confirmDelete: 'Conferma Eliminazione',
      deleteConfirmMsg: 'Sei sicuro di voler eliminare l\'IRO',
      deleteWarning: 'Questa azione non può essere annullata.',
      cancel: 'Annulla',
      export: 'Esporta',
      newIRO: 'Nuovo IRO',
      searchPlaceholder: 'Cerca per nome o descrizione...',
      all: 'Tutti',
      status: 'Stato',
      refresh: 'Aggiorna',
      totalIRO: 'IRO totali',
      noIROFound: 'Nessun IRO trovato',
      noIROInCategory: 'Nessun IRO in questa categoria',
      esrsView: 'Per ESRS',
      macroThemeView: 'Per Macro Categorie TeamSystem',
      uncategorized: 'Non categorizzati',
      iroCatalog: 'Catalogo IRO',
      deleteNonDraftWarning: 'Questo IRO non è in stato bozza. Eliminandolo verranno persi tutti i dati di assessment e validazione associati.',
      deleteSelected: 'Elimina selezionati',
      bulkDeleteConfirmMsg: 'Sei sicuro di voler eliminare gli IRO selezionati?',
      bulkDeleteCount: '{{count}} IRO selezionati',
      date: 'Data',
      assessmentStatus: 'Stato',
      noAssessments: 'Nessuna valutazione stakeholder',
      loadingAssessments: 'Caricamento valutazioni...',
      materiality: 'Materialità',
      materialLabel: 'Materiale',
      nonMaterialLabel: 'Non Materiale',
      adjustment: 'Aggiustamento',
      withAdjustment: 'Con aggiustamento',
      withoutAdjustment: 'Senza aggiustamento',
      adjustScores: 'Aggiusta punteggi',
      removeAdjustment: 'Rimuovi aggiustamento',
      openInNewTab: 'Apri in nuova scheda',
      original: 'Originale',
      adjusted: 'Aggiustato',
      clickForAssessmentDetail: 'Clicca per dettaglio assessment',
      viewIROAria: 'Visualizza IRO',
      editIROAria: 'Modifica IRO',
      deleteIROAria: 'Elimina IRO',
      duplicateIROAria: 'Duplica IRO',
      moreOptionsAria: 'Altre opzioni',
      loadError: 'Errore nel caricamento degli IRO',
    },
    myAssessments: {
      pendingAssessments: 'Assessment in Attesa',
      pendingAssessmentsDesc: 'IRO assegnati in attesa della tua valutazione',
      startAssessment: 'Inizia Assessment',
      pendingStatus: 'In Attesa',
      noAssessments: 'Nessuna valutazione assegnata',
      noAssessmentsDesc: 'Al momento non ci sono valutazioni assegnate a te. Quando ti verranno affidate delle valutazioni le troverai qui e riceverai una notifica.',
      noAssessmentsAdmin: 'Nessun assessment trovato per l\'anno corrente.',
      totalAssessments: 'Totale Assessment',
      completed: 'Completati',
      filterByEsrs: 'Filtra per Area ESRS',
      allAreas: 'Tutte le aree',
      filterByStatus: 'Filtra per Stato',
      allStatuses: 'Tutti gli stati',
      completedStatus: 'Completato',
      revisedStatus: 'Revisionato',
      toConfirmStatus: 'Da confermare',
      confirmAllButton: 'Conferma tutti',
      sendToStakeholder: 'Invia allo stakeholder',
      sentToStakeholder: 'Inviata',
      errorSending: 'Errore durante l\'invio',
      iroCode: 'Codice IRO',
      iroName: 'Nome IRO',
      esrsArea: 'Area ESRS',
      assessmentType: 'Tipo',
      status: 'Stato',
      impact: 'Impatto',
      financial: 'Finanziario',
      both: 'Entrambi',
      noMatchesFilter: 'Nessun assessment corrisponde ai filtri selezionati',
      viewAllAssessments: 'Visualizza tutti gli assessment',
      assessor: 'Valutatore',
      allStakeholders: 'Tutti gli stakeholder',
      impactScore: 'Score Impatto',
      financialScore: 'Score Finanziario',
      date: 'Data',
      assessorsCount: 'Valutatori',
      evaluatedIROs: 'IRO Valutati',
      completionRate: 'Completamento',
      avgImpact: 'Media Impatto',
      avgFinancial: 'Media Finanziario',
      role: 'Ruolo',
      iroEvaluated: 'IRO Valutati',
      actions: 'Azioni',
      fillOnBehalf: 'Compila per conto di',
      sendReminder: 'Invia Sollecito',
      sendAllReminders: 'Invia Tutti i Solleciti',
      reminderSent: 'Sollecito inviato',
      allRemindersSent: 'Tutti i solleciti inviati',
      errorSendingReminder: 'Errore nell\'invio del sollecito',
      addAssessment: 'Aggiungi Valutazione',
      addStakeholder: 'Aggiungi Stakeholder Interno',
      deleteAssessment: 'Elimina Valutazione',
      confirmDelete: 'Conferma Eliminazione',
      deleteConfirmMsg: 'Sei sicuro di voler eliminare questa valutazione? I punteggi dell\'IRO verranno ricalcolati.',
      cancel: 'Annulla',
      delete: 'Elimina',
      secondaryAssessorsPlaceholder: 'Assessor secondari (separati da virgola)',
      editNameAndRole: 'Modifica nome e ruolo',
      with: 'con',
    },
    assessmentComparison: {
      assessmentComparison: 'Confronto Valutazioni',
      consolidateScores: 'Consolida Punteggi',
      assessmentProgress: 'Progresso valutazioni',
      completed: 'completate',
      divergenceWarning: 'Le valutazioni presentano divergenze significative. Si consiglia di rivedere le valutazioni prima del consolidamento.',
      noAssessmentsAvailable: 'Nessuna valutazione stakeholder disponibile per questo IRO.',
      assessor: 'Valutatore',
      type: 'Tipo',
      status: 'Stato',
      weight: 'Peso',
      impactScore: 'Score Impatto',
      financialScore: 'Score Finanziario',
      date: 'Data',
      impact: 'Impatto',
      financial: 'Finanziario',
      both: 'Entrambi',
      consolidatedScores: 'Punteggi Consolidati',
      overallScore: 'Score Complessivo',
      assessments: 'valutazioni',
      impactVariance: 'Varianza Impatto',
      financialVariance: 'Varianza Finanziario',
      statusCompleted: 'Completata',
      statusRevised: 'Revisionata',
      statusPending: 'In attesa',
      detailTitle: 'Dettaglio Valutazione',
      scale: 'Scala',
      scope: 'Portata',
      irremediability: 'Irrimediabilità',
      probability: 'Probabilità',
      likelihood: 'Verosimiglianza',
      ecoFinancialImpact: 'Impatto Eco-Finanziario',
      reputationalImpact: 'Impatto Reputazionale',
      operationalImpact: 'Impatto Operativo',
      notes: 'Note',
      noDetail: 'Nessun dettaglio disponibile',
      deleteAssessment: 'Elimina Valutazione',
      confirmDelete: 'Conferma Eliminazione',
      deleteConfirmMsg: 'Sei sicuro di voler eliminare questa valutazione? I punteggi consolidati verranno ricalcolati.',
      cancel: 'Annulla',
      delete: 'Elimina',
      actions: 'Azioni',
      collapseAssessment: 'Comprimi valutazione',
      expandAssessment: 'Espandi valutazione',
    },
    governance: {
      esgGovernance: 'Governance ESG',
      initializeStructure: 'Inizializza Struttura',
      list: 'Lista',
      hierarchy: 'Gerarchia',
      newOrgan: 'Nuovo Organo',
      hierarchicalStructure: 'Struttura Gerarchica',
      board: 'Consiglio di Amministrazione',
      committee: 'Comitato',
      management: 'Management',
      operatingSystem: 'Sistema Operativo',
      workingGroup: 'Gruppo di Lavoro',
      president: 'Presidente',
      vicePresident: 'Vice Presidente',
      secretary: 'Segretario',
      member: 'Membro',
      observer: 'Osservatore',
      expert: 'Esperto',
      policies: 'Politiche',
      targets: 'Obiettivi',
      actionPlans: 'Piani di Azione',
      materialityMatrix: 'Matrice Materialità',
      weekly: 'Settimanale',
      monthly: 'Mensile',
      quarterly: 'Trimestrale',
      annually: 'Annuale',
      adHoc: 'Su Richiesta',
      active: 'Attivo',
      inactive: 'Inattivo',
      activate: 'Attiva',
      deactivate: 'Disattiva',
      edit: 'Modifica',
      save: 'Salva',
      cancel: 'Annulla',
      add: 'Aggiungi',
      addMember: 'Aggiungi Membro',
      createManually: 'Crea Manualmente',
      initializeStandardStructure: 'Inizializza Struttura Standard',
      members: 'membri',
      membersTitle: 'Membri',
      esrsTopics: 'Topic ESRS',
      approvals: 'Approvazioni',
      meetingFrequency: 'Frequenza riunioni',
      noMembersAssigned: 'Nessun membro assegnato',
      noOrgansConfigured: 'Nessun organo ESG configurato',
      noOrgansDescription: 'Inizializza la struttura di governance per creare gli organi predefiniti (CdA, Comitato Sostenibilità, ecc.) oppure crea manualmente i tuoi organi.',
      editOrgan: 'Modifica Organo',
      newEsgOrgan: 'Nuovo Organo ESG',
      addMemberTo: 'Aggiungi Membro a',
      name: 'Nome',
      nameEN: 'Nome (EN)',
      type: 'Tipo',
      parentOrgan: 'Organo Padre',
      noneTopLevel: 'Nessuno (Top-level)',
      description: 'Descrizione',
      approvalPermissions: 'Permessi di Approvazione',
      fullName: 'Nome Completo',
      role: 'Ruolo',
      chairperson: 'Presidente/Chairperson',
      chairpersonSuffix: 'Presidente',
      responsibilities: 'Responsabilità (separate da virgola)',
      responsibilitiesHelper: 'Es: Coordinamento, Reporting, Analisi',
      loadError: 'Errore nel caricamento della governance',
      initError: 'Errore nell\'inizializzazione',
      saveError: 'Errore nel salvataggio',
      stateChangeError: 'Errore nel cambio stato',
      addMemberError: 'Errore nell\'aggiunta membro',
      removeError: 'Errore nella rimozione',
      confirmRemoveMember: 'Rimuovere {{member}} da {{organ}}?',
    },
    prepareDialog: {
      prepareAssessment: 'Prepara Assessment',
      selectStakeholder: 'Seleziona Stakeholder',
      selectIros: 'Seleziona IRO',
      sendOptions: 'Opzioni di Invio',
      confirm: 'Conferma',
      targetStakeholder: 'Stakeholder di Riferimento',
      searchStakeholder: 'Cerca stakeholder interno...',
      noStakeholderSelected: 'Nessuno stakeholder selezionato',
      stakeholderRole: 'Ruolo',
      stakeholderAreas: 'Aree di competenza',
      autoIncludeAssigned: 'Includi IRO con stakeholder assegnato',
      autoIncludeAssignedHint: 'Pre-seleziona automaticamente gli IRO dove questo stakeholder è tra i valutatori assegnati',
      irosAlreadyAssigned: 'IRO già assegnati a questo stakeholder',
      irosNotAssigned: 'IRO non ancora assegnati',
      code: 'Codice',
      name: 'Nome',
      esrsArea: 'Area ESRS',
      type: 'Tipo',
      status: 'Stato',
      campaign: 'Campagna',
      noAssignedIros: 'Nessun IRO già assegnato a questo stakeholder',
      noUnassignedIros: 'Tutti gli IRO sono già assegnati',
      selectedIros: 'IRO selezionati',
      loadingAssignments: 'Caricamento assegnazioni...',
      sendTo: 'Invia a',
      sendToStakeholder: 'Invia allo stakeholder stesso',
      sendToEmail: 'Invia a un indirizzo email specifico',
      fillOnBehalf: 'Compila per conto dello stakeholder',
      fillOnBehalfHint: 'Compilerai direttamente l\'assessment per conto dello stakeholder selezionato',
      emailRecipient: 'Indirizzo Email',
      emailRecipientName: 'Nome del Destinatario',
      viewpointNote: 'Il destinatario email fornirà il punto di vista ma non rappresenta lo stakeholder.',
      assessmentType: 'Tipo di Assessment',
      impact: 'Solo Impatto',
      financial: 'Solo Finanziario',
      both: 'Entrambi',
      deadline: 'Scadenza',
      notes: 'Note per il valutatore',
      summary: 'Riepilogo Assessment',
      willBeSentTo: 'Sarà inviato a',
      willFillDirectly: 'Compilerai direttamente l\'assessment per conto di',
      viaEmail: 'via email',
      irosToAssess: 'IRO da valutare',
      cancel: 'Annulla',
      back: 'Indietro',
      next: 'Avanti',
      createAndSend: 'Crea e Invia',
      createDraft: 'Salva come Bozza',
      fillNow: 'Compila ora',
      selectAtLeastOneIro: 'Seleziona almeno un IRO',
      enterValidEmail: 'Inserisci un indirizzo email valido',
      errorCreating: 'Errore durante la creazione dell\'assessment',
      newSuffix: 'nuovi',
      emailRecipientViewpoint: 'Destinatario email (punto di vista)',
    },
  },
  dataCapture: {
    title: 'Raccolta Dati ESRS',
    countryRequests: 'Richieste Country',
    consolidation: 'Consolidamento',
    dataEntry: 'Inserimento Dati',
    noActivityAssigned: "Nessuna attività assegnata per l'anno corrente",
    contactAdmin: "Contatta l'amministratore per ricevere un'assegnazione.",
    status: {
      to_compile: 'Non inviato',
      draft: 'Bozza da inviare',
      rejected_to_owner: 'Rifiutato e rinviato al data owner',
      in_validation: 'In fase di validazione',
      validated: 'Validato',
      approved: 'Consolidato',
      consolidated: 'Consolidato',
      consolidated_approved: 'Consolidato approvato',
      validated_pending_consolidation: 'Validato — in attesa di consolidamento',
      admin_modified: "Modificato dall'admin",
      modified_by_agent_hint: "Questo dato è stato modificato da un agente AI (MCP) ed è tornato in lavorazione: va rivalidato (o riconsolidato) dal responsabile.",
    },
    perimeter: {
      centralized: 'Centralizzato',
      byCountry: 'Per country: {{name}}',
      mainExcept: 'Principale (eccetto: {{names}})',
    },
    exceptionDelete: {
      title: 'Eliminare le eccezioni?',
      body_one: 'Hai <b>{{count}} eccezione</b> configurata per {{standard}}. Disattivando le eccezioni verranno eliminate e tutti i datapoint erediteranno la configurazione globale.',
      body_other: 'Hai <b>{{count}} eccezioni</b> configurate per {{standard}}. Disattivando le eccezioni verranno eliminate e tutti i datapoint erediteranno la configurazione globale.',
      cancel: 'Annulla',
      confirm: 'Sì, elimina eccezioni',
    },
    reportAssessmentPdf: {
      internalDoc: 'TEAMSYSTEM S.P.A. - DOCUMENTO INTERNO',
      title: 'Report Assessment - Anno {{year}}',
      compiledCount: '{{count}} datapoint compilati - {{date}}',
      footer: 'TeamSystem S.p.A. - Report Assessment {{year}} - {{date}}',
      columns: { code: 'Codice', request: 'Richiesta', value: 'Valore', notes: 'Note' },
      dataOwner: 'Data owner: {{name}}',
      ownershipReview: {
        title: 'OWNER DA RIVEDERE: segnalato come non corretto',
        raisedBy: 'Segnalato da {{name}} il {{date}}',
        raisedByNoDate: 'Segnalato da {{name}}',
        suggested: 'Suggerito: {{name}}',
      },
      status: {
        to_compile: 'Dati mancanti',
        draft: 'Bozza',
        in_validation: 'In validazione',
        validated: 'Validato',
        consolidated: 'Consolidato',
        approved: 'Approvato',
        consolidated_approved: 'Cons. approvato',
        admin_modified: 'Mod. admin',
      },
    },
    supervisorDashboard: {
      title: 'Validazione',
      toValidate: 'Da validare',
      validated: 'Validati oggi',
      rejected: 'Rifiutati',
      code: 'Codice',
      name: 'Nome',
      value: 'Valore',
      owner: 'Owner',
      notes: 'Note',
      actions: 'Azioni',
      validate: 'Valida',
      reject: 'Rifiuta',
      rejectReason: 'Motivo del rifiuto',
      confirm: 'Conferma',
      cancel: 'Annulla',
      noData: 'Nessun data point da validare',
      search: 'Cerca...',
      year: 'Anno',
      validatedMsg: 'Data point validato',
      rejectedMsg: 'Data point rifiutato',
      methodology: 'Metodologia',
      deadline: 'Scadenza',
      comparisonCampaignValue: 'Valore campagna di raffronto',
      perimetro: 'Perimetro',
      pendingShort: 'da validare',
      unassigned: 'Non assegnato',
      pendingConsolidation_one: 'Hai {{count}} gruppo da consolidare',
      pendingConsolidation_other: 'Hai {{count}} gruppi da consolidare',
      goToConsolidation: 'Vai al Consolidamento',
    },
    sourcesPanel: {
      iroTab: 'IRO dalla DMA',
      esrsTab: 'ESRS Obbligatori',
      esrsOptTab: 'ESRS Facoltativi',
      griTab: 'GRI',
      tnfdTab: 'TNFD',
      sfdrTab: 'SFDR',
      allTab: 'Tutti i Template',
      search: 'Cerca...',
      searchAriaLabel: 'Cerca fonti dati',
      selected: 'selezionati',
      addSelected: 'Aggiungi Selezionati',
      createAllMandatory: 'Crea Tutti Obbligatori',
      importFromIRO: 'Importa da IRO Materiali',
      code: 'Codice',
      name: 'Nome',
      standard: 'Standard',
      disclosure: 'Disclosure',
      type: 'Tipo',
      framework: 'Framework',
      mandatory: 'Obbligatorio',
      noTemplates: 'Nessun template trovato',
      iroTitle: 'IRO dalla Doppia Materialità',
      iroDesc: 'Seleziona gli IRO per cui creare i datapoint ESRS corrispondenti. Gli IRO materiali sono già selezionati.',
      iroResult: 'Risultato importazione',
      materialStandards: 'Standard materiali',
      materialIROs: 'IRO materiali trovati',
      material: 'Materiale',
      notMaterial: 'Non materiale',
      impact: 'Impact',
      risk: 'Risk',
      opportunity: 'Opportunity',
      iroType: 'Tipo',
      materiality: 'Materialità',
      noIros: 'Nessun IRO trovato. Esegui prima la Doppia Materialità.',
      importSelected: 'Importa Selezionati',
      configureDatapoints: 'Configura Datapoint',
      created: 'creati',
      skipped: 'già esistenti',
      errors: 'errori',
      adding: 'Creazione in corso...',
      importing: 'Importazione in corso...',
    },
    assignmentManager: {
      title: 'Gestione Assegnazioni',
      newAssignment: 'Nuova Assegnazione',
      assignee: 'Assegnatario',
      name: 'Nome',
      email: 'Email',
      role: 'Ruolo',
      owner: 'Owner',
      supervisor: 'Supervisor',
      scope: 'Ambito',
      esrsStandards: 'Standard ESRS',
      geographies: 'Geografie',
      deadline: 'Scadenza',
      actions: 'Azioni',
      create: 'Crea',
      cancel: 'Annulla',
      delete: 'Elimina',
      apply: 'Applica ai datapoint',
      userId: 'User ID',
      selectUser: 'Seleziona utente',
      searchUser: 'Cerca per nome o email...',
      manualEntry: 'Inserimento manuale',
      noAssignments: 'Nessuna assegnazione trovata',
      year: 'Anno',
      created: 'Assegnazione creata',
      deleted: 'Assegnazione eliminata',
      applied: 'Assegnazione applicata ai datapoint',
      allStandards: 'Tutti',
      edit: 'Modifica',
      updated: 'Assegnazione aggiornata',
      editAssignment: 'Modifica Assegnazione',
      save: 'Salva',
      editNote: 'Le modifiche non vengono propagate automaticamente ai datapoint. Usa "Applica" per aggiornarli.',
      objectIdHint: 'MongoDB ObjectId',
      editAssignmentAria: 'Modifica assegnazione',
      applyAssignmentAria: 'Applica assegnazione',
      deleteAssignmentAria: 'Elimina assegnazione',
    },
    iroMappingStep: {
      title: 'Mapping IRO → Datapoint',
      noIros: 'Nessun IRO selezionato. Torna allo Step 1 per selezionare gli IRO.',
      noIrosDisabled: 'La sorgente IRO non è attiva. Attivala nello Step 1.',
      iroOf: 'di',
      standard: 'Standard',
      type: 'Tipo',
      code: 'Codice',
      name: 'Nome',
      description: 'Descrizione',
      disclosure: 'Disclosure',
      prev: 'Precedente',
      next: 'Salva e Avanti',
      skip: 'Salta',
      impact: 'Impact',
      risk: 'Risk',
      opportunity: 'Opportunity',
      timeHorizon: 'Orizzonte',
      short: 'Breve',
      medium: 'Medio',
      long: 'Lungo',
      geographies: 'Geografie',
      valueChain: 'Catena del valore',
      scores: 'Punteggi',
      impactScore: 'Impact',
      financialScore: 'Financial',
      overallScore: 'Overall',
      material: 'Materiale',
      notMaterial: 'Non materiale',
      search: 'Cerca datapoint...',
      filterAll: 'Tutti',
      filterRequired: 'Shall disclose',
      filterOptional: 'May disclose',
      datapoints: 'datapoint',
      selected: 'selezionati',
      noTemplates: 'Nessun datapoint trovato per questo IRO con i filtri correnti.',
      impactNature: 'Natura',
      actual: 'Attuale',
      potential: 'Potenziale',
      selectAll: 'Seleziona visibili',
      deselectAll: 'Deseleziona visibili',
      shall: 'Shall',
      may: 'May',
      suggested: 'Suggeriti',
      otherTemplates: 'Tutti gli altri',
      filterAllTypes: 'Tutti',
      filterNumeric: 'Quantitativi',
      filterText: 'Qualitativi',
      iroDetails: 'Dettagli IRO',
    },
    dataConfigurationWizard: {
      title: 'Configurazione',
      back: 'Indietro',
      next: 'Avanti',
      apply: 'Applica Configurazione',
      applying: 'Applicazione in corso...',
      saving: 'Salvataggio...',
      draft: 'Draft',
      active: 'Attiva',
      locked: 'Bloccata',
      applyConfirmTitle: 'Applica Configurazione',
      applyConfirmText: 'Questa azione creerà i DataPoint dai template selezionati e assegnerà i responsabili. Continuare?',
      confirm: 'Conferma',
      cancel: 'Annulla',
      applySuccess: 'Configurazione applicata con successo!',
      created: 'creati',
      skipped: 'già esistenti',
      ownershipUpdated: 'assegnazioni applicate',
      year: 'Anno',
      summarySourcesLabel: 'Framework',
      summaryDmaLabel: 'Filtro DMA',
      summaryReviewLabel: 'Review',
      summaryAssignLabel: 'Assegnazioni',
      assigned: 'assegnati',
      notStarted: 'Non iniziato',
      configured: 'Configurato',
      notConfigured: 'Non configurato',
    },
    configurationPhase: {
      title: 'Configurazione Raccolta Dati',
      step1: 'IRO Materiali',
      step2: 'Framework',
      step3: 'Selezione KPI',
      step4: 'Assegnazioni',
      next: 'Avanti',
      back: 'Indietro',
      finish: 'Completa Configurazione',
      materialIRODesc: 'IRO con decisione di materialità positiva, raggruppati per standard ESRS.',
      frameworkDesc: 'Seleziona il framework di riferimento per i KPI.',
      kpiDesc: 'Seleziona i KPI da raccogliere. I KPI obbligatori sono pre-selezionati.',
      assignDesc: 'Assegna Data Owner per ogni standard.',
      code: 'Codice',
      name: 'Nome',
      type: 'Tipo',
      unit: 'Unità',
      mandatory: 'Obbligatorio',
      selected: 'Selezionati',
      standard: 'Standard',
      standardsCount: 'Standard',
      ownerName: 'Nome Owner',
      ownerEmail: 'Email Owner',
      noTemplates: 'Nessun template disponibile',
      configComplete: 'Configurazione completata! Datapoint creati e campagna in bozza.',
      creating: 'Creazione in corso...',
      datapoints: 'Datapoint totali',
      datapointsCount_one: '{{count}} datapoint',
      datapointsCount_other: '{{count}} datapoint',
      completedPct: '{{pct}}% completati',
      noData: 'Nessun dato',
      year: 'Anno',
    },
    kanbanBoard: {
      title: 'Kanban Raccolta Dati',
      configuration: 'Configurazione Dati',
      collection: 'Raccolta Dati',
      validation: 'Validazione',
      materialIROs: 'IRO Materiali',
      templates: 'Template',
      assignedOwners: 'Owner assegnati',
      activeCampaign: 'Campagna attiva',
      ownerProgress: 'Progresso owner',
      pendingReminders: 'Solleciti in attesa',
      toValidate: 'Da validare',
      validatedToday: 'Completati',
      overdue: 'Scaduti',
      configure: 'Configura',
      manage: 'Gestisci',
      validate: 'Valida',
      noCampaigns: 'Nessuna campagna',
      framework: 'Framework',
      year: 'Anno',
      datapoint: 'Datapoint',
    },
    roleAssignmentStep: {
      title: 'Assegnazione Ruoli',
      owner: 'Data Owner',
      validator: 'Data Validator',
      inherited: 'ereditato',
      standard: 'Standard',
      disclosure: 'Disclosure',
      datapoint: 'Datapoint',
      noDatapoints: 'Nessun template selezionato. Torna allo Step 1 per selezionare le sorgenti.',
      selectRole: 'Seleziona ruolo...',
      coverage: 'Copertura',
      covered: 'coperti',
      previous: 'Precedente',
      next: 'Prossimo',
      datapoints: 'datapoint',
      disclosures: 'disclosure',
      noRoles: 'Nessun ruolo configurato. Vai in Impostazioni > Ruoli Data Capture per configurarli.',
      allCountries: 'Dato centralizzato',
      allCountriesShort: 'Centr.',
      perCountry: 'Dato suddiviso per Country',
      perCountryShort: 'Per Country',
      scope: 'Scope',
      ownerShort: 'Owner',
      validatorShort: 'Validator',
      exceptionsTitle: 'Eccezioni datapoint',
      noExceptions: 'Nessuna eccezione configurata. Tutti i datapoint ereditano la configurazione globale.',
      addException: '+ Aggiungi eccezione',
      removeException: 'Rimuovi {{code}}',
      mandatory: 'Mandatory',
      required: 'Required',
      quantitative: 'Quantitative',
    },
    activeDatapointsPanel: {
      title: 'Datapoint Attivi',
      total: 'Totale',
      assigned: 'Assegnati',
      unassigned: 'Non assegnati',
      completionRate: 'Completamento',
      overdue: 'Scaduti',
      search: 'Cerca...',
      code: 'Codice',
      name: 'Nome',
      standard: 'Standard',
      owner: 'Owner',
      status: 'Status',
      allStandards: 'Tutti gli standard',
      allStatuses: 'Tutti gli status',
      noDatapoints: 'Nessun datapoint trovato',
      rowsPerPage: 'Righe per pagina',
      searchAriaLabel: 'Cerca data point attivi',
    },
    templateCatalog: {
      title: 'Catalogo Template',
      search: 'Cerca...',
      searchAriaLabel: 'Cerca template',
      code: 'Codice',
      name: 'Nome',
      standard: 'Standard',
      disclosure: 'Disclosure',
      type: 'Tipo',
      unit: 'Unità',
      mandatory: 'Obbligatorio',
      crossMapping: 'Cross-mapping',
      uploadExcel: 'Importa da Excel',
      noTemplates: 'Nessun template trovato',
      imported: 'Template importati',
      year: 'Anno',
      importResult: '{{imported}} nuovi, {{updated}} aggiornati, {{errors}} errori',
      templateCount_one: '{{count}} template',
      templateCount_other: '{{count}} template',
    },
    datapointMappingView: {
      iroToReview: 'IRO da revisionare',
      mandatoryLabel: 'Mandatori',
      optionalLabel: 'Opzionali',
      totalDp: 'Totale Datapoint',
      unmappedMandatory: 'Mandatori senza IRO',
      filter: 'Filtra datapoint...',
      searchOther: 'Cerca da altri standard...',
      selected: 'selezionati',
      mandatoryBadge: 'obbl.',
      code: 'Codice',
      name: 'Nome',
      unit: 'Unità',
      assignedTo: 'Assegnato a',
      noResults: 'Nessun risultato',
      noneInCategory: 'Nessun datapoint in questa categoria',
      unmappedDesc: 'Datapoint mandatori il cui standard ESRS non corrisponde a nessun IRO selezionato. Inclusi automaticamente.',
      otherStandards: 'Da altri standard',
      back: 'Indietro',
      save: 'Salva Configurazione',
      saving: 'Salvataggio...',
      saved: 'Configurazione salvata!',
      loading: 'Caricamento template...',
      selectIro: 'Seleziona un IRO dalla sidebar',
      savingStep1: 'Creazione datapoint...',
      savingStep2: 'Collegamento agli IRO...',
      filterIndicatorsAria: 'Filtra indicatori',
      filterDataPointAria: 'Filtra data point',
      mandatoryBadgeShort: 'obbl.',
    },
    datapointReviewStep: {
      code: 'Codice',
      name: 'Nome',
      type: 'Tipo',
      format: 'Formato',
      mandatoryBadge: 'Obbligatorio',
      optionalBadge: 'Facoltativo',
      allTypes: 'Tutti i tipi',
      typeNumeric: 'Quantitativo',
      typeText: 'Qualitativo',
      datapoints: 'datapoint',
      filterAll_one: 'Tutti ({{count}})',
      filterAll_other: 'Tutti ({{count}})',
      filterMandatory_one: 'Obbligatori ({{count}})',
      filterMandatory_other: 'Obbligatori ({{count}})',
      filterOptional_one: 'Facoltativi ({{count}})',
      filterOptional_other: 'Facoltativi ({{count}})',
      groupMandatory_one: '{{count}} obblig.',
      groupMandatory_other: '{{count}} obblig.',
      groupOptional_one: '{{count}} facoltativo',
      groupOptional_other: '{{count}} facoltativi',
      summary: '{{total}} datapoint selezionati — {{mandatory}} obbligatori · {{optional}} facoltativi inclusi',
    },
    delegateDialog: {
      title: 'Delega Datapoint',
      datapoint: 'Datapoint da delegare',
      userId: 'User ID',
      userName: 'Nome',
      userEmail: 'Email',
      notes: 'Note (opzionale)',
      cancel: 'Annulla',
      confirm: 'Conferma Delega',
    },
    dmaFilterStep: {
      title: 'Filtro DMA',
      bannerNoDma: 'Nessuna DMA trovata per questo anno. Puoi saltare questo step — tutti i datapoint facoltativi verranno inclusi.',
      bannerInProgress: 'La tua DMA è ancora in corso (nessun IRO materiale trovato). Puoi saltare questo step — tutti i datapoint facoltativi verranno inclusi.',
      bannerAi: 'Filtro applicato: i datapoint facoltativi sono inclusi se il loro standard ESRS è presente negli IRO materiali. Puoi modificare ogni voce prima di procedere.',
      skip: 'Salta — includi tutti i facoltativi',
      regenerate: 'Ricalcola filtro',
      generating: 'Applicazione filtro DMA...',
      include: 'INCLUDI',
      exclude: 'ESCLUDI',
      code: 'Codice',
      name: 'Nome',
      aiRec: 'Proposta AI',
      override: 'Override',
      reason: 'Motivazione',
      dmaUnavailable: 'DMA non disponibile',
      overrideChip: 'override',
      materialIros_one: '{{count}} IRO materiale trovato',
      materialIros_other: '{{count}} IRO materiali trovati',
      datapoints: 'datapoint',
      stubWarning: 'Nessun template opzionale trovato per il framework selezionato — tutti i facoltativi verranno inclusi per default.',
    },
    sourceSelectionStep: {
      esrsTitle: 'ESRS',
      esrsDesc: 'Datapoint EFRAG IG3 (obbligatori e facoltativi)',
      esrsOmnibusTitle: 'ESRS Omnibus',
      esrsOmnibusDesc: 'Set semplificato ESRS post-Omnibus (459 datapoint, -61% rispetto IG3)',
      miniOmnibusTestTitle: 'MiniOmnibus Test',
      miniOmnibusTestDesc: '5 datapoint di test (E1, S1, G1) — solo per sviluppo e testing',
      griTitle: 'GRI',
      griDesc: 'Template Global Reporting Initiative',
      tnfdTitle: 'TNFD',
      tnfdDesc: 'Taskforce on Nature-related Financial Disclosures',
      sfdrTitle: 'SFDR',
      sfdrDesc: 'Sustainable Finance Disclosure Regulation',
      datapoints: 'datapoint',
      code: 'Codice',
      name: 'Nome',
    },
    dataCollectionPage: {
      title: 'Raccolta Dati',
      campaigns: 'Campagne',
      myData: 'I Miei Dati',
      activity: 'Storico azioni',
    },
    dataValidationPage: {
      title: 'Validazione Dati',
      review: 'Revisione',
      consolidation: 'Consolidamento',
      activity: 'Storico azioni',
    },
    countryNames: {
      IT: 'Italia', ES: 'Spagna', FR: 'Francia', DE: 'Germania', PT: 'Portogallo',
      AT: 'Austria', BE: 'Belgio', NL: 'Paesi Bassi', PL: 'Polonia', RO: 'Romania',
      SE: 'Svezia', CZ: 'Repubblica Ceca', HU: 'Ungheria', GR: 'Grecia', CH: 'Svizzera',
      GB: 'Regno Unito', US: 'Stati Uniti',
    },
    activityHistory: {
      empty: 'Nessuna azione registrata sui tuoi dati.',
      valueLabel: 'Valore',
      actions: {
        draft: 'Salvato in bozza',
        in_validation: 'Inviato per validazione',
        validated: 'Validato',
        approved: 'Approvato',
        admin_modified: "Modificato dall'admin",
        to_compile: 'Riportato da compilare',
        compiled_mcp: 'Compilato via agente AI',
        ownership_review_raised: "Segnalato: non sono io l'owner",
        ownership_review_withdrawn: 'Segnalazione owner ritirata',
        ownership_review_reassigned: 'Owner riassegnato',
      },
    },
    mandatoryPanel: {
      mandatoryTitle: 'Datapoint Mandatori',
      mandatoryDesc: 'Questi datapoint sono richiesti dalla normativa ESRS e vengono creati automaticamente.',
      suggestedTitle: 'Datapoint Suggeriti',
      suggestedDesc: 'Datapoint opzionali collegati a standard ESRS/GRI. Aggiungi quelli rilevanti per la tua azienda.',
      code: 'Codice',
      name: 'Nome',
      standard: 'Standard',
      disclosure: 'Disclosure',
      type: 'Tipo',
      crossMapping: 'Cross-mapping',
      add: 'Aggiungi',
      added: 'Aggiunto',
      autoCreating: 'Creazione datapoint mandatori...',
      created: 'creati',
      skipped: 'già esistenti',
      noSuggestions: 'Nessun suggerimento disponibile',
      noMandatory: 'Nessun template mandatorio configurato',
      adding: 'Aggiunta in corso...',
      datapointUnit: 'datapoint',
      suggestedUnit: 'suggeriti',
      dataType: { numeric: 'Quantitativo', text: 'Qualitativo' },
    },
    campaignDetail: {
      title: 'Dettaglio Campagna',
      coverage: 'Copertura',
      completion: 'Completamento',
      overdue: 'Scaduti',
      delegations: 'Deleghe',
      ownerProgress: 'Progresso per Owner',
      validatorProgress: 'Progresso per Validatore',
      standardProgress: 'Progresso per Standard',
      owner: 'Owner',
      validator: 'Validatore',
      standard: 'Standard',
      total: 'Totale',
      completed: 'Completati',
      progress: 'Progresso',
      actions: 'Azioni',
      send: 'Invia Notifiche',
      remind: 'Invia Solleciti',
      forceFill: 'Forza Valore',
      delegate: 'Delega',
      value: 'Valore',
      notes: 'Note',
      save: 'Salva',
      cancel: 'Annulla',
      toUser: 'Destinatario',
      userName: 'Nome',
      userEmail: 'Email',
      userId: 'User ID',
      notFound: 'Campagna non trovata',
      sent: 'Notifiche inviate',
      reminded: 'Solleciti inviati',
      forceFilled: 'Valore forzato',
      delegated: 'Datapoint delegato',
      statusColumn: 'Status',
      validators: 'Validatori',
      noValidators: 'Nessun validatore assegnato',
      status: { draft: 'Bozza', active: 'Attiva', completed: 'Completata', cancelled: 'Annullata' },
    },
    progressDashboard: {
      title: 'Progresso Raccolta Dati',
      noCampaigns: "Nessuna campagna trovata per l'anno selezionato",
      datapointUnit: 'datapoint',
      completedSuffix: 'completati',
      overdueSuffix: 'scaduti',
      totalDatapoint: 'Totale Datapoint',
      completed: 'Completati',
      overdue: 'Scaduti',
      byStandard: 'Progresso per Standard ESRS',
      byOwner: 'Progresso per Owner',
      byValidator: 'Progresso per Validatore',
      colCode: 'Codice',
      colName: 'Nome',
      colOwner: 'Owner',
      colStandard: 'Standard',
      colStatus: 'Status',
      colDeadline: 'Scadenza',
      colAction: 'Azione',
      reminded: 'Sollecitato',
      noOwner: 'Nessun owner assegnato',
      alreadyCompleted: 'Già completato',
      remindTooltip: 'Sollecita {{name}}',
      remindAria: 'sollecita',
      ownershipReviewChip: 'Owner da rivedere',
      ownershipReviewFilter: 'Owner da rivedere',
      ownershipReviewFilterTooltip:
        'Mostra solo i datapoint per cui l’owner ha segnalato di non essere il proprietario del dato',
      ownershipReviewRows_one: '{{count}} da rivedere',
      ownershipReviewRows_other: '{{count}} da rivedere',
      reassign: 'Riassegna',
      reassignTooltip: 'Sposta il dato su owner e validatore giusti',
      reassignTitle: 'Riassegna il dato',
      reassignRaisedBy: 'Segnalato da {{name}}',
      reassignSuggests: 'suggerisce {{name}}',
      reassignNewOwner: 'Nuovo owner',
      reassignNewValidator: 'Nuovo validatore',
      reassignNeedsOwner: 'Scegli il nuovo owner dall’elenco',
      reassignNeedsValidator:
        'Scegli il nuovo validatore dall’elenco, oppure svuota il campo per lasciarlo com’è',
    },
    info: {
      ariaLabel: 'Informazioni sul datapoint',
      title: 'Riferimento ESRS',
      descriptionTitle: 'Descrizione',
      loadingDescription: 'Caricamento...',
      noDescription: 'Nessuna descrizione disponibile.',
      disclosure: 'Disclosure',
      paragraph: 'Paragrafo',
      ar: 'Application Requirement',
      noRefs: 'Nessun riferimento disponibile',
      efragLink: 'Indicazioni ESRS semplificate (EFRAG)',
      howToCalculateTitle: 'Come si calcola',
      whatToMeasure: 'Cosa misurare',
      scopeAndPerimeter: 'Regole e perimetro',
      howToCalculate: 'Formula / metodo',
      unit: 'Unità di misura',
    },
    campaignManager: {
      title: 'Campagne di Raccolta',
      newCampaign: 'Nuova Campagna',
      showArchived: 'Mostra archiviate',
      noCampaigns: 'Nessuna campagna trovata',
      yearLabel: 'Anno {{year}}',
      newPeriod: 'Nuovo periodo',
      createNewPeriod: 'Crea nuovo periodo',
      newPeriodCreatedToast: 'Nuovo periodo "{{label}}" creato',
      newPeriodDialog: {
        title: 'Nuovo periodo',
        description: 'Crea una nuova campagna "{{name}}" per il periodo selezionato. I datapoint saranno gli stessi, pronti per una nuova raccolta.',
      },
      columns: {
        name: 'Nome',
        status: 'Status',
        deadline: 'Deadline',
        progress: 'Progresso',
        actions: 'Azioni',
      },
      actions: {
        send: 'Invia',
        cancel: 'Annulla',
        view: 'Dettaglio',
        create: 'Crea',
        close: 'Chiudi',
        delete: 'Elimina',
        archive: 'Archivia',
      },
      fields: {
        description: 'Descrizione',
        year: 'Anno',
        campaignName: 'Nome campagna',
        period: 'Periodo',
        fullYear: 'Anno intero',
        none: 'Nessuno',
      },
      standards: {
        section: 'Standard da raccogliere',
        noneAllHint: 'Nessuno selezionato: verranno inclusi tutti i datapoint della configurazione',
        selectedCount: 'Selezionati: {{count}} datapoint',
      },
      toasts: {
        sent: 'Campagna inviata',
        cancelled: 'Campagna annullata',
        created: 'Campagna creata',
        deleted: 'Campagna eliminata',
        archived: 'Campagna archiviata',
      },
      delete: {
        confirmTitle: 'Conferma eliminazione',
        confirmMsg: 'Sei sicuro di voler eliminare la campagna',
        warning: 'Questa azione è irreversibile e cancellerà anche:',
        deleteUnavailableTooltip: 'Le campagne attive o chiuse non possono essere eliminate. Puoi archiviarle.',
        allDatapoints: 'Tutti i data point associati',
        allConsolidationData: 'Tutti i dati di consolidamento',
        rolesUnchanged: 'Le assegnazioni utente (ruoli) resteranno invariate.',
      },
      ariaLabels: {
        sendCampaign: 'Invia campagna',
        cancelCampaign: 'Annulla campagna',
        deleteCampaign: 'Elimina campagna',
        deleteUnavailable: 'Elimina non disponibile',
      },
      campaignStatus: {
        draft: 'Bozza',
        active: 'Attiva',
        completed: 'Chiusa',
        cancelled: 'Annullata',
      },
      periods: {
        h1: 'H1 (Gen–Giu)',
        h2: 'H2 (Lug–Dic)',
        q1: 'Q1 (Gen–Mar)',
        q2: 'Q2 (Apr–Giu)',
        q3: 'Q3 (Lug–Set)',
        q4: 'Q4 (Ott–Dic)',
        m1: 'M1 — Gennaio',
        m2: 'M2 — Febbraio',
        m3: 'M3 — Marzo',
        m4: 'M4 — Aprile',
        m5: 'M5 — Maggio',
        m6: 'M6 — Giugno',
        m7: 'M7 — Luglio',
        m8: 'M8 — Agosto',
        m9: 'M9 — Settembre',
        m10: 'M10 — Ottobre',
        m11: 'M11 — Novembre',
        m12: 'M12 — Dicembre',
      },
      comparisonField: {
        label: 'Campagna di confronto (facoltativa)',
        none: 'Nessun confronto',
      },
    },
    sourceDocuments: {
      title: 'Libreria',
      subtitle: 'Documenti che giustificano i dati: policy, metodologie, perimetri',
      upload: 'Carica documento',
      uploadTitle: 'Nuovo documento',
      chooseFile: 'Scegli file…',
      fieldName: 'Nome',
      fieldDescription: 'Descrizione',
      fieldCategory: 'Categoria',
      fieldYear: 'Anno di riferimento',
      fieldYearInfo: 'Anno di riferimento: {{year}} (anno di lavoro corrente)',
      colName: 'Documento',
      colCategory: 'Categoria',
      colYears: 'Anni',
      colFile: 'File',
      colUploadedBy: 'Caricato da',
      open: 'Apri',
      empty: 'Nessun documento in libreria. Carica il primo con il pulsante in alto.',
      duplicateWarning: 'Questo file è già in libreria come "{{name}}": non è stato ricaricato.',
      linkedDocuments: 'Documenti di fonte',
      linkedDocumentsHelper: 'Collega i documenti che giustificano questo dato (facoltativo)',
      documentUnavailable: 'Documento non più in libreria',
      selectCategory: 'Seleziona una categoria',
      uploadInLibrary: 'Manca un documento? Caricalo in libreria',
      fieldVisibility: 'Riservatezza',
      selectVisibility: 'Indica chi può vedere questo documento',
      visibilityShared: 'Condivisibile internamente',
      visibilityRestricted: 'Riservato — contiene dati sensibili',
      visibilityPublic: 'Pubblico — divulgabile all\'esterno',
      visibilityHelp: 'Scelta obbligatoria: i documenti condivisibili sono visibili a tutta la libreria.',
      restrictedHelp: 'Visibile solo a te, al validatore dei datapoint collegati e all\'amministratore.',
      restrictedBadge: 'Riservato',
      publicHelp: 'Visibile a tutta la libreria e utilizzabile fuori dall\'azienda: report, questionari dei clienti, gare. Scegli questo livello solo se la pubblicazione è stata autorizzata.',
      publicBadge: 'Pubblico',
      inheritedBadge: 'Ereditato — da rivedere',
      confirmYear: 'Conferma per quest\'anno',
      removeYear: 'Rimuovi da quest\'anno',
      draftBadge: 'Bozza — da confermare',
      draftByAgent: 'Caricato da {{agent}} per {{name}}',
      draftPickerLabel: 'bozza',
      confirmDraft: 'Conferma il documento',
      confirmDraftTitle: 'Conferma il documento in bozza',
      confirmDraftText: 'Questo documento è stato caricato da un agente AI e finora lo vedono solo chi l\'ha caricato e gli amministratori. Aprilo, controlla che sia il file giusto e scegli chi può vederlo.',
      confirmDraftAction: 'Conferma',
      detailsTitle: 'Dettagli del documento',
      draftReadOnlyText: 'Documento caricato da un agente AI, in attesa che chi l\'ha caricato lo confermi.',
      noDescription: 'Nessuna descrizione',
      draftVisibilityPending: 'Da scegliere alla conferma',
      close: 'Chiudi',
    },
  },
  settings: {
    sustainablePlatformPage: {
      siaTitle: 'Sustainability Impact Assessment (SIA)',
      gsfTitle: 'Green Software Principles (GSF)',
      carbonAwareTitle: 'Carbon-Aware Architecture',
      sciTitle: 'SCI Measurement (ISO/IEC 21031:2024)',
      cloudEmissionTitle: 'Cloud Emission Measurement (GHG Protocol)',
      embodiedHardware: 'Embodied (hardware)',
      locationVsMarketTitle: 'Metodo Location vs Market (GHG Protocol Scope 2)',
      csrdBothMethodsNote: 'EU CSRD richiede entrambi i metodi. Il market-based riflette gli acquisti rinnovabili di Azure.',
      embodiedLifecycleCaption: 'Server ~{{serverKg}} kgCO2e totali, allocazione 1/{{vcpu}} vCPU su {{years}} anni = {{userShare}} gCO2eq/anno',
      biodiversityTitle: 'Biodiversità Digitale (LCIA / TNFD)',
      datacenterSitingCaption: 'Azure Italy North — {{area}} m², sito urbano/industriale, CF = {{cf}} PDF·m²·yr per m²·yr',
      overallVerdict: 'Tutti i pillar Environmental, Social, Economic in stato PASS. GSF Level 3 (Practiced). TNFD LEAP 4/4 completato. WCAG AA conforme. Bundle ottimizzato con code splitting.',
      methodologyNotes: 'Note Metodologiche',
      methodologySiaTitle: 'Sustainability Impact Assessment (SIA)',
      methodologySiaText: 'Il framework SIA utilizza la struttura A5 (Environmental, Social, Economic) con valutazione qualitativa interna. Ogni area viene valutata PASS/PARTIAL/NEEDS WORK sulla base di evidenze documentate nel codice sorgente e nella configurazione del progetto.',
      methodologyGsfTitle: 'Green Software Principles (GSF)',
      methodologyGsfText: 'Autovalutazione basata sulla GSF Maturity Matrix. Ogni principio viene valutato su scala 1-5 con evidenze specifiche. Il livello di maturità complessivo (Level 3 — Practiced) rappresenta la media ponderata dei principi applicabili.',
      methodologySciTitle: 'SCI Measurement (ISO/IEC 21031:2024)',
      methodologySciText: 'Le misurazioni SCI seguono lo standard ISO/IEC 21031:2024. I dati energetici sono misurati empiricamente tramite DevTools (CPU profiling, Network transfer) e Lighthouse. Le emissioni embodied sono calcolate usando dati Boavizta e Groger et al.',
      methodologyCloudTitle: 'Cloud Emission Measurement',
      methodologyCloudText: 'Metodologia allineata al GHG Protocol Corporate Standard (Scope 2+3). Intensità carbonica da EMBER 2024 (Italia: 310 gCO2eq/kWh). PUE Azure Italy North: 1.12. Entrambi i metodi location-based e market-based sono riportati come richiesto dalla CSRD.',
      methodologyBiodiversityTitle: 'Biodiversità Digitale',
      methodologyBiodiversityText: 'Impatto quantificato tramite LCIA con fattori di caratterizzazione ReCiPe 2016 Endpoint e dati Ecoinvent v3+. Framework TNFD LEAP completato in tutte e 4 le fasi. Valutazione sito datacenter basata su criteri di biodiversità (corridoi ecologici, aree protette, stress idrico).',
      methodologyLimitationsTitle: 'Limitazioni e Incertezze',
      methodologyLimitationsText: 'I dati presentati sono stime basate su misurazioni empiriche e modelli pubblicati, con un margine di incertezza stimato del ±15-25%. Non sono stati sottoposti ad audit di terze parti. Le emissioni embodied utilizzano dati LCA di letteratura, non misurazioni dirette dalla supply chain. I dati di consumo idrico si basano su WUE pubblicati dai cloud provider.',
    },
    roleManagement: {
      title: 'Ruoli Data Capture',
      subtitle: 'Configura i ruoli aziendali e assegna le persone responsabili per country.',
      addRole: 'Nuovo Ruolo',
      seed: 'Carica Predefiniti',
      noRoles: 'Nessun ruolo configurato. Clicca "Carica Predefiniti" per iniziare.',
      principalPerson: 'Utente Principale',
      principalPersonHint: 'Utente assegnato quando lo scope è "Dato centralizzato" o come fallback per country non configurate.',
      selectPerson: 'Seleziona persona...',
      columns: {
        code: 'Codice',
        name: 'Nome',
        nameEN: 'Nome EN',
        defaultRole: 'Default',
        active: 'Attivo',
        actions: 'Azioni',
        country: 'Country',
        person: 'Persona',
        assignments: 'Assegnazioni',
      },
      actions: {
        save: 'Salva',
        cancel: 'Annulla',
        delete: 'Elimina',
      },
      delete: {
        confirm: 'Eliminare questo ruolo?',
        cannotDeleteDefault: 'I ruoli predefiniti non possono essere eliminati',
      },
      ariaLabels: {
        deleteRole: 'Elimina ruolo',
        cannotDeleteDefault: 'Non è possibile eliminare ruoli predefiniti',
      },
    },
    countries: {
      all: 'Tutte',
      IT: 'Italia',
      ES: 'Spagna',
      FR: 'Francia',
      CH: 'Svizzera',
      AL: 'Albania',
      DK: 'Danimarca',
      TR: 'Turchia',
      IL: 'Israele',
    },
    tabs: {
      frameworkMapping: 'Framework Mapping',
      dataCaptureRoles: 'Ruoli Data Capture',
      apiTokens: 'API Tokens',
    },
    users: {
      title: 'Gestione Utenti',
      subtitle: 'Visualizza, modifica e gestisci gli utenti della piattaforma.',
      searchPlaceholder: 'Cerca per nome o email...',
      searchAriaLabel: 'Cerca utenti',
      filterRole: 'Filtra per ruolo',
      filterStatus: 'Filtra per stato',
      allRoles: 'Tutti i ruoli',
      allStatuses: 'Tutti gli stati',
      nome: 'Nome',
      cognome: 'Cognome',
      email: 'Email',
      ruolo: 'Ruolo',
      stato: 'Stato',
      ultimoAccesso: 'Ultimo Accesso',
      azioni: 'Azioni',
      attivo: 'Attivo',
      inattivo: 'Inattivo',
      editUser: 'Modifica Utente',
      editUserAria: 'Modifica utente',
      noUsers: 'Nessun utente trovato.',
      userActive: 'Utente attivo',
      addUser: 'Aggiungi Utente / Stakeholder Interno',
      totalUsers: 'utenti totali',
      ruoloPiattaforma: 'Ruolo Piattaforma',
      addUserSave: 'Aggiungi',
      requiredField: 'Campo obbligatorio',
      invalidEmail: 'Email non valida',
      createdSuccess: 'Utente creato con successo',
      createError: 'Errore nella creazione utente',
      loadError: 'Errore nel caricamento utenti',
      saveError: 'Errore nel salvataggio',
      roles: {
        amministratore: 'Amministratore',
        responsabile_esg: 'Responsabile ESG',
        contributore: 'Contributore',
        visualizzatore: 'Visualizzatore',
        global_admin: 'Admin Globale',
        country_admin: 'Admin Country',
        legal_reviewer: 'Revisore Legale',
      },
    },
    frameworkMapping: {
      subtitle: 'Gestisci le corrispondenze tra framework ESG',
      sourceFramework: 'Framework sorgente',
      targetFramework: 'Framework target',
      matchType: 'Tipo match',
      all: 'Tutti',
      sourceCode: 'Codice sorgente',
      targetCode: 'Codice target',
      confidence: 'Confidenza',
      source: 'Origine',
      actions: 'Azioni',
      addMapping: 'Nuovo mapping',
      editMapping: 'Modifica mapping',
      editMappingAria: 'Modifica mapping',
      deleteMappingAria: 'Elimina mapping',
      notes: 'Note',
      officialReference: 'Riferimento ufficiale',
      save: 'Salva',
      cancel: 'Annulla',
      delete: 'Elimina',
      confirmDelete: 'Sei sicuro di voler eliminare questo mapping?',
      totalMappings: 'Mapping totali',
      noMappings: 'Nessun mapping trovato.',
      official: 'Ufficiale',
      seed: 'Seed',
      manual: 'Manuale',
      exact: 'Esatto',
      partial: 'Parziale',
      related: 'Correlato',
    },
    tokens: {
      sectionTitle: 'Token API',
      newToken: 'Nuovo Token',
      newTokenApi: 'Nuovo Token API',
      loadError: 'Errore nel caricamento dei token',
      colName: 'Nome',
      colPermissions: 'Permessi',
      colCreatedAt: 'Creato il',
      colLastUsed: 'Ultimo utilizzo',
      colActions: 'Azioni',
      revokeTooltip: 'Revoca token',
      revokeAria: 'Revoca token {{name}}',
      noTokens: 'Nessun token attivo. Crea un token per connettere un agente MCP.',
      never: 'Mai',
      permissions: 'Permessi',
      read: 'Lettura',
      write: 'Scrittura',
      agentName: 'Nome agente',
      agentNamePlaceholder: 'es. Impact Officer di Francesco',
      requiredField: 'Campo obbligatorio',
      createError: 'Errore nella creazione del token',
      copyWarning: 'Copia il token adesso. Non sarà più visibile dopo la chiusura.',
      tokenLabel: 'Token',
      copyAria: 'Copia token',
      copied: 'Copiato!',
      close: 'Chiudi',
      cancel: 'Annulla',
      createToken: 'Crea Token',
      revokeTitle: 'Revoca Token',
      revokeError: 'Errore nella revoca del token',
      revokeQuestion: 'Revocare il token',
      revokeConfirm: 'L\'agente perderà immediatamente l\'accesso alla piattaforma.',
      revoke: 'Revoca',
    },
    sustainablePlatform: {
      pageTitle: 'Piattaforma Sostenibile',
      downloadPdf: 'Scarica PDF',
      generatingPdf: 'Generazione...',
      area: 'Area',
      notes: 'Note',
      region: 'Regione',
      reductionStrategies: 'Strategie di riduzione',
      annualEstimate: 'Stima Annuale (20 utenti)',
      energyPageView: 'Energia — Page View',
      energyPdf: 'Energia — PDF Generation',
      monthlyEstimate: 'Stima Mensile (20 utenti attivi)',
      activity: 'Attivita',
      volumeMonth: 'Volume/mese',
      monthlyTotal: 'Totale Mensile',
      priorityActions: 'Azioni Prioritarie',
      action: 'Azione',
      priority: 'Priorita',
      expectedImpact: 'Impatto Atteso',
      cloudEmissionsLocation: 'Emissioni Cloud (location)',
      cloudEmissionsMarket: 'Emissioni Cloud (market)',
      waterUsage: 'Consumo Acqua',
      infrastructureBoundary: 'Perimetro Infrastruttura',
      serverLifetime: 'Vita utile server',
      years: 'anni',
      decomposition: 'Decomposizione',
      category: 'Categoria',
      detail: 'Dettaglio',
      method: 'Metodo',
      value: 'Valore',
      source: 'Fonte',
      description: 'Descrizione',
      embodiedLifecycle: 'Emissioni Embodied — Ciclo di vita hardware',
      waterConsumption: 'Consumo Idrico (WUE)',
      formula: 'Formula',
      datacenterCooling: 'Raffreddamento datacenter',
      electricityProduction: 'Produzione elettricita',
      total: 'Totale',
      totalImpact: 'Impatto Totale',
      dominantPathway: 'Pathway Dominante',
      materials: 'Materiali',
      landUse: 'Uso Suolo',
      initiated: 'Avviato',
      biodiversityPathways: 'Pathway di Impatto sulla Biodiversita',
      unit: 'Unita',
      materialExtraction: 'Estrazione Materiali — Impatto per Materiale',
      material: 'Materiale',
      impact: 'Impatto',
      phase: 'Fase',
      datacenterSiting: 'Valutazione Sito Datacenter',
      criterion: 'Criterio',
      ourValue: 'Nostro Valore',
      risk: 'Rischio',
      biodiversityChecklist: 'SIA A5. Biodiversita — Checklist',
      item: 'Voce',
      infrastructureConfig: 'Configurazione Infrastruttura',
      collapseConfig: 'Comprimi configurazione',
      expandConfig: 'Espandi configurazione',
      instanceType: 'Tipo Istanza',
      serverLifeYears: 'Vita server (anni)',
      resetDefaults: 'Ripristina Default',
      methodologyNotes: 'Note Metodologiche',
    },
  },
  dataConfiguration: {
    searchDatapoint: 'Cerca per codice o nome datapoint...',
    noDatapointAvailable: 'Nessun datapoint disponibile',
  },
  kpiDashboard: {
    campaignLabel: 'Campagna:',
    clickHint: 'Clicca su un valore per vedere il datapoint sorgente',
    loadError: 'Errore nel caricamento dei KPI',
    popover: {
      value: 'Valore',
      status: 'Stato',
      esrsStandard: 'Standard ESRS',
      campaign: 'Campagna',
      clickCodeHint: 'Clicca il codice per aprire il datapoint',
    },
    sections: {
      climate: 'Climate & Energy',
      ethical: 'Ethical Conduct',
      employees: 'Employee Engagement & Inclusion',
    },
    subsections: {
      scopeEmissions: 'Scope 1+2 emissions',
      carbonIntensity: 'Carbon Intensity Index',
      energy: 'Energy',
      codeOfConduct: 'Code of Conduct',
    },
    kpi: {
      scope1: 'Emissioni Scope 1',
      scope2LocationBased: 'Emissioni Scope 2 (location-based)',
      carbonIntensityIndex: 'Carbon Intensity Index',
      totalEnergy: 'Consumo energetico totale',
      renewableEnergy: 'Energia da fonti rinnovabili',
      gooCoverage: 'Copertura GoO Scope 2',
      antiCorruptionTraining: 'Formazione anti-corruzione',
      convictionsAntiCorruption: 'Condanne anti-corruzione',
      finesAntiCorruption: 'Sanzioni anti-corruzione',
      performanceReviewParticipation: 'Partecipazione performance review',
      employeeTurnover: 'Turnover dipendenti',
      genderPayGap: 'Gender pay gap',
      workforceHealthSafety: 'Forza lavoro coperta da H&S',
      workAccidentsRate: 'Tasso infortuni sul lavoro',
    },
    caption: {
      ownOperations: 'Sedi + flotta (own operations)',
      withGoO: "Con Garanzie d'Origine (GoO)",
      gooBuildings: 'Elettricità edifici da strumenti contrattuali',
      functionsAtRisk: 'Funzioni a rischio coperte',
      recordableAccidents: 'Infortuni registrabili per milione di ore lavorate',
    },
    previewTitle: 'KPI Chiave',
    viewAll: 'Espandi',
    collapse: 'Comprimi',
    noActiveCampaignShort: 'Nessuna campagna attiva',
  },
  dataCollection: {
    allCampaigns: 'Tutte le campagne',
    myData: 'I Miei Dati',
    noCampaignsForYear: "Nessuna campagna trovata per l'anno selezionato",
    noAssignmentsForYear: "Nessun datapoint assegnato per l'anno selezionato",
    deadlinePrefix: 'Scadenza',
    yearPrefix: 'Anno',
    completedOf: '{{completed}}/{{total}} completati',
    colCode: 'Codice',
    colName: 'Nome',
    colStandard: 'Standard',
    colStatus: 'Status',
    colDeadline: 'Scadenza',
    colAction: 'Azione',
    fill: 'Compila',
    continue: 'Continua',
    loadingDetails: 'Caricamento...',
    noDescription: 'Nessuna descrizione disponibile per questo datapoint.',
    hideDetails: 'Nascondi dettagli',
    details: 'Dettagli',
    valueField: 'Valore',
    booleanYes: 'Sì',
    booleanNo: 'No',
    dateField: 'Data',
    notesOptional: 'Note (opzionale)',
    notesPlaceholder: 'Aggiungi note o metodologia utilizzata...',
    saveDraft: 'Salva bozza',
    submitForValidation: 'Invia per validazione',
    notAvailable: 'Dato non disponibile',
    notAvailableShort: 'Non disponibile',
    rejectionWarning: 'Questo dato è stato rimandato indietro dal validatore. Motivo:',
    comparisonCampaignValue: 'Valore campagna di raffronto',
    ownershipReview: {
      checkbox: "Non sono io l'owner di questo dato",
      suggestedOwner: 'Chi pensi sia l’owner? (nome o funzione)',
      suggestedOwnerHelper:
        'Facoltativo. Vale per questa campagna: la riga resta aperta finché non viene riassegnata.',
      report: 'Segnala',
      withdraw: 'Ritira segnalazione',
      viewReport: 'Vedi segnalazione',
      chip: 'Owner da rivedere',
      raisedBy: 'Segnalato da {{name}} il {{date}}',
      raisedByNoDate: 'Segnalato da {{name}}',
      suggested: 'Suggerito: {{name}}',
      openedByOther:
        '{{name}} aveva segnalato di non essere l’owner di questo dato (suggerito: {{suggested}}). Ora è assegnato a te: se il dato è tuo, compilalo normalmente.',
      perCountryBlocked:
        'Questo dato è raccolto per paese: il cambio owner non si può chiedere da qui. Per cambiarlo scrivi all’amministratore.',
    },
  },
  consolidation: {
    noDatapoints: 'Nessun datapoint per-country da consolidare per questo anno.',
    noDatapointsHelp: 'Il consolidamento è necessario solo quando i datapoint sono configurati in modalità "Per country" con più responsabili.',
    totalDatapoints: '{{count}} datapoint totali',
    consolidatedCount: '{{count}} consolidati',
    toConsolidate: '{{count}} da consolidare',
    consolidatedOfTotal: '{{consolidated}}/{{total}} consolidati',
    consolidated: 'Consolidato',
    draft: 'Bozza',
    toBeConsolidated: 'Da consolidare',
    adminModified: "Modificato dall'admin",
    main: '🌍 Principale',
    restore: 'Ripristina',
    exclude: 'Escludi',
    notRequired: 'Non richiesta',
    statusToCompile: 'Da compilare',
    statusDraft: 'Bozza',
    statusInValidation: 'In validazione',
    statusValidated: 'Validato',
    statusApproved: 'Approvato',
    consolidatedValue: 'Valore consolidato',
    consolidatedAnswer: 'Risposta consolidata',
    edit: 'Modifica',
    notes: 'Note',
    consolidatedBy: 'Consolidato da {{name}}',
    numericPlaceholder: 'Inserisci il valore finale del gruppo',
    textPlaceholder: 'Inserisci la risposta consolidata del gruppo...',
    notesPlaceholder: 'Note (opzionale)',
    saveDraft: 'Salva bozza',
    confirm: 'Conferma',
    confirmTitle: 'Conferma consolidamento',
    consolidatedValueLabel: 'Valore consolidato: ',
    confirmInfo: 'Una volta confermato, i datapoint delle country incluse verranno marcati come Validati.',
    yesConfirm: 'Sì, conferma',
    campaign: 'Campagna',
    campaignInfo: {
      ariaLabel: 'Informazioni sulla campagna',
      title: 'Dettagli campagna',
      description: 'Descrizione',
      noDescription: 'Nessuna descrizione',
      period: 'Periodo',
      year: 'Anno',
      deadline: 'Scadenza',
      notSet: 'Non impostata',
    },
  },
  campaignComparison: {
    empty: 'Questa campagna non ha una campagna di confronto impostata.',
    title: 'Confronto: {{current}} vs {{comparison}}',
    columns: { code: 'Codice', name: 'Datapoint', variation: 'Variazione' },
    filter: { all: 'Tutti', quantitative: 'Quantitativi', qualitative: 'Qualitativi' },
  },
  reportAssessment: {
    title: 'Report Assessment — Anno {{year}}',
    tabs: {
      progress: 'Progresso',
      datapoint: 'Datapoint',
      perCountry: 'Per Country',
      kpiChiave: 'KPI Chiave',
      compare: 'Confronto',
    },
    toolbar: {
      exportPdf: 'Esporta PDF',
      filterByStatus: 'Filtra per stato',
      allStatuses: 'Tutti',
      showArchived: 'Mostra chiuse',
      onlyNumeric: 'Solo numerici',
      search: 'Cerca datapoint',
      searchPlaceholder: 'Codice o nome…',
      clearSearch: 'Pulisci ricerca',
    },
    empty: {
      noCampaigns: "Nessuna campagna per l'anno selezionato.",
      noDatapoints: 'Nessun datapoint in questa campagna.',
      noSearchResults: 'Nessun datapoint corrisponde alla ricerca.',
      noActiveCampaign: 'Nessuna campagna attiva da mostrare.',
      noSnapshot: 'Snapshot non disponibile per questa milestone.',
    },
    campaign: {
      consolidated: 'Consolidati',
      compiled: 'Compilati',
      closeReport: 'Chiudi Report',
      completionPct: '{{pct}}% completato',
      countries: '{{count}} country',
      compiledOfTotal: '{{compiled}}/{{total}} compilati',
    },
    columns: {
      code: 'Codice',
      name: 'Nome',
      dataOwner: 'Data Owner',
      validatorConsolidator: 'Validatore / Consolidatore',
      status: 'Stato',
      value: 'Valore',
      action: 'Azione',
      standard: 'Standard',
    },
    actions: {
      read: 'Leggi ▸',
      editValueTooltip: 'Modifica valore (admin)',
    },
    drawer: {
      value: 'Valore',
      dataOwner: 'Data Owner',
      country: 'Country',
      notes: 'Note',
      consolidationNotes: 'Nota di consolidamento',
      compilationDate: 'Data compilazione',
      approvedBy: 'Approvato da',
      countryBreakdown: 'Dettaglio per country',
      main: 'Principale',
      excludedFromConsolidation: 'Escluso dal consolidamento',
      sourceDocuments: 'Documenti di fonte',
      documentUnavailable: 'Documento non più in libreria',
    },
    editDrawer: {
      title: 'Modifica — {{code}}',
      warning: 'La modifica imposta lo stato a "Modificato dall\'admin" e viene registrata nel log di audit.',
      valueField: 'Valore',
      valueFieldUnit: 'Valore ({{unit}})',
      currentValue: 'Valore attuale: {{value}}',
      notesField: 'Note',
      currentNotes: 'Note attuali: {{notes}}',
      methodologyField: 'Metodologia',
      confirmNa: 'Azzerare il valore e impostare come N/A?',
      yesMarkNa: 'Sì, segna N/A',
      markNa: 'Segna come N/A',
      save: 'Salva',
    },
    milestones: {
      historyTitle: 'Storico periodi',
      closedOnBy: 'Chiuso il {{date}} da {{name}}',
      completedAt: '{{pct}}% completato',
      typeQuarterly: 'Trimestrale',
      typeAnnual: 'Annuale',
      typeCustom: 'Personalizzato',
    },
    milestoneDialog: {
      title: 'Chiudi Report / Crea Milestone',
      campaignInfo: 'Campagna: {{name}} — Completamento attuale: {{pct}}% ({{consolidated}}/{{total}} consolidati)',
      typeLabel: 'Tipo milestone',
      typeQuarterly: 'Milestone trimestrale',
      typeAnnual: 'Chiusura annuale (blocca modifiche)',
      typeCustom: 'Milestone personalizzata',
      labelField: 'Etichetta (es. Q1 2026, Chiusura 2025)',
      annualWarning: 'La chiusura annuale blocca tutti i datapoint della campagna. Solo un amministratore potrà riaprire il report.',
    },
    messages: {
      editSuccess: 'Datapoint modificato con successo',
      editError: 'Errore durante il salvataggio. Riprova.',
      naSet: 'Datapoint impostato come N/A',
      naError: "Errore durante l'operazione. Riprova.",
      noFieldsError: 'Inserire almeno un campo da modificare',
      reportClosed: 'Report chiuso definitivamente',
      milestoneCreated: 'Milestone "{{label}}" creata',
      datapointNotFound: 'Datapoint con codice "{{code}}" non trovato nella campagna corrente.',
    },
    byCountry: {
      filter: 'Filtro',
      allCountries: 'Tutte le country',
      onlyConsolidated: 'Solo consolidati',
      onlyCentral: 'Solo dato centrale',
      activeFilter: 'Filtro attivo',
      noData: 'Nessun dato per country disponibile.',
      centralOnlyTitle: 'Solo dati centralizzati',
      centralOnlyDesc: 'La campagna <strong>{{name}}</strong> ha raccolto i datapoint come valore centralizzato di Gruppo, senza delega per country. La tab "Per Country" è utile quando lo stesso datapoint è delegato a responsabili in paesi diversi.',
      centralOnlyDescMulti: 'Le campagne selezionate hanno raccolto i datapoint come valore centralizzato di Gruppo, senza delega per country. La tab "Per Country" è utile quando lo stesso datapoint è delegato a responsabili in paesi diversi.',
      noSelection: 'Nessun datapoint per la selezione corrente.',
      consolidatedValue: 'Dato consolidato',
      centralValue: 'Dato centralizzato di Gruppo',
      collectedAsCentral: 'dato raccolto come centralizzato',
    },
  },
  reporting: {
    dmaOverviewSection: {
      totalIros: 'Totale IRO',
      totalIrosAria: 'Totale IRO: {{count}}',
      materialIros: 'IRO Materiali',
      materialIrosAria: 'IRO Materiali: {{count}} ({{percentage}}%)',
      ofTotal: 'del totale',
      materialProgressAria: '{{percentage}}% materiali',
      averageScore: 'Score Medio',
      averageScoreAria: 'Score Medio — Impact: {{impact}}, Financial: {{financial}}',
      esrsCoverage: 'Copertura ESRS',
      esrsCoverageAria: 'Copertura ESRS: {{count}} su 10 standard',
      standards: 'standard',
    },
    macroCategorySection: {
      score: 'Punteggio',
      scoreLower: 'punteggio',
      material: 'Materiale',
      notMaterial: 'Non materiale',
      impact: 'Impatto',
      riskOpp: 'Rischio/Opp.',
    },
    materialIrosSection: {
      typeImpact: 'Impatto',
      typeRisk: 'Rischio',
      typeOpportunity: 'Opportunità',
      horizonShort: 'Breve',
      horizonMedium: 'Medio',
      horizonLong: 'Lungo',
      stakeholderEmployees: 'Dipendenti',
      stakeholderCustomers: 'Clienti',
      stakeholderSuppliers: 'Fornitori',
      stakeholderInvestors: 'Investitori',
      stakeholderLocalCommunities: 'Comunità locali',
      stakeholderRegulators: 'Regolatori',
      stakeholderPartners: 'Partner',
      stakeholderOther: 'Altro',
      valueChainUpstream: 'A monte',
      valueChainOperations: 'Operazioni',
      valueChainDownstream: 'A valle',
      collapse: 'Comprimi',
      expand: 'Espandi',
      description: 'Descrizione',
      scores: 'Punteggi',
      scoreImpact: 'Impatto',
      scoreFinancial: 'Finanziario',
      scoreOverall: 'Complessivo',
      affectedStakeholders: 'Stakeholder interessati',
      valueChainPosition: 'Posizione catena del valore',
      emptyState: 'Nessun IRO materiale trovato per questo anno.',
      colCodeName: 'Codice / Nome',
      colType: 'Tipo',
      colEsrs: 'ESRS',
      colScore: 'Score',
      geographies: 'Geografie',
      horizon: 'Orizzonte',
      directionAsc: 'crescente',
      directionDesc: 'decrescente',
      caption: '{{count}} IRO materiali — ordinati per {{field}} ({{direction}})',
    },
    materialityMatrixSection: {
      iro: 'IRO',
      impact: 'Impatto',
      financial: 'Finanziario',
      material: 'Materiale',
      notMaterial: 'Non materiale',
      priority: 'Prioritario',
      impactScore: 'Punteggio di impatto',
      financialScore: 'Punteggio finanziario',
      iros: 'IRO',
      materials: 'Prioritari (entrambe le soglie)',
      watchList: 'Materiali (una soglia)',
      lowPriority: 'Non materiali',
      chartDescription: 'Matrice di materialità: {{total}} categorie su assi impatto (X) e finanziario (Y). {{material}} prioritarie, {{watch}} materiali su una sola soglia, {{low}} non materiali.',
      materialCategoriesAria_one: '{{count}} categoria prioritaria',
      materialCategoriesAria_other: '{{count}} categorie prioritarie',
      watchListCategoriesAria_one: '{{count}} categoria materiale su una soglia',
      watchListCategoriesAria_other: '{{count}} categorie materiali su una soglia',
      lowPriorityCategoriesAria_one: '{{count}} categoria non materiale',
      lowPriorityCategoriesAria_other: '{{count}} categorie non materiali',
    },
    reportingPage: {
      title: 'Report DMA',
      doubleMateriality: 'Doppia Materialità',
      generating: 'Generazione...',
      retry: 'Riprova',
      dmaOverview: 'Panoramica DMA',
      esrsMacroCategories: 'Macro-Categorie ESRS',
      materialityMatrix: 'Matrice di Materialità',
      materialIros: 'IRO Materiali',
    },
    reportPdf: {
      esrsStandards: 'Standard ESRS',
      notAssessed: 'Non valutato',
      generationDate: 'Data di generazione',
      lastConsolidation: 'Ultimo consolidamento dei punteggi',
      scoreRevisionsTitle: 'Revisioni dei punteggi',
      scoreRevisionsIntro: 'Punteggi rivisti dal team ESG dopo il consolidamento delle valutazioni, con la motivazione registrata in piattaforma. Nell\'elenco degli IRO sono indicati con †.',
      revisedMarker: '†',
      effectUnchanged: 'Materialità invariata',
      effectBecomesMaterial: 'Diventa materiale',
      effectBecomesNotMaterial: 'Diventa non materiale',
      dimensionImpact: 'Impatto',
      dimensionFinancial: 'Finanziario',
      colPrevious: 'Prima',
      colRevised: 'Dopo',
      colRationale: 'Motivazione',
      colDate: 'Data',
      colEffect: 'Effetto',
      adminAccount: 'account amministratore',
      stakeholdersSummaryWithAdmin: '{{stakeholders}} referenti interni e {{admins}} account amministratore hanno ricevuto {{assessments}} valutazioni da compilare, di cui {{completed}} completate.',
      reportTitle: 'Report DMA',
      year: 'Anno',
      dmaOverview: 'Panoramica DMA',
      totalIros: 'Totale IRO',
      materialIros: 'IRO Materiali',
      averageScore: 'Score Medio',
      esrsCoverage: 'Copertura ESRS',
      esrsMacroCategories: 'Macro-Categorie ESRS',
      material: 'Materiale',
      notMaterial: 'Non materiale',
      methodologyTitle: 'Metodologia di Doppia Materialità',
      whatIsDma: 'Cos\'è la Doppia Materialità?',
      whatIsDmaBody: 'L\'analisi di Doppia Materialità (DMA) valuta i temi ESG sotto due prospettive complementari, in conformità con gli standard ESRS previsti dalla direttiva CSRD:',
      impactMaterialityBullet: '• Impact Materiality (Inside-Out): gli impatti che l\'azienda genera sull\'ambiente e la società.',
      financialMaterialityBullet: '• Financial Materiality (Outside-In): i rischi e le opportunità ESG che influiscono sulla posizione finanziaria dell\'azienda.',
      orLogicNote: 'Un tema è materiale se raggiunge o supera almeno una delle due soglie, d\'impatto o finanziaria (logica OR); i temi che le raggiungono entrambe sono prioritari.',
      processFlowTitle: 'Flusso del Processo DMA',
      processStepSetup: 'Setup: configurazione dello scope di assessment (società, paesi, catena del valore, stakeholder, soglie di materialità). Generazione delle macro-categorie di valutazione.',
      processStepIroCreation: 'Creazione IRO: censimento degli impatti, rischi e opportunità (IRO) mappati ai 10 standard ESRS tematici (E1-E5, S1-S4, G1) e associati a macro-categorie.',
      processStepCampaign: 'Campagna di Assessment: creazione di campagne con selezione degli IRO da valutare, assegnazione degli stakeholder con pesi configurabili e tipo di assessment (impatto, finanziario, o entrambi).',
      processStepStakeholderAssessment: 'Valutazione Stakeholder: ogni stakeholder compila la propria valutazione su criteri di impatto (scala, ambito, irrimediabilità, probabilità) e/o criteri finanziari (probabilità, impatto economico-finanziario, reputazionale, operativo). Scala 1-4.',
      processStepConsolidation: 'Consolidamento: auto-consolidamento dopo ogni invio tramite media ponderata dei componenti. Calcolo di impactScore, financialScore e overallScore. Le soglie di materialità vengono applicate, e la decisione registrata, al ricalcolo della materialità.',
      processStepDashboard: 'Dashboard e Revisione: visualizzazione dei risultati aggregati nella matrice di materialità, con possibilità di forzare manualmente le decisioni di materialità e modificare le soglie.',
      processStepNextYear: 'Anno Successivo: clonazione selettiva dei dati nell\'anno successivo per confronto anno su anno.',
      iroClassificationTitle: 'Classificazione IRO',
      iroClassificationBody: 'Ogni elemento censito nel registro è un IRO (Impact, Risk, Opportunity), classificato per tipo:',
      iroImpactBullet: '• Impact: impatto dell\'azienda su ambiente/società (actual/potential, positive/negative)',
      iroRiskBullet: '• Risk: rischio ESG che incide sull\'azienda (physical, transition, systemic)',
      iroOpportunityBullet: '• Opportunity: opportunità ESG per l\'azienda (resource efficiency, products/services, markets, resilience, reputation)',
      iroScopeNote: 'Ogni IRO definisce il proprio perimetro: geografie, catena del valore (upstream/operations/downstream), orizzonte temporale (breve/medio/lungo) e stakeholder interessati.',
      scoringMethodologyTitle: 'Metodologia di Scoring',
      impactMaterialityScore: 'Impact Materiality Score',
      impactScoreBody: 'La valutazione di impatto utilizza 4 criteri su scala 1-4 (Minimo, Basso, Moderato, Alto):',
      impactScaleBullet: '• Scale: gravità dell\'impatto',
      impactScopeBullet: '• Scope: estensione (soggetti/ambiente coinvolti)',
      impactIrremediabilityBullet: '• Irremediability: difficoltà di rimedio (solo impatti negativi)',
      impactProbabilityBullet: '• Probability: probabilità di accadimento (nel ciclo corrente applicata a tutti gli impatti, effettivi e potenziali)',
      impactScoreFormula: 'Impatto negativo:  Severity = AVG(Scale, Scope, Irremediability)\nImpatto positivo:  Severity = AVG(Scale, Scope)\n\nImpatto effettivo e potenziale: impactScore = Severity x Probability\n\nRange: 1-16 (max = 4 x 4)',
      financialMaterialityScore: 'Financial Materiality Score',
      financialScoreBody: 'La valutazione finanziaria raccoglie 4 criteri su scala 1-4; il punteggio ne usa 3 (l\'Eco-Financial Impact è raccolto ma non entra nel calcolo):',
      financialLikelihoodBullet: '• Likelihood: probabilità (Remoto < 1%, Improbabile 1-10%, Possibile 10-50%, Molto probabile > 50%)',
      financialEcoBullet: '• Eco-Financial Impact: effetti su ARR, EBITDA, Cashflow (raccolto, non usato nel punteggio)',
      financialReputationalBullet: '• Reputational Impact: effetti su stakeholder e media',
      financialOperationalBullet: '• Operational Impact: conseguenze su processi e continuità',
      overallScoreTitle: 'Overall Score e Decisione di Materialità',
      thresholdsTitle: 'Soglie di Materialità',
      thresholdsBody: 'Un impatto è materiale se il suo punteggio d\'impatto raggiunge o supera la soglia d\'impatto; un rischio o un\'opportunità è materiale se il suo punteggio finanziario raggiunge o supera la soglia finanziaria. Le soglie sono fissate nella configurazione DMA di ciascun anno:',
      consolidationTitle: 'Consolidamento Multi-Stakeholder',
      consolidationBody: 'Quando più stakeholder valutano lo stesso IRO, il sistema consolida gli score tramite media ponderata dei singoli componenti. Ad ogni invio di un assessment, il sistema esegue automaticamente il consolidamento:',
      consolidationFormula: 'Per ogni criterio (es. scale, scope, likelihood):\n  media_ponderata = SUM(valore_i x peso_i) / SUM(peso_i)\n\nPoi si applicano le formule standard\ndi impactScore e financialScore.\n\noverallScore = MAX(impactScore, financialScore)',
      manualForceNote: 'È inoltre possibile forzare manualmente la decisione di materialità con un rationale obbligatorio, sovrascrivendo il calcolo automatico.',
      thematicEsrsTitle: 'Standard ESRS Tematici',
      thematicEsrsBody: 'Il sistema copre i 10 standard ESRS tematici: E1 (Cambiamento climatico), E2 (Inquinamento), E3 (Risorse idriche e marine), E4 (Biodiversità ed ecosistemi), E5 (Uso risorse ed economia circolare), S1 (Forza lavoro propria), S2 (Lavoratori nella catena del valore), S3 (Comunità interessate), S4 (Consumatori e utilizzatori finali), G1 (Condotta aziendale).',
      materialityMatrix: 'Matrice di Materialità',
      topics_one: 'topic',
      topics_other: 'topic',
      materialPlural: 'Materiali',
      priorityPlural: 'Prioritari',
      totalTopics: 'Totale topic',
      macroCategories: 'Macro-categorie',
      colCodeName: 'Codice / Nome',
      colType: 'Tipo',
      colGeographies: 'Geografie',
      colHorizon: 'Orizzonte',
      horizonShort: 'Breve',
      horizonMedium: 'Medio',
      horizonLong: 'Lungo',
      stakeholderEmployees: 'Dipendenti',
      stakeholderCustomers: 'Clienti',
      stakeholderSuppliers: 'Fornitori',
      stakeholderInvestors: 'Investitori',
      stakeholderLocalCommunities: 'Comunità locali',
      stakeholderRegulators: 'Regolatori',
      stakeholderPartners: 'Partner',
      stakeholderOther: 'Altro',
      interviewedStakeholders: 'Referenti interni coinvolti',
      stakeholdersSummary: '{{stakeholders}} referenti interni hanno ricevuto {{assessments}} valutazioni da compilare, di cui {{completed}} completate.',
      colName: 'Nome',
      colRole: 'Ruolo',
      coverTitle: 'Analisi di Doppia\nMaterialità',
      coverSubtitle: 'Valutazione degli Impatti, Rischi e Opportunità ESG',
      referenceYear: 'Anno di riferimento',
      issueDate: 'Data di emissione',
      confidentialDocument: 'Documento riservato — generato da TeamSystem Impact',
    },
    title: 'Report',
    csrd: 'Report CSRD',
    dnf: 'Dichiarazione Non Finanziaria',
    taxonomyReport: 'Report Tassonomia',
    executiveSummary: 'Executive Summary',
  },
  taxonomy: {
    title: 'Tassonomia Green EU',
    activities: 'Attività Economiche',
    assessment: 'Valutazione',
    kpi: 'KPI Tassonomia',
    eligible: 'Eligible',
    aligned: 'Aligned',
  },
  errors: {
    generic: 'Si è verificato un errore',
    network: 'Errore di connessione',
    unauthorized: 'Non autorizzato',
    forbidden: 'Accesso negato',
    notFound: 'Risorsa non trovata',
  },
  about: {
    title: 'Informazioni',
    version: 'Versione',
    buildDate: 'Data build',
    commit: 'Commit',
    changelog: 'Changelog',
    releaseTitle: 'Release corrente',
    accessibility: 'Accessibilità',
    wcagLevel: 'Livello WCAG',
    wcagBadge: 'AA — adeguamento ~90%',
    wcagDescription: 'La piattaforma raggiunge circa il 90% di adeguamento agli standard WCAG 2.1 Livello AA. Implementati: contrasto testo 4.5:1, navigazione completa da tastiera, indicatori di focus visibili, gerarchia heading semantica e attributi ARIA sui componenti interattivi. Percentuale stimata da audit statico interno; restano da completare alcuni punti minori (es. contrasto pieno dei bordi, notifiche persistenti) e il test dinamico con screen reader.',
    a11yLanguage: 'Lingua della pagina dichiarata (lang="it")',
    a11yStructure: 'Struttura semantica HTML con componenti MUI accessibili',
    a11yAria: 'Attributi ARIA su componenti principali',
    a11yKeyboard: 'Navigazione da tastiera completa con supporto Tab, Enter, Space',
    a11yFocus: 'Indicatori di focus visibili su tutti i componenti interattivi',
    a11yContrast: 'Contrasto testo conforme (4.5:1)',
    a11yHeadings: 'Gerarchia heading semantica (h1 → h2 → h3)',
    a11yLastAudit: 'Ultimo audit: 20 luglio 2026 — adeguamento ~90% ai criteri WCAG 2.1 AA (audit statico interno; test dinamico da completare)',
    changelogItems: {
      stakeholderAssessment: 'Sistema di assessment stakeholder con vista raggruppata per assessore',
      scoringAlgorithm: 'Algoritmo di scoring materialità (DMA 2025) con consolidamento admin',
      materialityDashboard: 'Dashboard materialità con pannello comparativo',
      catalogViews: '3 modalità di vista Catalogo IRO (ESRS, Macro Tema, Flat)',
      exportImport: 'Script export/import DMA e seed data',
      financialValidation: 'Fix validazione assessment finanziari consolidati',
      obsoleteCleanup: 'Pulizia assessment obsoleti in autoConsolidateIRO',
      documentation: 'Documentazione tecnica del processo DMA',
    },
  },
  ma: {
    pageTitle: 'Fascicoli M&A',
    confidentialityBanner:
      'Informazione riservata: acquisizioni non annunciate. Usa sempre il nome in codice e non condividere questi contenuti fuori dagli autorizzati.',
    noDeals: 'Non sei autorizzato a nessun fascicolo.',
    loadError: 'Non è stato possibile caricare i fascicoli. Riprova o segnala il problema.',
    dealNotFound: 'Fascicolo non trovato.',
    escalationOpen: 'Escalation aperta',
    redFlagCount_one: '{{count}} campanello d\'allarme',
    redFlagCount_other: '{{count}} campanelli d\'allarme',
    updatedAt: 'Aggiornato il {{date}}',
    severity: 'Gravità {{level}}',
    companySection: 'Dati del target',
    companyName: 'Azienda',
    companySector: 'Settore',
    companyProduct: 'Prodotto',
    companySize: 'Dimensione',
    companyCountry: 'Paese',
    escalationSection: 'Escalation all\'ESG Office',
    redFlagsSection: 'Campanelli d\'allarme',
    noRedFlags: 'Nessun campanello d\'allarme registrato.',
    conclusionsSection: 'Conclusioni del team ESG',
    noConclusions: 'Nessuna conclusione registrata.',
    actionPointsSection: 'Azioni suggerite',
    noActionPoints: 'Nessuna azione suggerita.',
    diarySection: 'Diario dei contatti',
    noTouchpoints: 'Nessun contatto registrato.',
    touchpointType: {
      questionario_ricevuto: 'Questionario ricevuto',
      call: 'Call',
      richiesta_dati: 'Richiesta dati',
      escalation: 'Escalation',
      nota: 'Nota',
    },
    learningSection: 'Apprendimento',
    briefing: 'Briefing consegnato',
    esgOfficeCorrection: 'Correzione dell\'ESG Office',
    outcome: 'Esito post-closing',
    outcomeMaterialized: 'Il rischio si è materializzato',
    outcomeNotMaterialized: 'Il rischio non si è materializzato',
  },
  engagement: {
    pageTitle: 'Stakeholder Engagement',
    navAria: 'Navigazione stakeholder engagement',
    tabCampaigns: 'Campagne',
    tabResponses: 'Risposte',
    campaigns: {
      title: 'Campagne',
      newCampaign: 'Nuova Campagna',
      tableAria: 'Tabella campagne',
      colName: 'Nome',
      colCategory: 'Categoria',
      colResponses: 'Risposte',
      colCreated: 'Data Creazione',
      colActions: 'Azioni',
      noCampaigns: 'Nessuna campagna presente',
      statusActive: 'Attiva',
      statusClosed: 'Chiusa',
      closeCampaignAria: 'Chiudi campagna {{name}}',
      reopenCampaignAria: 'Riapri campagna {{name}}',
      name: 'Nome',
      description: 'Descrizione',
      categoryAria: 'Categoria stakeholder',
      assessmentYear: 'Anno di valutazione',
      cancel: 'Annulla',
      create: 'Crea',
      categories: {
        dipendenti: 'Dipendenti',
        investitori: 'Investitori',
        clienti: 'Clienti',
        fornitori: 'Fornitori',
        comunita_locali: 'Comunita locali',
        regolatori: 'Regolatori',
        ong: 'ONG',
        sindacati: 'Sindacati',
        altro: 'Altro',
      },
    },
    entries: {
      totalResponses: 'Risposte totali',
      last7Days: 'Ultimi 7 giorni',
      last30Days: 'Ultimi 30 giorni',
      filterByCampaignAria: 'Filtra per campagna',
      allCampaigns: 'Tutte le campagne',
      tableAria: 'Tabella risposte stakeholder',
      colUser: 'Utente',
      colComment: 'Commento',
      colDate: 'Data',
      colSource: 'Fonte',
      colAgent: 'Agente',
      noResponses: 'Nessuna risposta trovata',
      rowsPerPage: 'Righe per pagina:',
    },
  },
  connections: {
    title: 'Connessioni AI',
    oauthClients: 'Sistemi Connessi',
    noClients: 'Nessun sistema AI connesso. I client OAuth vengono registrati automaticamente quando un sistema esterno si connette.',
    revokeClient: 'Revoca client',
    revokeConfirm: 'Sei sicuro di voler revocare questo client OAuth? Il sistema non potra\' piu\' accedere alla piattaforma.',
    clientId: 'Client ID',
    registeredOn: 'Registrato il',
  },
};

// Traduzioni inglesi
export const translationsEN = {
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    close: 'Close',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
  },
  consent: {
    subtitle: 'wants to access TeamSystem Impact',
    actingAs: 'Will access as:',
    destination: 'The authorization will be delivered to:',
    scopesUnrecognised: 'The permissions requested by this application do not exist in the platform: this is not a limitation of your role. Report it to whoever configured it.',
    willBeAbleTo: 'It will be able to:',
    authorize: 'Authorize',
    authorizing: 'Authorizing...',
    deny: 'Cancel',
    loading: 'One moment...',
    unknownClient: 'AI client',
    invalidRequest: 'Incomplete or invalid access request.',
    errorLoading: 'Unable to read the access request.',
    errorAuthorizing: 'Authorization failed. Please try again.',
    nothingToGrant: 'Your role does not allow any of the requested permissions, so there is nothing to authorize.',
    someDenied: 'Some requested permissions are not included, because your role does not allow them.',
    scopes: {
      'dma:read': 'Read the double materiality assessment (topics, IROs, ratings)',
      'dma:write': 'Change the double materiality assessment',
      'datacapture:read': 'Read collected data and campaign progress',
      'datacapture:write': 'Enter and change collected data',
      'datacapture:config': 'Configure data collection (roles, campaigns, assignments)',
      'pm:read': 'Read tasks and activities',
      'pm:write': 'Create and update tasks',
      'engagement:read': 'Read stakeholder questionnaires',
      'engagement:write': 'Submit questionnaire answers',
      'admin:read': 'Read master data and administrative views',
      'ma:write': 'Write into M&A deal records',
      unknown: 'Unrecognised permission',
    },
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    loginWithMicrosoft: 'Login with Microsoft',
    welcome: 'Welcome to TeamSystem Impact',
    loggingIn: 'Logging in...',
    loginError: 'Authentication error',
    sessionExpired: 'Session expired. Please login again.',
    tagline: 'ESG platform for CSRD compliance. Double materiality, data collection and ESRS reporting in one tool.',
    allRightsReserved: 'All rights reserved',
    loginErrorMicrosoft: 'Error during Microsoft login',
  },
  header: {
    subtitle: 'ESG & CSRD Platform',
    profile: 'Profile',
    openMenu: 'Open navigation menu',
    toggleLight: 'Switch to light mode',
    toggleDark: 'Switch to dark mode',
    userMenu: 'User account menu',
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome, {{name}}',
    overview: 'ESG management and CSRD compliance overview',
    esgScore: 'ESG Score',
    completamento: 'Completion',
    materiality: 'Materiality',
    materialitySubtitle: 'Material topics',
    dataCapture: 'Data Capture',
    dataCaptureSubtitle: 'Datapoints completed',
    reporting: 'Reporting',
    reportStatus: 'In Review',
    reportDeadline: 'Deadline: 31/03/2025',
    taxonomy: 'EU Taxonomy',
    availableModules: 'Available Modules',
    doubleMateriality: 'Double Materiality',
    doubleMaterialityDesc: 'IRO assessment and materiality matrix',
    dataMultiCountry: 'Multi-Country Data Capture',
    dataMultiCountryDesc: 'ESRS data collection with country delegation',
    executiveDashboard: 'Executive Dashboard',
    executiveDashboardDesc: 'Aggregated ESG KPIs for C-level',
    taxonomyModule: 'EU Green Taxonomy',
    taxonomyModuleDesc: 'Eligibility, alignment and Art. 8 KPIs',
    esrsStandards: 'ESRS Standards',
    available: 'Available',
    comingSoon: 'Coming Soon',
    dmaCompleted: 'Completed',
    dmaInProgress: 'In progress',
    contributorSubtitle: 'Your activities on Impact for year {{year}}',
    unreadTitle: 'New notifications',
    openInbox: 'Open inbox',
    allRead: 'Nothing new',
    datapointsToFill: 'Datapoints to fill in',
    goToCollection: 'Go to Capture',
    datapointsToValidate: 'Datapoints to validate',
    goToValidation: 'Go to Validation',
    datapointsToConsolidate: 'Datapoints to consolidate',
    goToConsolidation: 'Go to Consolidation',
    dmaAssessments: 'DMA Assessments',
    openYourAssessments: 'Open your assessments',
    noAssignments: 'You have no activities assigned for year {{year}}. You\'ll be notified when datapoints or assessments are assigned.',
    totalIros: 'Total IROs',
    yearLabel: 'Year {{year}}',
    assessmentTitle: 'Assessment',
    irosAssessed: 'IROs assessed',
    path: {
      heading: 'The breath of compliance',
      subheading: 'Year {{year}} · TeamSystem Impact',
      statusNotStarted: 'Not started',
      statusInProgress: 'In progress',
      statusCompleted: 'Completed',
      engagement: 'Stakeholder Engagement',
      engagementDesc: 'Listening to stakeholders',
      dma: 'Double Materiality',
      dmaDesc: 'Impact and financial assessment',
      collection: 'Data Collection',
      collectionDesc: 'Compilation of sustainability datapoints',
      reporting: 'Reporting',
      reportingDesc: 'Publishing the disclosure',
      comingSoon: 'Coming soon',
      chipCampaigns: '{{n}} campaigns',
      chipResponses: '{{n}} responses',
      chipMaterialIros: '{{n}} material IRO',
      chipAreas: '{{n}} material macro areas',
      chipDatapoints: '{{n}} datapoints',
      chipFrameworks: '{{n}} frameworks',
      chipOverdue: '{{n}} overdue',
      openFullScreen: 'Open full screen',
      engCampaigns: 'Campaigns this year',
      engResponses: 'Responses collected',
      engCampaignsList: 'Campaigns',
      engOpenModule: 'Open Engagement',
      engEmpty: 'No engagement campaigns for this year.',
      dmaTotal: 'Total IROs',
      dmaMaterial: 'Material IROs',
      dmaAreas: 'Macro areas',
      dmaTopAreas: 'Most material macro-areas',
      dmaOpenMatrix: 'Open the materiality matrix',
      colReports: 'Collection reports',
      colDatapoints: 'datapoints',
      colCompleted: 'filled in',
      colOpenModule: 'Open Collection',
      colEmpty: 'No collection reports for this year.',
      colReportKpis: 'Key KPIs',
      colCompiled: 'Compiled',
      colValidated: 'Validated',
      colOpenReport: 'Go to Report Assessment',
    },
  },
  navigation: {
    dashboard: 'Dashboard',
    dma: 'Double Materiality',
    dma_full: 'Double Materiality Assessment',
    dma_catalog: 'IRO Catalog',
    dma_assessment: 'Assessment',
    dma_campaigns: 'Campaigns',
    dma_materiality: 'Materiality',
    dma_matrix: 'Materiality Matrix',
    dma_settings: 'Year Settings',
    dma_report: 'DMA Report',
    materiality: 'Double Materiality',
    data: 'Data',
    data_configuration: 'Configuration',
    data_collection: 'Capture',
    data_validation: 'Validation',
    data_roles: 'Data Capture Roles',
    data_report_assessment: 'Assessment Report',
    data_documents: 'Library',
    dataCapture: 'Data Capture',
    reporting: 'Reports',
    reporting_reports: 'Reports',
    reporting_csrd: 'CSRD Reports',
    reporting_executive: 'Executive Summary',
    taxonomy: 'EU Taxonomy',
    taxonomy_overview: 'Overview',
    taxonomy_activities: 'Economic Activities',
    ma: 'M&A',
    inbox: 'Notifications',
    engagement: 'Engagement',
    agent_tokens: 'Agent Token',
    settings: 'Settings',
    settings_info: 'About',
    settings_year_management: 'Year Management',
    settings_connections: 'AI Connections',
    settings_sustainability: 'Sustainable Platform',
    settings_users: 'User Management',
    users: 'Users',
    audit: 'Audit Trail',
    menuTitle: 'Navigation',
    closeMenu: 'Close navigation',
    skipToContent: 'Skip to main content',
  },
  notifications: {
    title: 'Notifications',
    markAllRead: 'Mark all as read',
    empty: 'No notifications',
    emptyDesc: 'When you receive new notifications, they will appear here.',
    justNow: 'Just now',
  },
  materiality: {
    title: 'Double Materiality',
    iroAssessment: 'IRO Assessment',
    stakeholders: 'Stakeholders',
    matrix: 'Materiality Matrix',
    impacts: 'Impacts',
    risks: 'Risks',
    opportunities: 'Opportunities',
  },
  dma: {
    setupWizard: {
      assessmentYear: 'Assessment Year',
      groupCompanies: 'Group Companies',
      geographies: 'Geographies',
      valueChain: 'Value Chain',
      stakeholders: 'Stakeholders',
      naceCodes: 'NACE Codes',
      review: 'Review',
      assessmentYearTitle: 'Assessment Year',
      assessmentYearDesc: 'Select the reference year for the materiality assessment.',
      year: 'Year',
      groupCompaniesTitle: 'Group Companies',
      groupCompaniesDesc: 'Add companies included in the reporting perimeter.',
      companyName: 'Company Name',
      country: 'Country',
      consolidated: 'Consolidated',
      parentCompany: 'Parent Company',
      add: 'Add',
      name: 'Name',
      yes: 'Yes',
      no: 'No',
      noCompanyAdded: 'No company added',
      geographiesTitle: 'Active Geographies',
      geographiesDesc: 'Select the countries where the organization operates.',
      valueChainTitle: 'Value Chain',
      valueChainDesc: 'Select the value chain positions relevant for the assessment.',
      stakeholdersTitle: 'Stakeholder Categories',
      stakeholdersDesc: 'Select the stakeholder categories relevant for the organization.',
      naceCodesTitle: 'NACE Codes',
      naceCodesDesc: "Add the NACE codes for the organization's economic activities.",
      naceCode: 'NACE Code',
      naceExample: 'e.g. 62.01',
      description: 'Description',
      primary: 'Primary',
      code: 'Code',
      noNaceAdded: 'No NACE code added',
      reviewTitle: 'Configuration Review',
      completeness: 'Completeness',
      notes: 'Notes (optional)',
      cancel: 'Cancel',
      back: 'Back',
      next: 'Next',
      saveChanges: 'Save Changes',
      createSetup: 'Create Setup',
      editDmaSetup: 'Edit DMA Setup',
      newDmaSetup: 'New DMA Setup',
      saveError: 'Error while saving',
      italy: 'Italy',
      spain: 'Spain',
      france: 'France',
      switzerland: 'Switzerland',
      albania: 'Albania',
      denmark: 'Denmark',
      turkey: 'Turkey',
      israel: 'Israel',
      upstream: 'Upstream',
      operations: 'Own Operations',
      downstream: 'Downstream',
      upstreamDesc: 'Suppliers, raw materials, procurement',
      operationsDesc: 'Production, services, operational sites',
      downstreamDesc: 'Distribution, customers, end of life product',
      employees: 'Employees',
      customers: 'Customers',
      suppliers: 'Suppliers',
      investors: 'Investors',
      localCommunities: 'Local Communities',
      regulators: 'Regulators',
      partners: 'Partners',
      other: 'Other',
    },
    assessmentPrepareDialog: {
      prepareAssessment: 'Prepare Assessment',
      selectStakeholder: 'Select Stakeholder',
      selectIros: 'Select IROs',
      sendOptions: 'Send Options',
      confirm: 'Confirm',
      targetStakeholder: 'Target Stakeholder',
      searchStakeholder: 'Search internal stakeholder...',
      noStakeholderSelected: 'No stakeholder selected',
      stakeholderRole: 'Role',
      stakeholderAreas: 'Areas of expertise',
      autoIncludeAssigned: 'Include IROs with assigned stakeholder',
      autoIncludeAssignedHint: 'Automatically pre-select IROs where this stakeholder is among the assigned assessors',
      irosAlreadyAssigned: 'IROs already assigned to this stakeholder',
      irosNotAssigned: 'IROs not yet assigned',
      code: 'Code',
      name: 'Name',
      esrsArea: 'ESRS Area',
      type: 'Type',
      status: 'Status',
      campaign: 'Campaign',
      noAssignedIros: 'No IROs already assigned to this stakeholder',
      noUnassignedIros: 'All IROs are already assigned',
      selectedIros: 'Selected IROs',
      loadingAssignments: 'Loading assignments...',
      newCount: 'new',
      sendTo: 'Send to',
      sendToStakeholder: 'Send to the stakeholder',
      sendToEmail: 'Send to a specific email address',
      fillOnBehalf: 'Fill on behalf of the stakeholder',
      fillOnBehalfHint: 'You will directly fill the assessment on behalf of the selected stakeholder',
      emailRecipient: 'Email Address',
      emailRecipientName: 'Recipient Name',
      viewpointNote: 'The email recipient will provide a viewpoint but does not represent the stakeholder.',
      assessmentType: 'Assessment Type',
      impact: 'Impact Only',
      financial: 'Financial Only',
      both: 'Both',
      deadline: 'Deadline',
      notes: 'Notes for assessor',
      summary: 'Assessment Summary',
      willBeSentTo: 'Will be sent to',
      willFillDirectly: 'You will directly fill the assessment on behalf of',
      viaEmail: 'via email',
      irosToAssess: 'IROs to assess',
      cancel: 'Cancel',
      back: 'Back',
      next: 'Next',
      createAndSend: 'Create and Send',
      createDraft: 'Save as Draft',
      fillNow: 'Fill now',
      selectAtLeastOneIro: 'Select at least one IRO',
      enterValidEmail: 'Enter a valid email address',
      errorCreating: 'Error creating assessment',
      emailRecipientViewpoint: 'Email recipient (viewpoint)',
    },
    campaignDetail: {
      campaignNotFound: 'Campaign not found',
      statusDraft: 'Draft',
      statusActive: 'Active',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
      statusPending: 'Pending',
      statusInProgress: 'In Progress',
      irosInCampaign: 'IROs in Campaign',
      assignedStakeholders: 'Assigned Stakeholders',
      completion: 'Completion',
      proposalsToReview: 'Proposals to Review',
      stakeholder: 'Stakeholder',
      iroProposals: 'IRO Proposals',
      proposeNewIro: 'Propose New IRO',
      code: 'Code',
      name: 'Name',
      esrsArea: 'ESRS Area',
      type: 'Type',
      status: 'Status',
      actions: 'Actions',
      impact: 'Impact',
      risk: 'Risk',
      opportunity: 'Opportunity',
      assess: 'Assess',
      view: 'View',
      date: 'Date',
      description: 'Description',
      rationale: 'Rationale',
      assignStakeholder: 'Assign Stakeholder',
      email: 'Email',
      assessmentType: 'Assessment Type',
      progress: 'Progress',
      noStakeholderAssigned: 'No stakeholders assigned',
      financial: 'Financial',
      both: 'Both',
      pending: 'Pending',
      completed: 'Completed',
      noProposals: 'No proposals to review',
      proposedBy: 'Proposed by',
      suggestedName: 'Suggested Name',
      review: 'Review',
      assignTitle: 'Assign Stakeholder to Campaign',
      selectUser: 'Select User',
      instructions: 'Instructions (optional)',
      cancel: 'Cancel',
      assign: 'Assign',
      reviewProposal: 'Review IRO Proposal',
      notes: 'Notes (optional)',
      reject: 'Reject',
      approve: 'Approve',
      filterByAssessment: 'Filter by Assessments',
      allIros: 'All IROs',
      assessed: 'Assessed',
      notAssessed: 'Not Assessed',
      assessments: 'Assessments',
      assessedBy: 'Assessed by',
      noAssessments: 'No assessments',
      closeAssessment: 'Close Assessment',
      closeAssessmentConfirm: 'Are you sure you want to close your assessment? You will not be able to modify your assessments.',
      reopenAssessment: 'Reopen',
      cancelAssessment: 'Cancel',
      assessmentClosed: 'Your assessment is closed',
      viewOnly: 'View only',
      cancelled: 'Cancelled',
    },
    iroDetail: {
      backToList: 'Back to list',
      back: 'Back',
      iroNotFound: 'IRO not found',
      invalidIroId: 'Invalid IRO ID',
      edit: 'Edit',
      submitForValidation: 'Submit for Validation',
      reject: 'Reject',
      validate: 'Validate',
      approveMateriality: 'Approve Materiality',
      details: 'Details',
      materialityAssessment: 'Materiality Assessment',
      multiStakeholder: 'Multi-Stakeholder',
      auditTrail: 'Audit Trail',
      statusDraft: 'Draft',
      statusInValidation: 'In Validation',
      statusValidated: 'Validated',
      statusMaterial: 'Material',
      statusNotMaterial: 'Not Material',
      scale1: '1 - Minimum',
      scale2: '2 - Low',
      scale3: '3 - Medium',
      scale4: '4 - High',
      likelihood1: '1 - Remote (<1%)',
      likelihood2: '2 - Unlikely (1-10%)',
      likelihood3: '3 - Possible (10-50%)',
      likelihood4: '4 - Very Likely (>50%)',
      rm1: '1 - Initial (no processes)',
      rm2: '2 - Managed (partial processes)',
      rm3: '3 - Optimized (best practices)',
      iroType: 'IRO Type',
      esrsArea: 'ESRS Area',
      subTopic: 'Sub-Topic',
      description: 'Description',
      relatedTopics: 'Related Topics',
      impactMateriality: 'Impact Materiality',
      financialMateriality: 'Financial Materiality',
      score: 'Score',
      assessImpact: 'Assess Impact',
      assessFinancial: 'Assess Financial',
      notAssessed: 'Not yet assessed',
      scale: 'Scale',
      scope: 'Scope',
      irremediability: 'Irremediability',
      probability: 'Probability',
      likelihood: 'Occurrence Likelihood',
      ecoFinancialImpact: 'Economic-Financial Impact',
      reputationalImpact: 'Reputational Impact',
      operationalImpact: 'Operational Impact',
      rmMaturityLevel: 'Risk Management Maturity',
      notes: 'Notes',
      cancel: 'Cancel',
      save: 'Save',
      materialityDecision: 'Materiality Decision',
      material: 'Material',
      notMaterial: 'Not Material',
      approvingOrgan: 'Approving Organ',
      rationale: 'Rationale',
      rejectReason: 'Rejection Reason',
      approve: 'Approve',
      macroCategory: 'Macro-category',
      macroCategoryNone: 'Not assigned',
      descriptionLabel: 'Description',
      timeHorizon: 'Time Horizon',
      shortTerm: 'Short term',
      mediumTerm: 'Medium term',
      longTerm: 'Long term',
      riskType: 'Risk Type',
      opportunityType: 'Opportunity Type',
      impactNature: 'Impact Nature',
      actual: 'Actual',
      potential: 'Potential',
      impactDirection: 'Impact Direction',
      positive: 'Positive',
      negative: 'Negative',
      geographies: 'Geographies',
      valueChain: 'Value Chain',
      affectedStakeholders: 'Affected Stakeholders',
      impactMaterialityTitle: 'Impact Materiality',
      financialMaterialityTitle: 'Financial Materiality',
      modifyBtn: 'Modify',
      compileBtn: 'Fill in',
      overallScores: 'Overall Scores',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      overallScore: 'Overall Score',
      materialChip: 'MATERIAL',
      notMaterialChip: 'NOT MATERIAL',
      consolidatedScoresTitle: 'Consolidated Scores (Multi-Stakeholder)',
      fromAssessments: 'from assessments',
      consolidatedOn: 'Consolidated on',
      noConsolidatedScores: 'No consolidated scores available. Scores will be calculated automatically when stakeholders complete their assessments.',
      assessorsConfigured: 'assessors configured for this IRO',
      scoresConsolidatedOn: 'Scores consolidated on',
      configure: 'Configure',
      multiStakeholderNotConfigured: 'Multi-Stakeholder Assessment Not Configured',
      addAssessorsToEnable: 'Add assessors to enable multi-stakeholder assessment for this IRO.',
      usePanelToAdd: 'Use the "Configured Assessors" panel above to add assessors.',
      dateTime: 'Date/Time',
      user: 'User',
      action: 'Action',
      field: 'Field',
      previousValue: 'Previous Value',
      newValue: 'New Value',
      noAuditLog: 'No activity recorded.',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      deleteConfirmMsg: 'Are you sure you want to delete the IRO',
      deleteWarning: 'This action cannot be undone.',
      deleteNonDraftWarning: 'This IRO is not in draft status. Deleting it will permanently remove all associated assessment and validation data.',
      adjustedChip: 'Adjusted',
      adjustScores: 'Adjust scores',
      removeAdjustment: 'Remove adjustment',
      adjustedBy: 'Adjusted by',
      adjustedAt: 'Adjusted on',
      adjustmentRationale: 'Rationale',
      originalScores: 'Original scores',
      adjustmentHistory: 'Adjustment history',
      removed: 'Removed',
      by: 'by',
    },
    dataCapturePanel: {
      csrdDataCollection: 'CSRD Data Collection',
      newDataPoint: 'New Data Point',
      editDataPoint: 'Edit Data Point',
      toCompile: 'To compile',
      draft: 'Draft',
      inValidation: 'In validation',
      validated: 'Validated',
      approved: 'Approved',
      numeric: 'Quantitative',
      text: 'Qualitative',
      boolean: 'Yes/No',
      date: 'Date',
      file: 'File',
      selection: 'Selection',
      annual: 'Annual',
      semiAnnual: 'Semi-annual',
      quarterly: 'Quarterly',
      monthly: 'Monthly',
      oneTime: 'One-time',
      total: 'Total',
      completed: 'Completed',
      completion: 'Completion',
      code: 'Code',
      name: 'Name',
      esrs: 'ESRS',
      type: 'Type',
      value: 'Value',
      status: 'Status',
      actions: 'Actions',
      rowsPerPage: 'Rows per page',
      insert: 'Insert',
      insertValue: 'Insert value',
      editValue: 'Edit value',
      submitForValidation: 'Submit for validation',
      validate: 'Validate',
      reject: 'Reject',
      approve: 'Approve',
      editDefinition: 'Edit definition',
      delete: 'Delete',
      save: 'Save',
      saveValue: 'Save Value',
      cancel: 'Cancel',
      search: 'Search...',
      all: 'All',
      esrsStandard: 'ESRS Standard',
      none: 'None',
      description: 'Description',
      esrsDisclosure: 'ESRS Disclosure',
      esrsDisclosurePlaceholder: 'e.g. E1-6',
      dataType: 'Data Type',
      unit: 'Unit of Measure',
      unitPlaceholder: 'e.g. tCO2eq, MWh, EUR',
      frequency: 'Frequency',
      deadline: 'Deadline',
      dataOwner: 'Data Owner',
      emailDataOwner: 'Data Owner Email',
      required: 'Required',
      mandatoryEsrs: 'Mandatory ESRS',
      quantitative: 'Quantitative',
      notes: 'Notes',
      methodology: 'Calculation methodology',
      methodologyHelper: 'Describe how this data was calculated or collected',
      noDataPointFound: 'No data point found',
      confirmDelete: 'Are you sure you want to delete this data point?',
      rejectReason: 'Rejection reason:',
      loadError: 'Error loading',
      saveError: 'Error saving',
      deleteError: 'Error deleting',
      saveValueError: 'Error saving value',
      operationError: 'Operation error',
      yes: 'Yes',
      no: 'No',
      e1: 'E1 - Climate Change',
      e2: 'E2 - Pollution',
      e3: 'E3 - Water Resources',
      e4: 'E4 - Biodiversity',
      e5: 'E5 - Circular Economy',
      s1: 'S1 - Own Workforce',
      s2: 'S2 - Value Chain Workers',
      s3: 'S3 - Affected Communities',
      s4: 'S4 - Consumers and Users',
      g1: 'G1 - Business Conduct',
      valueLabel: 'Value',
      dateLabel: 'Date',
    },
    methodologyInfo: {
      valuesTitle: 'What the values mean',
    },
    methodology: {
      pageTitle: 'Methodology Note — Double Materiality Assessment {{year}}',
      exportPdf: 'Export PDF',
      generating: 'Generating...',
      pdfHeaderLabel: 'TEAMSYSTEM S.P.A. — INTERNAL DOCUMENT',
      pdfDocTitle: 'Methodology Note\nDouble Materiality Assessment {{year}}',
      pdfFooter: 'TeamSystem S.p.A. · DMA Methodology Note {{year}} · Generated on {{date}}',
      pdfFileName: 'dma-methodology-note',
      colFunction: 'Function',
      colContacts: 'Contacts',
      colTopic: 'TeamSystem Topic',
      colDescription: 'Description',
      s1Title: '1. Introduction',
      s1p1: 'This methodology note describes the process adopted by TeamSystem S.p.A. (hereinafter “TeamSystem”) for updating the Double Materiality Assessment (DMA) for the {{year}} financial year.',
      s1p2: 'The double materiality assessment was first conducted in 2024, with the support of external consultants (ERM), and led to the identification of a structured set of impacts, risks and opportunities (hereinafter “IROs”) material to the Group. In 2025, TeamSystem internalised the process, entrusting it to the in-house ESG and Impact Team under the methodological supervision of ERM, thereby ensuring continuity with the previous year’s approach while progressively strengthening internal capabilities.',
      s1p3: 'The {{year}} assessment has a twofold objective:',
      s1Bullets: 'to update the assessment of the IROs already identified in 2024, in light of developments in the internal and external context;\nto incorporate any new impacts, risks and opportunities that emerged during the year.',
      s2Title: '2. Regulatory and methodological framework',
      s2p1: 'The assessment is conducted in compliance with the requirements set out by the regulations in force on sustainability reporting, with particular reference to:',
      s2Bullets: 'Legislative Decree No. 125 of 6 September 2024, which transposes Directive (EU) 2022/2464 (CSRD) into Italian law;\nDirective (EU) 2022/2464 of the European Parliament and of the Council on corporate sustainability reporting;\nCommission Delegated Regulation (EU) 2023/2772, which supplements Directive 2013/34/EU with sustainability reporting standards (ESRS);\nEFRAG IG 1: Implementation Guidance on the materiality assessment;\nEFRAG IG 2: Implementation Guidance on the value chain.',
      s3Title: '3. The principle of Double Materiality',
      s3p1: 'The principle of double materiality, introduced by the CSRD, provides that a sustainability matter may be relevant from an impact perspective, from a financial perspective, or from both:',
      s3ImpactTitle: 'Impact materiality (Inside-out)',
      s3ImpactBody: 'A matter is material from an impact perspective when it concerns the actual or potential effects, positive or negative, that TeamSystem generates on people and/or the environment over the short, medium or long term.',
      s3FinancialTitle: 'Financial materiality (Outside-in)',
      s3FinancialBody: 'A matter is material from a financial perspective when it generates risks and/or opportunities that have, or could reasonably be expected to have, a material influence on TeamSystem’s development, financial position, financial performance, cash flows, access to finance or cost of capital.',
      s4Title: '4. {{year}} update process',
      s4StartTitle: 'Starting point: the 2024 IRO list',
      s4StartBody: 'The {{year}} process started from the list of IROs identified and validated during the previous assessment. This list was used as the basis for collecting updated assessments from internal stakeholders, ensuring consistency and comparability over time.',
      s4InvolveTitle: 'Engagement of internal stakeholders',
      s4InvolveBody: 'To collect updated assessments and identify any new matters, TeamSystem involved the heads of the main corporate functions through a structured survey process. The functions involved were:',
      s4Functions: 'Legal and Compliance Department\nCyber Security\nProcurement and Supply Chain\nResearch and Development (R&D)\nMergers & Acquisitions\nMarketing\nSales and Commercial\nHuman Resources\nFacility Management\nInternational HR\nDigital Impact',
      s4After1: 'Each contact was sent a structured questionnaire, accompanied by supporting information material. For those who requested it, completion was facilitated through a direct meeting with the ESG team, with the aim of ensuring the quality and completeness of the responses.',
      s4After2: 'In addition to assessing the IROs within their remit, function heads were asked to report any new matters that emerged during {{year}} and relevant to their area.',
      s5Title: '5. Structure and content of the surveys',
      s5Intro: 'The surveys were structured into three main sections, corresponding to the three types of IRO analysed.',
      s5ImpactsTitle: 'Impacts',
      s5ImpactsBody: 'Impacts represent the effects that TeamSystem has, or could have, on people and the environment. They can be actual or potential, positive or negative, and are located along the value chain (upstream, operations, downstream). For each impact, respondents provided a numerical assessment on a 1–4 scale against the following criteria:',
      s5ImpactsBullets: 'Scale: the magnitude or intensity of the impact — how strong is the effect?\nScope: the breadth of the effect — how many and which stakeholders are involved?\nIrremediability: how irreversible and permanent the impact and its effects are (applicable exclusively to negative impacts).\nLikelihood: how likely is it that the impact will materialise within the reference time horizon?',
      s5RisksTitle: 'Risks',
      s5RisksBody: 'Risks identify the matters that, from a financial, reputational or operational perspective, have or could have significant effects on TeamSystem. For each risk, respondents provided an assessment on a 1–4 scale against the following criteria:',
      s5RisksBullets: 'Operational Impact: how much the matter can affect TeamSystem’s processes, resources or operating activities?\nReputational Impact (negative): how much it can negatively affect the reputation, image and trust of stakeholders?\nEconomic-Financial Impact: what effects can it have on revenues, EBITDA and cash flows? (collected, not used in the score: see §10)\nLikelihood: how likely is it that the risk will materialise within the reference time horizon?',
      s5OppTitle: 'Opportunities',
      s5OppBody: 'Opportunities identify the matters that could generate benefits for TeamSystem from an operational, reputational or financial perspective. For each opportunity, respondents provided an assessment on a 1–4 scale against the following criteria:',
      s5OppBullets: 'Operational Impact: how much the matter can generate improvements in TeamSystem’s processes, resources or operating activities?\nReputational Impact (positive): how much it can improve the reputation, image and trust of stakeholders?\nEconomic-Financial Impact: what effects can it have on revenues, EBITDA and cash flows? (collected, not used in the score: see §10)\nLikelihood: how likely is it that the opportunity will materialise within the reference time horizon?',
      s6Title: '6. Score calculation',
      s6AggTitle: 'Aggregation of assessments',
      s6AggBody: 'For each IRO assessed by more than one function, the scores were aggregated by calculating, for each criterion, the mean of the assessments received, weighted by the weight assigned to each assessor (with equal weights this is the arithmetic mean). This approach ensures that the final assessment reflects the overall view of the organisation, balancing the different functional perspectives.',
      s6ImpactsTitle: 'Impacts',
      s6ImpactsBody: 'Severity is calculated as the average of Scale, Scope and — for negative impacts only — Irremediability. The final score is obtained by multiplying severity by Likelihood. In the current cycle likelihood is applied to all impacts, actual and potential, as a methodological choice (ESRS provide for it for potential impacts only); the distinction will be introduced in the next assessment cycle:',
      s6ImpactsFormula: 'Impact Score = Severity (average of Scale, Scope, Irremediability) × Likelihood',
      s6RoTitle: 'Risks and Opportunities',
      s6RoBody: 'The score is calculated by selecting the higher value between Operational Impact and Reputational Impact, and multiplying it by Likelihood:',
      s6RoFormula: 'Score = max(Operational Impact, Reputational Impact) × Likelihood',
      s6MinMax: 'The maximum achievable score is 16 (4 × 4), while the minimum is 1 (1 × 1).',
      s7Title: '7. Definition of the materiality threshold',
      s7p1: 'Once the scores of all IROs have been calculated, two materiality thresholds are set: one for the impact score, applied to impacts, and one for the financial score, applied to risks and opportunities. Each IRO is material if its score reaches or exceeds the threshold for its type; otherwise it is classified as non-material.',
      s7p2: 'The thresholds are set in the DMA configuration of each year, so as to ensure consistency with the previous year’s assessment, while taking into account the evolution of the context and the greater granularity of the {{year}} assessments.',
      s8Title: '8. Aggregation of results by macro-category (TeamSystem Topic) and by ESRS standard',
      s8p1: 'To provide an aggregated and readable view of the results, IROs are grouped into thematic macro-categories (TeamSystem Topics), which include, for example: Climate & Energy, Data Privacy and Cybersecurity, Talent Training & Development, etc. Each macro-category is represented in the matrix by two values:',
      s8Bullets: 'the highest impact score among the impacts belonging to the topic (horizontal axis);\nthe highest financial score among the risks and opportunities belonging to the topic (vertical axis).',
      s8Note: 'For each ESRS standard a summary score is also calculated, equal to the sum of the highest impact score and the highest financial score. The calculation considers all assessed IROs, material and non-material.',
      s9Title: '9. Displaying the results: the double materiality matrix',
      s9p1: 'The results of the assessment are represented through the double materiality matrix, which positions the thematic macro-categories along two axes:',
      s9Bullets: 'Horizontal axis — Impact materiality: derived from impacts, considering the highest impact score within the topic.\nVertical axis — Financial materiality: derived from risks and opportunities, considering the higher of the two scores.',
      s9p2: 'A topic is material if it reaches or exceeds at least one of the two thresholds, impact or financial; topics reaching both (top-right quadrant) are considered priorities. The matrix makes it possible to visually identify the most relevant matters and to communicate the results immediately to internal and external stakeholders.',
      s10Title: '10. Financial aspect of the IROs',
      s10p1: 'The {{year}} assessment does not include an explicit quantitative assessment of the financial impact of the IROs (e.g. an estimate in terms of revenues, costs or market value). The surveys already collect an economic-financial impact indicator, on a 1–4 scale, which however does not enter the score calculation: it can be progressively integrated into future assessments, in line with the evolution of regulatory requirements and industry best practices.',
      s11Title: '11. Thematic macro-categories (TeamSystem Topics)',
      s11p1: 'The thematic macro-categories adopted in the assessment are set out below, together with their description:',
      s11Descriptions: 'Impacts related to climate conditions, greenhouse gas emissions and energy consumption along the value chain.\nWater consumption in TeamSystem’s operations, including that related to the upstream value chain.\nCircular economy practices relating to technological equipment, to minimise waste generation and extend its useful life.\nOverall job satisfaction and work-life balance of employees.\nHealth and safety practices to protect the physical and mental health of workers.\nInitiatives to ensure diversity, equity and inclusion, including gender equality and inclusiveness.\nTraining and professional development opportunities for employees.\nRespect for human and labour rights by suppliers, partners, contractors and service providers.\nEngagement with and support for local communities, and constructive relationships with local authorities.\nData protection and cybersecurity measures concerning employees, value chain workers, customers and software users.\nMeasures to ensure clear, open and accessible reporting for all relevant stakeholders.\nIntegration of sustainability criteria into products and services, including accessibility for all consumers.\nInternal organisational dynamics and initiatives to ensure transparency, accountability and responsible business conduct.\nEthical practices guiding business conduct, including legal, tax and regulatory compliance.',
    },
    assessmentForm: {
      impactAssessment: 'Impact Assessment',
      financialAssessment: 'Financial Assessment',
      scale: 'Scale',
      scope: 'Scope',
      irremediability: 'Irremediability',
      probability: 'Probability',
      likelihood: 'Occurrence Likelihood',
      ecoFinancialImpact: 'Economic-Financial Impact',
      reputationalImpact: 'Reputational Impact',
      operationalImpact: 'Operational Impact',
      notes: 'Notes (optional)',
      cancel: 'Cancel',
      submitAssessment: 'Submit Assessment',
      updateAssessment: 'Update Assessment',
      deadline: 'Deadline',
      successMessage: 'Assessment submitted successfully!',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      myAssessment: 'My Assessment',
      onlyImpact: 'Impact Only',
      onlyFinancial: 'Financial Only',
      both: 'Both',
      statusCompleted: 'Completed',
      statusRevised: 'Revised',
      statusInProgress: 'In Progress',
      statusCarriedOver: 'To confirm',
      confirmInherited: 'Confirm',
      inheritedBanner: 'Assessment carried over from last year — confirm if it still applies, or edit the values.',
      deadlinePassed: 'Deadline has passed',
      scaleLabel: 'Scale: how severe is the impact',
      scopeLabel: 'Scope: how many subjects/environment affected',
      probabilityLabel: 'Probability of occurrence',
      ecoFinancialLabel: 'Economic-Financial Impact',
      reputationalLabel: 'Reputational Impact',
      operationalLabel: 'Operational Impact',
      calculatedImpactScore: 'Calculated Impact Score',
      calculatedFinancialScore: 'Calculated Financial Score',
      reopenIroTitle: 'Reopen IRO?',
      reopenIroMessage: 'This IRO has already been finalized. Do you want to reopen it to add a new assessment? This action will be logged in the audit trail.',
      reopenConfirm: 'Yes, reopen and save',
      notApplicable: 'N/A',
      scale1: '1 - Minimum',
      scale2: '2 - Low',
      scale3: '3 - Medium',
      scale4: '4 - High',
      likelihood1: '1 - Remote (<1%)',
      likelihood2: '2 - Unlikely (1-10%)',
      likelihood3: '3 - Possible (10-50%)',
      likelihood4: '4 - Very Likely (>50%)',
    },
    matrix: {
      title: 'Materiality',
      year: 'Year',
      consolidateScores: 'Consolidate scores',
      consolidateConfirmTitle: 'Consolidate IRO scores',
      consolidateConfirmMsg: 'Recalculate all IRO scores from stakeholder assessments and apply materiality thresholds. Continue?',
      consolidating: 'Consolidating...',
      saveThresholds: 'Save materiality',
      refresh: 'Refresh',
      cancel: 'Cancel',
      thresholdConfig: 'Materiality Threshold Configuration',
      impactThreshold: 'Impact Score Threshold (Impacts)',
      financialThreshold: 'Financial Score Threshold (Risks & Opportunities)',
      macroAreaTitle: 'Aggregation by ESRS Macro-area',
      esrs: 'ESRS',
      name: 'Name',
      maxImpact: 'Max Impact',
      maxFinancial: 'Max Financial',
      macroScore: 'Macro Score',
      material: 'Material?',
      materialIROs: 'Material IROs',
      nonMaterialIROs: 'Non-Material IROs',
      code: 'Code',
      iroName: 'Name',
      type: 'Type',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      assessed: 'Assessed',
      materialLabel: 'Material',
      nonMaterialLabel: 'Non-Material',
      noAssessment: 'No Assessment',
      noData: 'No data available',
      thresholdsSaved: 'Thresholds saved successfully',
      macroCategoryTitle: 'Aggregation by Macro-category',
      category: 'Category',
      nIRO: 'N. IRO',
      tabESRS: 'By ESRS',
      tabMacroCategory: 'By Macro-category',
      forceMaterial: 'Force Material',
      forceNonMaterial: 'Force Non-Material',
      forceConfirmTitle: 'Force materiality decision',
      forceConfirmMaterial: 'Force this IRO as MATERIAL? This overrides the automatic calculation result.',
      forceConfirmNonMaterial: 'Force this IRO as NON-MATERIAL? This overrides the automatic calculation result.',
      confirm: 'Confirm',
      forced: 'Forced',
      dotDetailTitle: 'Material IROs',
      impacts: 'Impacts',
      risks: 'Risks',
      opportunities: 'Opportunities',
      score: 'Score',
      close: 'Close',
      noMaterialIRO: 'No material IROs',
      typeImpact: 'Impact',
      typeRisk: 'Risk',
      typeOpportunity: 'Opportunity',
      invalidThresholds: 'Invalid threshold values',
      tabAnalysis: 'Analysis',
      tabPrevYearComparison: 'Previous Year Comparison',
      tabNewIros: 'New IROs',
      tabScoreRedistribution: 'Score Redistribution',
      tabMethodology: 'Methodology',
      materialityMatrix: 'Materiality Matrix',
      topic: 'topic',
      topics: 'topics',
      smaller: 'Smaller',
      larger: 'Larger',
      macroCategories: 'Macro-categories',
      newBadge: 'New',
      openFullDetail: 'Open full detail',
    },
    assessmentDialog: {
      assessIRO: 'Assess IRO',
      assessmentDetails: 'Assessment Details',
      loading: 'Loading...',
      errorLoading: 'Error loading IRO',
      retry: 'Retry',
      skipIRO: 'Skip IRO',
      skipConfirm: 'Are you sure you want to skip this IRO? You will not be able to assess it in this campaign.',
      skipping: 'Skipping...',
      assessor: 'Assessor',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      submittedAt: 'Submitted on',
      status: 'Status',
      pending: 'Pending',
      completed: 'Completed',
      iroReference: 'IRO Reference',
      assessmentType: 'Assessment Type',
      impact: 'Impact',
      financial: 'Financial',
      both: 'Both',
      notYetAssessed: 'Not yet assessed',
      fillAssessment: 'Fill Assessment',
      you: 'You',
      close: 'Close',
    },
    quickAdd: {
      title: 'Quick Add Assessment',
      step1: 'Select IRO',
      step2: 'Fill Assessment',
      searchExisting: 'Search existing',
      createNew: 'Create new',
      searchPlaceholder: 'Search by IRO name or code...',
      noOptions: 'No IRO found',
      loading: 'Loading...',
      name: 'Name',
      type: 'Type',
      esrsStandard: 'ESRS Standard',
      description: 'Description (optional)',
      impact: 'Impact',
      risk: 'Risk',
      opportunity: 'Opportunity',
      impactDirection: 'Impact Direction',
      impactNature: 'Impact Nature',
      positive: 'Positive',
      negative: 'Negative',
      actual: 'Actual',
      potential: 'Potential',
      riskType: 'Risk Type',
      physical: 'Physical',
      transition: 'Transition',
      systemic: 'Systemic',
      opportunityType: 'Opportunity Type',
      resourceEfficiency: 'Resource Efficiency',
      productsServices: 'Products & Services',
      markets: 'Markets',
      resilience: 'Resilience',
      reputation: 'Reputation',
      next: 'Next',
      back: 'Back',
      cancel: 'Cancel',
      forAssessor: 'On behalf of',
      creatingIro: 'Creating IRO...',
      requiredField: 'Required field',
    },
    page: {
      iroCatalog: 'IRO Catalog',
      year: 'Year',
      stakeholderAssessment: 'Stakeholder Assessment',
      activeCampaigns: 'Active Assessment Campaigns',
      assignedAssessments: 'Assigned IRO Assessments',
      assessmentCampaigns: 'Assessment Campaigns',
      proposeNewIro: 'Propose New IRO',
      materialityMatrix: 'Materiality Matrix',
      dmaSetup: 'DMA Setup',
      editSetup: 'Edit Setup',
      createSetup: 'Create Setup',
      createNewSetup: 'Create New Setup',
      noSetupConfigured: 'No setup configured for year',
      configCompleteness: 'Configuration Completeness',
      groupCompanies: 'Group Companies',
      activeGeographies: 'Active Geographies',
      valueChain: 'Value Chain',
      stakeholderCategories: 'Stakeholder Categories',
      naceCodes: 'NACE Codes',
      materialityThresholds: 'Materiality Thresholds',
      impactScoreThreshold: 'Impact Score Threshold',
      financialScoreThreshold: 'Financial Score Threshold',
      noSetupWarning: 'No DMA setup configured for year {year}. Contact the administrator to configure the scope.',
      impact: 'Impact',
      financial: 'Financial',
      both: 'Both',
      deadline: 'Deadline',
      companies: 'Companies',
      geographies: 'Geographies',
      stakeholders: 'Stakeholders',
      prepareAssessment: 'Prepare Assessment',
      noAssessmentsAssigned: 'No assessments assigned',
      contactAdminAssignment: 'Contact the administrator to receive an assignment.',
    },
    tabImageBanner: {
      explanatoryInfographic: 'Explanatory infographic',
      uploadLandscapeImage: 'Upload landscape image',
      clickOrDrag: 'Click or drag here',
      uploadFailed: 'Failed to upload image',
      removeFailed: 'Failed to remove image',
    },
    matrixIcons: {
      overlapping: '{{count}} overlapping — click to explore',
    },
    scoreAdjustment: {
      title: 'Adjust Scores',
      originalScores: 'Original Scores',
      newScores: 'New Scores',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      rationale: 'Rationale (optional)',
      cancel: 'Cancel',
      save: 'Save Adjustment',
      noChange: 'At least one score must differ from the original',
      enterValidScore: 'Enter at least one valid score',
    },
    comparisonPanel: {
      comparison: 'Comparison',
      othersAverage: 'Other assessors average',
      previousYear: 'Previous Year',
      myPreviousYear: 'My assessment',
      impactScore: 'Impact',
      financialScore: 'Financial',
      noOtherAssessments: 'No other assessors',
      noPreviousYear: 'No previous year data',
      assessors: 'assessors',
    },
    cardFlow: {
      assessmentCardFlow: 'Assessment Flow',
      of: 'of',
      progress: 'Progress',
      completed: 'completed',
      prev: 'Previous',
      next: 'Next',
      skip: 'Skip',
      saveAndContinue: 'Save and Continue',
      confirmAndSubmitAll: 'Confirm and Submit All',
      close: 'Close',
      loading: 'Loading...',
      errorLoading: 'Error loading',
      allCompleted: 'All assessments have been completed!',
      submitSuccess: 'All assessments have been submitted successfully!',
      onBehalfOf: 'On behalf of',
      comparison: 'Comparison',
      iroCompleted: 'Assessment completed for this IRO',
    },
    campaignIros: {
      iroCode: 'IRO Code',
      iroName: 'IRO Name',
      esrsArea: 'ESRS Area',
      assessmentType: 'Type',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      status: 'Status',
      assessor: 'Assessor',
      pending: 'Pending',
      completed: 'Completed',
      skipped: 'Skipped',
      impact: 'Impact',
      financial: 'Financial',
      both: 'Both',
      noIros: 'No IROs in this campaign',
      loadingError: 'Error loading data',
      progress: 'Progress',
    },
    cloneYear: {
      cloneYear: 'Clone Year',
      sourceYear: 'Source Year',
      targetYear: 'Target Year',
      selectData: 'Select data to copy',
      dmaSetup: 'DMA Configuration',
      dmaSetupDesc: 'Scope, countries, value chain, stakeholder categories',
      iros: 'IRO Catalog',
      irosDesc: 'All IROs from the year',
      assessments: 'Copy assessments too',
      assessmentsDesc: 'Keeps the IRO materiality scores (otherwise the new year starts to be re-assessed). Requires the IRO Catalog.',
      campaigns: 'Assessment Campaigns',
      campaignsDesc: 'Campaign structure (without assessments)',
      documents: 'Document Library',
      documentsDesc: 'Copies the Library documents into the new year (flagged "to review")',
      externalStakeholders: 'External Stakeholders',
      externalStakeholdersDesc: 'Global, not year-specific',
      internalStakeholders: 'Internal Stakeholders',
      internalStakeholdersDesc: 'ESG Organs (global)',
      clone: 'Clone',
      cancel: 'Cancel',
      cloning: 'Cloning...',
      alwaysIncluded: 'Always included',
      globalData: 'Global data',
      success: 'Clone completed',
      done: 'Done',
      skippedTitle: 'Some IROs were not cloned because they are incomplete:',
      skippedHint: 'Fill in the missing fields on these IROs in the source year and retry if you want to include them.',
    },
    assessorConfig: {
      configuredAssessors: 'Configured Assessors',
      addAssessor: 'Add Assessor',
      assessor: 'Assessor',
      assessmentType: 'Assessment Type',
      weight: 'Weight',
      normalizedWeight: 'Normalized Weight',
      assignmentDate: 'Assignment Date',
      actions: 'Actions',
      edit: 'Edit',
      remove: 'Remove',
      assessors: 'assessors',
      totalWeight: 'Total weight',
      deadline: 'Deadline',
      noAssessorsConfigured: 'No assessors configured. Add assessors to enable multi-stakeholder assessment.',
      editAssessor: 'Edit Assessor',
      selectUser: 'Select User',
      impactOnly: 'Impact Only',
      financialOnly: 'Financial Only',
      both: 'Both',
      weightDescription: 'The weight determines the relative importance of this stakeholder\'s assessment in the weighted average calculation.',
      cancel: 'Cancel',
      save: 'Save',
      add: 'Add',
      confirmRemoveAssessor: 'Are you sure you want to remove this assessor?',
    },
    esgOrgan: {
      internalStakeholders: 'Internal Stakeholders (ESG Organs)',
      addOrgan: 'Add Organ',
      editOrgan: 'Edit Organ',
      name: 'Name',
      type: 'Type',
      description: 'Description',
      members: 'Members',
      status: 'Status',
      meetingFrequency: 'Meeting Frequency',
      actions: 'Actions',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      confirmDelete: 'Are you sure you want to delete this organ?',
      noOrgans: 'No ESG organs configured',
      manageMembers: 'Manage Members',
      addMember: 'Add Member',
      role: 'Role',
      title: 'Title',
      activeMembers: 'Active Members',
      collapseOrgan: 'Collapse organ',
      expandOrgan: 'Expand organ',
      deleteOrgan: 'Delete organ',
    },
    newIros: {
      title: 'New IROs compared to 2025',
      subtitle: 'Impacts, risks and opportunities added this year that were not present in the 2025 DMA.',
      impacts: 'Impacts',
      risks: 'Risks',
      opportunities: 'Opportunities',
      name: 'Name',
      code: 'Code',
      type: 'Type',
      noNew: 'No new IROs compared to 2025.',
      total: 'Total new IROs',
      material: 'Material',
      nonMaterial: 'Non-Material',
    },
    yearComparison: {
      title: 'Macro-category Matrix Comparison',
      prevYear: 'Comparison Year ({{year}})',
      currYear: 'Current Year ({{year}})',
      compareWith: 'Compare with year',
      fromSystem: 'Comparison year (from system)',
      manual: 'Manual input',
      addRow: 'Add',
      confirm: 'Confirm',
      edit: 'Edit',
      name: 'Macro-category',
      delta: 'Changes vs comparison year',
      noData: 'No data',
      noChanges: 'No changes',
      newInMatrix: 'New in matrix',
      removed: 'Removed from matrix',
      matrixAria: 'Materiality matrix {{title}}',
    },
    stakeholderManager: {
      externalStakeholders: 'External Stakeholders',
      addStakeholder: 'Add Stakeholder',
      editStakeholder: 'Edit Stakeholder',
      name: 'Name',
      category: 'Category',
      description: 'Description',
      phone: 'Phone',
      address: 'Address',
      influenceLevel: 'Influence Level',
      dependencyLevel: 'Dependency Level',
      priorityScore: 'Priority Score',
      actions: 'Actions',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      confirmDelete: 'Are you sure you want to delete this stakeholder?',
      noStakeholders: 'No stakeholders configured',
      filterByCategory: 'Filter by category',
      allCategories: 'All categories',
    },
    dmaSettings: {
      settings: 'Year Settings',
      year: 'Year',
      externalStakeholders: 'External Stakeholders',
      countries: 'Countries',
      internalStakeholders: 'Internal Stakeholders',
      macroCategories: 'Macro-Categories',
      cloneYear: 'Clone Year',
      currentYear: 'Current Year',
      workingYear: 'Working Year',
      startNewYear: 'Start New Year',
      newYear: 'New Year',
      cloneFromCurrent: 'Clone configuration from current year',
      cloneDesc: 'Copies framework, templates, DMA filter and role assignments. Campaign data is NOT copied.',
      create: 'Create',
      cancel: 'Cancel',
      activeCountries: 'Active Countries',
      selectCountries: 'Select active countries',
      save: 'Save',
      noSetupForYear: 'No setup configured for this year',
      createSetup: 'Create Setup',
      yearCreated: 'Year created successfully',
      countriesSaved: 'Countries saved successfully',
      addCategory: 'Add Category',
      order: 'Order',
      code: 'Code',
      nameIT: 'Name (IT)',
      nameEN: 'Name (EN)',
      actions: 'Actions',
      editCategory: 'Edit Category',
      deleteCategory: 'Delete Category',
      confirmDelete: 'Are you sure you want to delete this macro-category?',
      categoryDeleted: 'Category deleted',
      categorySaved: 'Category saved',
      noCategories: 'No macro-categories configured',
      default: 'Default',
      custom: 'Custom',
      delete: 'Delete',
      yearLifecycle: {
        title: 'Archive and delete years',
        description: 'Archive a year to hide it from menus while keeping its data (reversible). Only an archived year can be permanently deleted from the database.',
        statusActive: 'Active',
        statusArchived: 'Archived',
        archive: 'Archive',
        restore: 'Restore',
        deletePermanently: 'Delete permanently',
        cannotArchiveActive: 'You cannot archive the currently selected working year',
        noYears: 'No years available',
        archived: 'Year {{year}} archived',
        restored: 'Year {{year}} restored',
        deleted: 'Year {{year}} permanently deleted',
        archiveConfirmTitle: 'Archive year {{year}}?',
        archiveConfirmText: 'The year will be hidden from menus but its data will remain in the database. You can restore it at any time.',
        deleteTitle: 'Permanently delete year {{year}}?',
        deletePreviewIntro: 'The following will be permanently deleted from the database:',
        deletePreviewEmpty: 'This year contains no data: it will simply be removed from the list.',
        deletePreviewTotal: 'Total items',
        deleteWarningIrreversible: 'This action is irreversible: the data cannot be recovered.',
        continue: 'Continue',
        deleteConfirmInstruction: 'To confirm, type the year ({{year}}) below:',
        typeYearPlaceholder: 'Type {{year}}',
        entities: {
          iros: 'IRO assessments',
          campaigns: 'Data collection campaigns',
          entries: 'Filled-in data',
          consolidations: 'Per-country consolidations',
          datapoints: 'Defined datapoints',
          assignments: 'Datapoint assignments',
          materialityMatrix: 'Materiality matrix',
          iroAssessments: 'Materiality assessments',
          macroCategories: 'Macro-categories',
          macroCategoryScores: 'Macro-category scores',
          engagementCampaigns: 'Engagement campaigns',
          dmaProcesses: 'DMA processes',
          hrImports: 'HR data imports',
          dmaSetup: 'DMA configuration (scope)',
          yearConfig: 'Year configuration (data capture)',
          reportingConfig: 'Reporting configuration',
          consolidatedData: 'Consolidated reporting data',
          reportSections: 'Report sections',
          reportingAssignments: 'Reporting assignments',
          countryProfiles: 'Country profiles',
          legalReviews: 'Legal reviews',
        },
      },
    },
    iroDetailDialog: {
      close: 'Close',
      description: 'Description',
      macroCategory: 'Macro-category',
      timeHorizon: 'Time Horizon',
      consolidatedScores: 'Consolidated Scores',
      consolidatedAt: 'Consolidated at',
      noConsolidated: 'No consolidated scores',
      stakeholderAssessments: 'Stakeholder Assessments',
      assessor: 'Assessor',
      weight: 'Weight',
      status: 'Status',
      completed: 'completed',
      noAssessments: 'No assessments',
      yearComparison: 'Previous Year Comparison',
      year: 'Year',
      noPrevYear: 'No previous year data',
      typeImpact: 'Impact',
      typeRisk: 'Risk',
      typeOpportunity: 'Opportunity',
      horizonShort: 'Short',
      horizonMedium: 'Medium',
      horizonLong: 'Long',
      statusPending: 'Pending',
      statusCompleted: 'Completed',
      statusRevised: 'Revised',
      statusSkipped: 'Skipped',
      with: 'with',
      openFullDetail: 'Open full detail',
      loadFailed: 'Failed to load IRO details',
    },
    matrixV2: {
      materialityMatrix: 'Materiality Matrix',
      thresholds: 'Thresholds',
      refresh: 'Refresh',
      esrsStandard: 'ESRS Standard',
      type: 'Type',
      all: 'All',
      impact: 'Impact',
      risk: 'Risk',
      opportunity: 'Opportunity',
      configureThresholds: 'Configure Materiality Thresholds',
      impactScoreThreshold: 'Impact Score Threshold',
      financialScoreThreshold: 'Financial Score Threshold',
      save: 'Save',
      material: 'Material',
      watchList: 'Watch List',
      lowPriority: 'Low Priority',
      totalIro: 'Total IROs',
      financialMaterialityAxis: 'FINANCIAL MATERIALITY (OUTSIDE-IN)',
      impactMaterialityAxis: 'IMPACT MATERIALITY (INSIDE-OUT)',
      impactLabel: 'Impact',
      financialLabel: 'Financial',
      materialLabel: 'MATERIAL',
      topicsScoredBy: '{{count}} topics scored by impact and financial relevance',
      byEsrsStandard: 'By ESRS Standard',
      byType: 'By Type',
      byGeography: 'By Geography',
      mat: 'mat.',
      chartAria: 'Double materiality matrix: IRO distribution by Impact and Financial Relevance',
    },
    campaignManager: {
      assessmentCampaigns: 'Assessment Campaigns',
      year: 'Year',
      newCampaign: 'New Campaign',
      totalCampaigns: 'Total Campaigns',
      active: 'Active',
      pendingProposals: 'Pending Proposals',
      completed: 'Completed',
      campaignName: 'Campaign Name',
      status: 'Status',
      assignments: 'Assignments',
      progress: 'Progress',
      deadline: 'Deadline',
      proposals: 'Proposals',
      actions: 'Actions',
      noCampaigns: 'No campaigns created for year',
      viewDetails: 'View Details',
      startCampaign: 'Start Campaign',
      completeCampaign: 'Complete Campaign',
      cancelCampaign: 'Cancel Campaign',
      newAssessmentCampaign: 'New Assessment Campaign',
      description: 'Description',
      startDate: 'Start Date',
      endDate: 'End Date',
      selectIros: 'Select IROs to include',
      selected: 'selected',
      code: 'Code',
      name: 'Name',
      esrsArea: 'ESRS Area',
      cancel: 'Cancel',
      createCampaign: 'Create Campaign',
      nameAndIroRequired: 'Name and at least one IRO are required',
      expired: 'Expired',
      openInNewTab: 'Open in new tab',
      statusDraft: 'Draft',
      statusActive: 'Active',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
    },
    proposeIro: {
      proposalSent: 'Proposal Sent',
      proposalSentDesc: 'Your IRO proposal has been sent to the ESG team for review. You will be notified when it is approved or rejected.',
      backToList: 'Back to List',
      proposeNewIro: 'Propose New IRO',
      infoBanner: 'Propose an IRO (Impact, Risk, Opportunity) you consider relevant for the company. Your proposal will be reviewed by the ESG team.',
      esrsArea: 'ESRS Area',
      type: 'Type',
      iroName: 'IRO Name',
      iroNamePlaceholder: 'e.g. GHG Emissions Scope 1 and 2',
      description: 'Description',
      descriptionPlaceholder: 'Describe the IRO in detail...',
      esrsTopicOptional: 'ESRS Topic (optional)',
      esrsTopicPlaceholder: 'e.g. Climate change mitigation',
      impactNature: 'Impact Nature',
      impactDirection: 'Impact Direction',
      timeHorizon: 'Time Horizon',
      valueChainPosition: 'Position in the Value Chain',
      rationale: 'Rationale',
      rationalePlaceholder: 'Why do you consider this IRO relevant for the company?',
      cancel: 'Cancel',
      submitProposal: 'Submit Proposal',
      requiredFields: 'Fill in all required fields',
      typeImpact: 'Impact',
      typeRisk: 'Risk',
      typeOpportunity: 'Opportunity',
      natureActual: 'Actual',
      naturePotential: 'Potential',
      directionNegative: 'Negative',
      directionPositive: 'Positive',
      horizonShort: 'Short term (<1 year)',
      horizonMedium: 'Medium term (1-5 years)',
      horizonLong: 'Long term (>5 years)',
      vcUpstream: 'Upstream (Suppliers)',
      vcOperations: 'Operations (Own activities)',
      vcDownstream: 'Downstream (Clients/Users)',
    },
    scoreRedistribution: {
      currentMaterial: 'Current material',
      proposedMaterial: 'Proposed material',
      adjustments: 'Adjustments',
      willLose: 'Will lose materiality',
      currentMatrix: 'Current Matrix',
      proposedMatrix: 'Proposed Matrix',
      code: 'Code',
      name: 'Name',
      type: 'Type',
      currentScore: 'Current Score',
      proposedScore: 'Proposed Score',
      materialStatus: 'Materiality',
      readOnlyNote: 'This view is read-only. No modifications are applied to the data.',
      close: 'Close',
      adjusted: 'Adjusted',
      typeImpact: 'Impact',
      typeRisk: 'Risk',
      typeOpportunity: 'Opportunity',
      stays: 'Stays',
      loses: 'Loses',
      gains: 'Gains',
      notMat: 'Not mat.',
      proposedView: 'Proposed view',
      noIrosInCategory: 'No IROs in this category',
      yes: 'Yes',
      no: 'No',
      matrixAria: 'Score redistribution matrix by macro-category',
    },
    iroForm: {
      back: 'Back',
      newIRO: 'New IRO',
      editIRO: 'Edit IRO',
      basicInfo: 'Basic Information',
      nameLabel: 'Name',
      descriptionLabel: 'Description',
      classification: 'Classification',
      type: 'Type',
      typeImpact: 'Impact',
      typeRisk: 'Risk',
      typeOpportunity: 'Opportunity',
      esrsSubTopic: 'ESRS Sub-topic',
      esrsSubTopicPlaceholder: 'e.g. Climate Change Mitigation',
      macroCategory: 'Macro-category',
      macroCategoryNone: 'None',
      timeHorizon: 'Time Horizon',
      impactNature: 'Impact Nature',
      impactNatureActual: 'Actual',
      impactNaturePotential: 'Potential',
      impactDirection: 'Impact Direction',
      impactDirectionPositive: 'Positive',
      impactDirectionNegative: 'Negative',
      scope: 'Scope of Application',
      geographies: 'Geographies',
      valueChainPositions: 'Value Chain Positions',
      affectedStakeholders: 'Affected Stakeholders',
      internalStakeholderAssignment: 'Internal Stakeholder Assignment',
      assignedStakeholders: 'Assigned Internal Stakeholders',
      assignedStakeholdersPlaceholder: 'Select users for assessment...',
      assignedStakeholdersHelper: 'Selected stakeholders will be able to assess this IRO',
      cancel: 'Cancel',
      saveChanges: 'Save Changes',
      createIRO: 'Create IRO',
      noUsersFound: 'No users found',
      loadingUsers: 'Loading users...',
      errorSaving: 'Error while saving',
      nameRequired: 'Name is required',
      descriptionRequired: 'Description is required',
      selectAtLeastOneGeography: 'Select at least one geography',
      selectAtLeastOneValueChain: 'Select at least one value chain position',
      selectAtLeastOneStakeholder: 'Select at least one stakeholder',
      selectImpactNature: 'Select the impact nature',
      selectImpactDirection: 'Select the impact direction',
      riskType: 'Risk Type',
      selectRiskType: 'Select the risk type',
      opportunityType: 'Opportunity Type',
      selectOpportunityType: 'Select the opportunity type',
    },
    iroRegistry: {
      type: 'Type',
      nameAndDescription: 'Name / Description',
      macroCategory: 'Macro-category',
      actions: 'Actions',
      createIROIn: 'Create IRO in',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      duplicate: 'Duplicate',
      submitForValidation: 'Submit for Validation',
      validate: 'Validate',
      confirmDelete: 'Confirm Delete',
      deleteConfirmMsg: 'Are you sure you want to delete the IRO',
      deleteWarning: 'This action cannot be undone.',
      cancel: 'Cancel',
      export: 'Export',
      newIRO: 'New IRO',
      searchPlaceholder: 'Search by name or description...',
      all: 'All',
      status: 'Status',
      refresh: 'Refresh',
      totalIRO: 'total IRO',
      noIROFound: 'No IRO found',
      noIROInCategory: 'No IRO in this category',
      esrsView: 'By ESRS',
      macroThemeView: 'By TeamSystem Macro Categories',
      uncategorized: 'Uncategorized',
      iroCatalog: 'IRO Catalog',
      deleteNonDraftWarning: 'This IRO is not in draft status. Deleting it will permanently remove all associated assessment and validation data.',
      deleteSelected: 'Delete selected',
      bulkDeleteConfirmMsg: 'Are you sure you want to delete the selected IROs?',
      bulkDeleteCount: '{{count}} IRO selected',
      date: 'Date',
      assessmentStatus: 'Status',
      noAssessments: 'No stakeholder assessments',
      loadingAssessments: 'Loading assessments...',
      materiality: 'Materiality',
      materialLabel: 'Material',
      nonMaterialLabel: 'Not Material',
      adjustment: 'Adjustment',
      withAdjustment: 'With adjustment',
      withoutAdjustment: 'Without adjustment',
      adjustScores: 'Adjust scores',
      removeAdjustment: 'Remove adjustment',
      openInNewTab: 'Open in new tab',
      original: 'Original',
      adjusted: 'Adjusted',
      clickForAssessmentDetail: 'Click for assessment detail',
      viewIROAria: 'View IRO',
      editIROAria: 'Edit IRO',
      deleteIROAria: 'Delete IRO',
      duplicateIROAria: 'Duplicate IRO',
      moreOptionsAria: 'More options',
      loadError: 'Error loading IROs',
    },
    myAssessments: {
      pendingAssessments: 'Pending Assessments',
      pendingAssessmentsDesc: 'Assigned IROs awaiting your assessment',
      startAssessment: 'Start Assessment',
      pendingStatus: 'Pending',
      noAssessments: 'No assessments assigned',
      noAssessmentsDesc: 'You don\'t have any assessments assigned to you yet. When assessments are assigned to you, they\'ll appear here and you\'ll be notified.',
      noAssessmentsAdmin: 'No assessments found for the current year.',
      totalAssessments: 'Total Assessments',
      completed: 'Completed',
      filterByEsrs: 'Filter by ESRS Area',
      allAreas: 'All Areas',
      filterByStatus: 'Filter by Status',
      allStatuses: 'All Statuses',
      completedStatus: 'Completed',
      revisedStatus: 'Revised',
      toConfirmStatus: 'To confirm',
      confirmAllButton: 'Confirm all',
      sendToStakeholder: 'Send to stakeholder',
      sentToStakeholder: 'Sent',
      errorSending: 'Error while sending',
      iroCode: 'IRO Code',
      iroName: 'IRO Name',
      esrsArea: 'ESRS Area',
      assessmentType: 'Type',
      status: 'Status',
      impact: 'Impact',
      financial: 'Financial',
      both: 'Both',
      noMatchesFilter: 'No assessments match the selected filters',
      viewAllAssessments: 'View all assessments',
      assessor: 'Assessor',
      allStakeholders: 'All stakeholders',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      date: 'Date',
      assessorsCount: 'Assessors',
      evaluatedIROs: 'Evaluated IROs',
      completionRate: 'Completion',
      avgImpact: 'Avg Impact',
      avgFinancial: 'Avg Financial',
      role: 'Role',
      iroEvaluated: 'IROs Evaluated',
      actions: 'Actions',
      fillOnBehalf: 'Fill on behalf of',
      sendReminder: 'Send Reminder',
      sendAllReminders: 'Send All Reminders',
      reminderSent: 'Reminder sent',
      allRemindersSent: 'All reminders sent',
      errorSendingReminder: 'Error sending reminder',
      addAssessment: 'Add Assessment',
      addStakeholder: 'Add Internal Stakeholder',
      deleteAssessment: 'Delete Assessment',
      confirmDelete: 'Confirm Delete',
      deleteConfirmMsg: 'Are you sure you want to delete this assessment? The IRO scores will be recalculated.',
      cancel: 'Cancel',
      delete: 'Delete',
      secondaryAssessorsPlaceholder: 'Secondary assessors (comma-separated)',
      editNameAndRole: 'Edit name and role',
      with: 'with',
    },
    assessmentComparison: {
      assessmentComparison: 'Assessment Comparison',
      consolidateScores: 'Consolidate Scores',
      assessmentProgress: 'Assessment progress',
      completed: 'completed',
      divergenceWarning: 'Assessments show significant divergences. It is recommended to review assessments before consolidation.',
      noAssessmentsAvailable: 'No stakeholder assessments available for this IRO.',
      assessor: 'Assessor',
      type: 'Type',
      status: 'Status',
      weight: 'Weight',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      date: 'Date',
      impact: 'Impact',
      financial: 'Financial',
      both: 'Both',
      consolidatedScores: 'Consolidated Scores',
      overallScore: 'Overall Score',
      assessments: 'assessments',
      impactVariance: 'Impact Variance',
      financialVariance: 'Financial Variance',
      statusCompleted: 'Completed',
      statusRevised: 'Revised',
      statusPending: 'Pending',
      detailTitle: 'Assessment Detail',
      scale: 'Scale',
      scope: 'Scope',
      irremediability: 'Irremediability',
      probability: 'Probability',
      likelihood: 'Likelihood',
      ecoFinancialImpact: 'Eco-Financial Impact',
      reputationalImpact: 'Reputational Impact',
      operationalImpact: 'Operational Impact',
      notes: 'Notes',
      noDetail: 'No detail available',
      deleteAssessment: 'Delete Assessment',
      confirmDelete: 'Confirm Delete',
      deleteConfirmMsg: 'Are you sure you want to delete this assessment? Consolidated scores will be recalculated.',
      cancel: 'Cancel',
      delete: 'Delete',
      actions: 'Actions',
      collapseAssessment: 'Collapse assessment',
      expandAssessment: 'Expand assessment',
    },
    governance: {
      esgGovernance: 'ESG Governance',
      initializeStructure: 'Initialize Structure',
      list: 'List',
      hierarchy: 'Hierarchy',
      newOrgan: 'New Organ',
      hierarchicalStructure: 'Hierarchical Structure',
      board: 'Board of Directors',
      committee: 'Committee',
      management: 'Management',
      operatingSystem: 'Operating System',
      workingGroup: 'Working Group',
      president: 'President',
      vicePresident: 'Vice President',
      secretary: 'Secretary',
      member: 'Member',
      observer: 'Observer',
      expert: 'Expert',
      policies: 'Policies',
      targets: 'Targets',
      actionPlans: 'Action Plans',
      materialityMatrix: 'Materiality Matrix',
      weekly: 'Weekly',
      monthly: 'Monthly',
      quarterly: 'Quarterly',
      annually: 'Annually',
      adHoc: 'Ad Hoc',
      active: 'Active',
      inactive: 'Inactive',
      activate: 'Activate',
      deactivate: 'Deactivate',
      edit: 'Edit',
      save: 'Save',
      cancel: 'Cancel',
      add: 'Add',
      addMember: 'Add Member',
      createManually: 'Create Manually',
      initializeStandardStructure: 'Initialize Standard Structure',
      members: 'members',
      membersTitle: 'Members',
      esrsTopics: 'ESRS Topics',
      approvals: 'Approvals',
      meetingFrequency: 'Meeting frequency',
      noMembersAssigned: 'No members assigned',
      noOrgansConfigured: 'No ESG organ configured',
      noOrgansDescription: 'Initialize the governance structure to create default organs (Board, Sustainability Committee, etc.) or manually create your organs.',
      editOrgan: 'Edit Organ',
      newEsgOrgan: 'New ESG Organ',
      addMemberTo: 'Add Member to',
      name: 'Name',
      nameEN: 'Name (EN)',
      type: 'Type',
      parentOrgan: 'Parent Organ',
      noneTopLevel: 'None (Top-level)',
      description: 'Description',
      approvalPermissions: 'Approval Permissions',
      fullName: 'Full Name',
      role: 'Role',
      chairperson: 'Chairperson',
      chairpersonSuffix: 'Chairperson',
      responsibilities: 'Responsibilities (comma separated)',
      responsibilitiesHelper: 'E.g.: Coordination, Reporting, Analysis',
      loadError: 'Error loading governance',
      initError: 'Error during initialization',
      saveError: 'Error saving',
      stateChangeError: 'Error changing state',
      addMemberError: 'Error adding member',
      removeError: 'Error removing',
      confirmRemoveMember: 'Remove {{member}} from {{organ}}?',
    },
    prepareDialog: {
      prepareAssessment: 'Prepare Assessment',
      selectStakeholder: 'Select Stakeholder',
      selectIros: 'Select IROs',
      sendOptions: 'Send Options',
      confirm: 'Confirm',
      targetStakeholder: 'Target Stakeholder',
      searchStakeholder: 'Search internal stakeholder...',
      noStakeholderSelected: 'No stakeholder selected',
      stakeholderRole: 'Role',
      stakeholderAreas: 'Areas of expertise',
      autoIncludeAssigned: 'Include IROs with assigned stakeholder',
      autoIncludeAssignedHint: 'Automatically pre-select IROs where this stakeholder is among the assigned assessors',
      irosAlreadyAssigned: 'IROs already assigned to this stakeholder',
      irosNotAssigned: 'IROs not yet assigned',
      code: 'Code',
      name: 'Name',
      esrsArea: 'ESRS Area',
      type: 'Type',
      status: 'Status',
      campaign: 'Campaign',
      noAssignedIros: 'No IROs already assigned to this stakeholder',
      noUnassignedIros: 'All IROs are already assigned',
      selectedIros: 'Selected IROs',
      loadingAssignments: 'Loading assignments...',
      sendTo: 'Send to',
      sendToStakeholder: 'Send to the stakeholder',
      sendToEmail: 'Send to a specific email address',
      fillOnBehalf: 'Fill on behalf of the stakeholder',
      fillOnBehalfHint: 'You will directly fill the assessment on behalf of the selected stakeholder',
      emailRecipient: 'Email Address',
      emailRecipientName: 'Recipient Name',
      viewpointNote: 'The email recipient will provide a viewpoint but does not represent the stakeholder.',
      assessmentType: 'Assessment Type',
      impact: 'Impact Only',
      financial: 'Financial Only',
      both: 'Both',
      deadline: 'Deadline',
      notes: 'Notes for assessor',
      summary: 'Assessment Summary',
      willBeSentTo: 'Will be sent to',
      willFillDirectly: 'You will directly fill the assessment on behalf of',
      viaEmail: 'via email',
      irosToAssess: 'IROs to assess',
      cancel: 'Cancel',
      back: 'Back',
      next: 'Next',
      createAndSend: 'Create and Send',
      createDraft: 'Save as Draft',
      fillNow: 'Fill now',
      selectAtLeastOneIro: 'Select at least one IRO',
      enterValidEmail: 'Enter a valid email address',
      errorCreating: 'Error creating assessment',
      newSuffix: 'new',
      emailRecipientViewpoint: 'Email recipient (viewpoint)',
    },
  },
  dataCapture: {
    title: 'ESRS Data Capture',
    countryRequests: 'Country Requests',
    consolidation: 'Consolidation',
    dataEntry: 'Data Entry',
    noActivityAssigned: 'No activity assigned for the current year',
    contactAdmin: 'Contact the administrator to receive an assignment.',
    status: {
      to_compile: 'Not submitted',
      draft: 'Draft to send',
      rejected_to_owner: 'Rejected and returned to data owner',
      in_validation: 'In validation',
      validated: 'Validated',
      approved: 'Consolidated',
      consolidated: 'Consolidated',
      consolidated_approved: 'Consolidated approved',
      validated_pending_consolidation: 'Validated — pending consolidation',
      admin_modified: 'Modified by admin',
      modified_by_agent_hint: 'This datapoint was modified by an AI agent (MCP) and is back in progress: it must be re-validated (or re-consolidated) by the owner.',
    },
    perimeter: {
      centralized: 'Centralized',
      byCountry: 'By country: {{name}}',
      mainExcept: 'Main (except: {{names}})',
    },
    exceptionDelete: {
      title: 'Delete exceptions?',
      body_one: 'You have <b>{{count}} exception</b> configured for {{standard}}. Disabling exceptions will delete them and all datapoints will inherit the global configuration.',
      body_other: 'You have <b>{{count}} exceptions</b> configured for {{standard}}. Disabling exceptions will delete them and all datapoints will inherit the global configuration.',
      cancel: 'Cancel',
      confirm: 'Yes, delete exceptions',
    },
    reportAssessmentPdf: {
      internalDoc: 'TEAMSYSTEM S.P.A. - INTERNAL DOCUMENT',
      title: 'Report Assessment - Year {{year}}',
      compiledCount: '{{count}} datapoints filled in - {{date}}',
      footer: 'TeamSystem S.p.A. - Report Assessment {{year}} - {{date}}',
      columns: { code: 'Code', request: 'Request', value: 'Value', notes: 'Notes' },
      dataOwner: 'Data owner: {{name}}',
      ownershipReview: {
        title: 'OWNER TO REVIEW: reported as incorrect',
        raisedBy: 'Reported by {{name}} on {{date}}',
        raisedByNoDate: 'Reported by {{name}}',
        suggested: 'Suggested: {{name}}',
      },
      status: {
        to_compile: 'Missing data',
        draft: 'Draft',
        in_validation: 'In validation',
        validated: 'Validated',
        consolidated: 'Consolidated',
        approved: 'Approved',
        consolidated_approved: 'Cons. approved',
        admin_modified: 'Admin mod.',
      },
    },
    supervisorDashboard: {
      title: 'Validation',
      toValidate: 'To validate',
      validated: 'Validated today',
      rejected: 'Rejected',
      code: 'Code',
      name: 'Name',
      value: 'Value',
      owner: 'Owner',
      notes: 'Notes',
      actions: 'Actions',
      validate: 'Validate',
      reject: 'Reject',
      rejectReason: 'Rejection reason',
      confirm: 'Confirm',
      cancel: 'Cancel',
      noData: 'No data points to validate',
      search: 'Search...',
      year: 'Year',
      validatedMsg: 'Data point validated',
      rejectedMsg: 'Data point rejected',
      methodology: 'Methodology',
      deadline: 'Deadline',
      comparisonCampaignValue: 'Comparison campaign value',
      perimetro: 'Scope',
      pendingShort: 'pending',
      unassigned: 'Unassigned',
      pendingConsolidation_one: 'You have {{count}} group to consolidate',
      pendingConsolidation_other: 'You have {{count}} groups to consolidate',
      goToConsolidation: 'Go to Consolidation',
    },
    sourcesPanel: {
      iroTab: 'IROs from DMA',
      esrsTab: 'Mandatory ESRS',
      esrsOptTab: 'Optional ESRS',
      griTab: 'GRI',
      tnfdTab: 'TNFD',
      sfdrTab: 'SFDR',
      allTab: 'All Templates',
      search: 'Search...',
      searchAriaLabel: 'Search data sources',
      selected: 'selected',
      addSelected: 'Add Selected',
      createAllMandatory: 'Create All Mandatory',
      importFromIRO: 'Import from Material IROs',
      code: 'Code',
      name: 'Name',
      standard: 'Standard',
      disclosure: 'Disclosure',
      type: 'Type',
      framework: 'Framework',
      mandatory: 'Mandatory',
      noTemplates: 'No templates found',
      iroTitle: 'IROs from Double Materiality',
      iroDesc: 'Select IROs to create corresponding ESRS datapoints. Material IROs are pre-selected.',
      iroResult: 'Import result',
      materialStandards: 'Material standards',
      materialIROs: 'Material IROs found',
      material: 'Material',
      notMaterial: 'Not material',
      impact: 'Impact',
      risk: 'Risk',
      opportunity: 'Opportunity',
      iroType: 'Type',
      materiality: 'Materiality',
      noIros: 'No IROs found. Run the Double Materiality first.',
      importSelected: 'Import Selected',
      configureDatapoints: 'Configure Datapoints',
      created: 'created',
      skipped: 'already existing',
      errors: 'errors',
      adding: 'Creating...',
      importing: 'Importing...',
    },
    assignmentManager: {
      title: 'Assignment Management',
      newAssignment: 'New Assignment',
      assignee: 'Assignee',
      name: 'Name',
      email: 'Email',
      role: 'Role',
      owner: 'Owner',
      supervisor: 'Supervisor',
      scope: 'Scope',
      esrsStandards: 'ESRS Standards',
      geographies: 'Geographies',
      deadline: 'Deadline',
      actions: 'Actions',
      create: 'Create',
      cancel: 'Cancel',
      delete: 'Delete',
      apply: 'Apply to datapoints',
      userId: 'User ID',
      selectUser: 'Select user',
      searchUser: 'Search by name or email...',
      manualEntry: 'Manual entry',
      noAssignments: 'No assignments found',
      year: 'Year',
      created: 'Assignment created',
      deleted: 'Assignment deleted',
      applied: 'Assignment applied to datapoints',
      allStandards: 'All',
      edit: 'Edit',
      updated: 'Assignment updated',
      editAssignment: 'Edit Assignment',
      save: 'Save',
      editNote: 'Changes are not automatically propagated to datapoints. Use "Apply" to update them.',
      objectIdHint: 'MongoDB ObjectId',
      editAssignmentAria: 'Edit assignment',
      applyAssignmentAria: 'Apply assignment',
      deleteAssignmentAria: 'Delete assignment',
    },
    iroMappingStep: {
      title: 'IRO → Datapoint Mapping',
      noIros: 'No IROs selected. Go back to Step 1 to select IROs.',
      noIrosDisabled: 'IRO source is not enabled. Enable it in Step 1.',
      iroOf: 'of',
      standard: 'Standard',
      type: 'Type',
      code: 'Code',
      name: 'Name',
      description: 'Description',
      disclosure: 'Disclosure',
      prev: 'Previous',
      next: 'Save & Next',
      skip: 'Skip',
      impact: 'Impact',
      risk: 'Risk',
      opportunity: 'Opportunity',
      timeHorizon: 'Horizon',
      short: 'Short',
      medium: 'Medium',
      long: 'Long',
      geographies: 'Geographies',
      valueChain: 'Value chain',
      scores: 'Scores',
      impactScore: 'Impact',
      financialScore: 'Financial',
      overallScore: 'Overall',
      material: 'Material',
      notMaterial: 'Not material',
      search: 'Search datapoints...',
      filterAll: 'All',
      filterRequired: 'Shall disclose',
      filterOptional: 'May disclose',
      datapoints: 'datapoint',
      selected: 'selected',
      noTemplates: 'No datapoints found for this IRO with current filters.',
      impactNature: 'Nature',
      actual: 'Actual',
      potential: 'Potential',
      selectAll: 'Select visible',
      deselectAll: 'Deselect visible',
      shall: 'Shall',
      may: 'May',
      suggested: 'Suggested',
      otherTemplates: 'All others',
      filterAllTypes: 'All',
      filterNumeric: 'Quantitative',
      filterText: 'Qualitative',
      iroDetails: 'IRO Details',
    },
    dataConfigurationWizard: {
      title: 'Configuration',
      back: 'Back',
      next: 'Next',
      apply: 'Apply Configuration',
      applying: 'Applying...',
      saving: 'Saving...',
      draft: 'Draft',
      active: 'Active',
      locked: 'Locked',
      applyConfirmTitle: 'Apply Configuration',
      applyConfirmText: 'This will create DataPoints from selected templates and assign owners. Continue?',
      confirm: 'Confirm',
      cancel: 'Cancel',
      applySuccess: 'Configuration applied successfully!',
      created: 'created',
      skipped: 'already existing',
      ownershipUpdated: 'assignments applied',
      year: 'Year',
      summarySourcesLabel: 'Framework',
      summaryDmaLabel: 'DMA Filter',
      summaryReviewLabel: 'Review',
      summaryAssignLabel: 'Assignments',
      assigned: 'assigned',
      notStarted: 'Not started',
      configured: 'Configured',
      notConfigured: 'Not configured',
    },
    configurationPhase: {
      title: 'Data Capture Configuration',
      step1: 'Material IROs',
      step2: 'Framework',
      step3: 'KPI Selection',
      step4: 'Assignments',
      next: 'Next',
      back: 'Back',
      finish: 'Complete Configuration',
      materialIRODesc: 'IROs with material decision, grouped by ESRS standard.',
      frameworkDesc: 'Select the reference framework for KPIs.',
      kpiDesc: 'Select KPIs to collect. Mandatory KPIs are pre-selected.',
      assignDesc: 'Assign Data Owner for each standard.',
      code: 'Code',
      name: 'Name',
      type: 'Type',
      unit: 'Unit',
      mandatory: 'Mandatory',
      selected: 'Selected',
      standard: 'Standard',
      standardsCount: 'Standard',
      ownerName: 'Owner Name',
      ownerEmail: 'Email Owner',
      noTemplates: 'No templates available',
      configComplete: 'Configuration complete! Datapoints created and campaign drafted.',
      creating: 'Creating...',
      datapoints: 'Total datapoints',
      datapointsCount_one: '{{count}} datapoint',
      datapointsCount_other: '{{count}} datapoints',
      completedPct: '{{pct}}% completed',
      noData: 'No data',
      year: 'Year',
    },
    kanbanBoard: {
      title: 'Data Capture Kanban',
      configuration: 'Data Configuration',
      collection: 'Data Collection',
      validation: 'Validation',
      materialIROs: 'Material IROs',
      templates: 'Template',
      assignedOwners: 'Assigned owners',
      activeCampaign: 'Active campaign',
      ownerProgress: 'Owner progress',
      pendingReminders: 'Pending reminders',
      toValidate: 'To validate',
      validatedToday: 'Completed',
      overdue: 'Overdue',
      configure: 'Configure',
      manage: 'Manage',
      validate: 'Validate',
      noCampaigns: 'No campaigns',
      framework: 'Framework',
      year: 'Year',
      datapoint: 'Datapoint',
    },
    roleAssignmentStep: {
      title: 'Role Assignment',
      owner: 'Data Owner',
      validator: 'Data Validator',
      inherited: 'inherited',
      standard: 'Standard',
      disclosure: 'Disclosure',
      datapoint: 'Datapoint',
      noDatapoints: 'No templates selected. Go back to Step 1 to select sources.',
      selectRole: 'Select role...',
      coverage: 'Coverage',
      covered: 'covered',
      previous: 'Previous',
      next: 'Next',
      datapoints: 'datapoints',
      disclosures: 'disclosures',
      noRoles: 'No roles configured. Go to Settings > Data Capture Roles to set them up.',
      allCountries: 'Centralized',
      allCountriesShort: 'Centr.',
      perCountry: 'Per Country',
      perCountryShort: 'Per Country',
      scope: 'Scope',
      ownerShort: 'Owner',
      validatorShort: 'Validator',
      exceptionsTitle: 'Datapoint exceptions',
      noExceptions: 'No exception configured. All datapoints inherit the global configuration.',
      addException: '+ Add exception',
      removeException: 'Remove {{code}}',
      mandatory: 'Mandatory',
      required: 'Required',
      quantitative: 'Quantitative',
    },
    activeDatapointsPanel: {
      title: 'Active Datapoints',
      total: 'Total',
      assigned: 'Assigned',
      unassigned: 'Unassigned',
      completionRate: 'Completion',
      overdue: 'Overdue',
      search: 'Search...',
      code: 'Code',
      name: 'Name',
      standard: 'Standard',
      owner: 'Owner',
      status: 'Status',
      allStandards: 'All standards',
      allStatuses: 'All statuses',
      noDatapoints: 'No datapoints found',
      rowsPerPage: 'Rows per page',
      searchAriaLabel: 'Search active datapoints',
    },
    templateCatalog: {
      title: 'Template Catalog',
      search: 'Search...',
      searchAriaLabel: 'Search templates',
      code: 'Code',
      name: 'Name',
      standard: 'Standard',
      disclosure: 'Disclosure',
      type: 'Type',
      unit: 'Unit',
      mandatory: 'Mandatory',
      crossMapping: 'Cross-mapping',
      uploadExcel: 'Import from Excel',
      noTemplates: 'No templates found',
      imported: 'Templates imported',
      year: 'Year',
      importResult: '{{imported}} new, {{updated}} updated, {{errors}} errors',
      templateCount_one: '{{count}} template',
      templateCount_other: '{{count}} templates',
    },
    datapointMappingView: {
      iroToReview: 'IROs to review',
      mandatoryLabel: 'Mandatory',
      optionalLabel: 'Optional',
      totalDp: 'Total Datapoints',
      unmappedMandatory: 'Mandatory without IRO',
      filter: 'Filter datapoints...',
      searchOther: 'Search from other standards...',
      selected: 'selected',
      mandatoryBadge: 'mand.',
      code: 'Code',
      name: 'Name',
      unit: 'Unit',
      assignedTo: 'Assigned to',
      noResults: 'No results',
      noneInCategory: 'No datapoints in this category',
      unmappedDesc: 'Mandatory datapoints whose ESRS standard does not match any selected IRO. Automatically included.',
      otherStandards: 'From other standards',
      back: 'Back',
      save: 'Save Configuration',
      saving: 'Saving...',
      saved: 'Configuration saved!',
      loading: 'Loading templates...',
      selectIro: 'Select an IRO from the sidebar',
      savingStep1: 'Creating datapoints...',
      savingStep2: 'Linking to IROs...',
      filterIndicatorsAria: 'Filter indicators',
      filterDataPointAria: 'Filter data point',
      mandatoryBadgeShort: 'mand.',
    },
    datapointReviewStep: {
      code: 'Code',
      name: 'Name',
      type: 'Type',
      format: 'Format',
      mandatoryBadge: 'Mandatory',
      optionalBadge: 'Optional',
      allTypes: 'All types',
      typeNumeric: 'Quantitative',
      typeText: 'Qualitative',
      datapoints: 'datapoint',
      filterAll_one: 'All ({{count}})',
      filterAll_other: 'All ({{count}})',
      filterMandatory_one: 'Mandatory ({{count}})',
      filterMandatory_other: 'Mandatory ({{count}})',
      filterOptional_one: 'Optional ({{count}})',
      filterOptional_other: 'Optional ({{count}})',
      groupMandatory_one: '{{count}} mand.',
      groupMandatory_other: '{{count}} mand.',
      groupOptional_one: '{{count}} optional',
      groupOptional_other: '{{count}} optional',
      summary: '{{total}} selected datapoints — {{mandatory}} mandatory · {{optional}} optional included',
    },
    delegateDialog: {
      title: 'Delegate Datapoint',
      datapoint: 'Datapoint to delegate',
      userId: 'User ID',
      userName: 'Name',
      userEmail: 'Email',
      notes: 'Notes (optional)',
      cancel: 'Cancel',
      confirm: 'Confirm Delegation',
    },
    dmaFilterStep: {
      title: 'DMA Filter',
      bannerNoDma: 'No DMA found for this year. You can skip this step — all optional datapoints will be included.',
      bannerInProgress: 'Your DMA is still in progress (no material IROs found). You can skip this step — all optional datapoints will be included.',
      bannerAi: 'Filter applied: optional datapoints are included if their ESRS standard matches a material IRO. You can modify each entry before proceeding.',
      skip: 'Skip — include all optional',
      regenerate: 'Recalculate filter',
      generating: 'Applying DMA filter...',
      include: 'INCLUDE',
      exclude: 'EXCLUDE',
      code: 'Code',
      name: 'Name',
      aiRec: 'AI Rec.',
      override: 'Override',
      reason: 'Reason',
      dmaUnavailable: 'DMA unavailable',
      overrideChip: 'override',
      materialIros_one: '{{count}} material IRO found',
      materialIros_other: '{{count}} material IROs found',
      datapoints: 'datapoint',
      stubWarning: 'No optional templates found for the selected framework — all optional datapoints will be included by default.',
    },
    sourceSelectionStep: {
      esrsTitle: 'ESRS',
      esrsDesc: 'EFRAG IG3 datapoints (mandatory and optional)',
      esrsOmnibusTitle: 'ESRS Omnibus',
      esrsOmnibusDesc: 'Simplified ESRS post-Omnibus (459 datapoints, -61% vs IG3)',
      miniOmnibusTestTitle: 'MiniOmnibus Test',
      miniOmnibusTestDesc: '5 test datapoints (E1, S1, G1) — for development and testing only',
      griTitle: 'GRI',
      griDesc: 'Global Reporting Initiative templates',
      tnfdTitle: 'TNFD',
      tnfdDesc: 'Taskforce on Nature-related Financial Disclosures',
      sfdrTitle: 'SFDR',
      sfdrDesc: 'Sustainable Finance Disclosure Regulation',
      datapoints: 'datapoint',
      code: 'Code',
      name: 'Name',
    },
    dataCollectionPage: {
      title: 'Data Collection',
      campaigns: 'Campaigns',
      myData: 'My Data',
      activity: 'Activity history',
    },
    dataValidationPage: {
      title: 'Data Validation',
      review: 'Review',
      consolidation: 'Consolidation',
      activity: 'Activity history',
    },
    countryNames: {
      IT: 'Italy', ES: 'Spain', FR: 'France', DE: 'Germany', PT: 'Portugal',
      AT: 'Austria', BE: 'Belgium', NL: 'Netherlands', PL: 'Poland', RO: 'Romania',
      SE: 'Sweden', CZ: 'Czech Republic', HU: 'Hungary', GR: 'Greece', CH: 'Switzerland',
      GB: 'United Kingdom', US: 'United States',
    },
    activityHistory: {
      empty: 'No actions recorded on your data.',
      valueLabel: 'Value',
      actions: {
        draft: 'Saved as draft',
        in_validation: 'Submitted for validation',
        validated: 'Validated',
        approved: 'Approved',
        admin_modified: 'Modified by admin',
        to_compile: 'Sent back for completion',
        compiled_mcp: 'Filled via AI agent',
        ownership_review_raised: "Reported: I'm not the owner",
        ownership_review_withdrawn: 'Owner report withdrawn',
        ownership_review_reassigned: 'Data owner reassigned',
      },
    },
    mandatoryPanel: {
      mandatoryTitle: 'Mandatory Datapoints',
      mandatoryDesc: 'These datapoints are required by ESRS regulation and are created automatically.',
      suggestedTitle: 'Suggested Datapoints',
      suggestedDesc: 'Optional datapoints linked to ESRS/GRI standards. Add those relevant to your company.',
      code: 'Code',
      name: 'Name',
      standard: 'Standard',
      disclosure: 'Disclosure',
      type: 'Type',
      crossMapping: 'Cross-mapping',
      add: 'Add',
      added: 'Added',
      autoCreating: 'Creating mandatory datapoints...',
      created: 'created',
      skipped: 'already existing',
      noSuggestions: 'No suggestions available',
      noMandatory: 'No mandatory templates configured',
      adding: 'Adding...',
      datapointUnit: 'datapoints',
      suggestedUnit: 'suggested',
      dataType: { numeric: 'Quantitative', text: 'Qualitative' },
    },
    campaignDetail: {
      title: 'Campaign Detail',
      coverage: 'Coverage',
      completion: 'Completion',
      overdue: 'Overdue',
      delegations: 'Delegations',
      ownerProgress: 'Progress by Owner',
      validatorProgress: 'Progress by Validator',
      standardProgress: 'Progress by Standard',
      owner: 'Owner',
      validator: 'Validator',
      standard: 'Standard',
      total: 'Total',
      completed: 'Completed',
      progress: 'Progress',
      actions: 'Actions',
      send: 'Send Notifications',
      remind: 'Send Reminders',
      forceFill: 'Force Fill',
      delegate: 'Delegate',
      value: 'Value',
      notes: 'Notes',
      save: 'Save',
      cancel: 'Cancel',
      toUser: 'To User',
      userName: 'Name',
      userEmail: 'Email',
      userId: 'User ID',
      notFound: 'Campaign not found',
      sent: 'Notifications sent',
      reminded: 'Reminders sent',
      forceFilled: 'Value forced',
      delegated: 'Datapoint delegated',
      statusColumn: 'Status',
      validators: 'Validators',
      noValidators: 'No validator assigned',
      status: { draft: 'Draft', active: 'Active', completed: 'Completed', cancelled: 'Cancelled' },
    },
    progressDashboard: {
      title: 'Data Collection Progress',
      noCampaigns: 'No campaign found for the selected year',
      datapointUnit: 'datapoints',
      completedSuffix: 'completed',
      overdueSuffix: 'overdue',
      totalDatapoint: 'Total Datapoints',
      completed: 'Completed',
      overdue: 'Overdue',
      byStandard: 'Progress by ESRS Standard',
      byOwner: 'Progress by Owner',
      byValidator: 'Progress by Validator',
      colCode: 'Code',
      colName: 'Name',
      colOwner: 'Owner',
      colStandard: 'Standard',
      colStatus: 'Status',
      colDeadline: 'Deadline',
      colAction: 'Action',
      reminded: 'Reminded',
      noOwner: 'No owner assigned',
      alreadyCompleted: 'Already completed',
      remindTooltip: 'Remind {{name}}',
      remindAria: 'remind',
      ownershipReviewChip: 'Owner to review',
      ownershipReviewFilter: 'Owner to review',
      ownershipReviewFilterTooltip:
        'Show only the data points whose owner reported not being the owner of the data',
      ownershipReviewRows_one: '{{count}} to review',
      ownershipReviewRows_other: '{{count}} to review',
      reassign: 'Reassign',
      reassignTooltip: 'Move the data point to the right owner and validator',
      reassignTitle: 'Reassign the data point',
      reassignRaisedBy: 'Reported by {{name}}',
      reassignSuggests: 'suggests {{name}}',
      reassignNewOwner: 'New owner',
      reassignNewValidator: 'New validator',
      reassignNeedsOwner: 'Choose the new owner from the list',
      reassignNeedsValidator:
        'Choose the new validator from the list, or clear the field to leave it unchanged',
    },
    info: {
      ariaLabel: 'Datapoint information',
      title: 'ESRS reference',
      descriptionTitle: 'Description',
      loadingDescription: 'Loading...',
      noDescription: 'No description available.',
      disclosure: 'Disclosure',
      paragraph: 'Paragraph',
      ar: 'Application Requirement',
      noRefs: 'No reference available',
      efragLink: 'Simplified ESRS guidance (EFRAG)',
      howToCalculateTitle: 'How to calculate',
      whatToMeasure: 'What to measure',
      scopeAndPerimeter: 'Scope & boundaries',
      howToCalculate: 'Formula / method',
      unit: 'Unit of measure',
    },
    campaignManager: {
      title: 'Collection Campaigns',
      newCampaign: 'New Campaign',
      showArchived: 'Show archived',
      noCampaigns: 'No campaigns found',
      yearLabel: 'Year {{year}}',
      newPeriod: 'New period',
      createNewPeriod: 'Create new period',
      newPeriodCreatedToast: 'New period "{{label}}" created',
      newPeriodDialog: {
        title: 'New period',
        description: 'Create a new campaign "{{name}}" for the selected period. The datapoints will stay the same, ready for a new collection.',
      },
      columns: {
        name: 'Name',
        status: 'Status',
        deadline: 'Deadline',
        progress: 'Progress',
        actions: 'Actions',
      },
      actions: {
        send: 'Send',
        cancel: 'Cancel',
        view: 'Detail',
        create: 'Create',
        close: 'Close',
        delete: 'Delete',
        archive: 'Archive',
      },
      fields: {
        description: 'Description',
        year: 'Year',
        campaignName: 'Campaign name',
        period: 'Period',
        fullYear: 'Full year',
        none: 'None',
      },
      standards: {
        section: 'Standards to collect',
        noneAllHint: 'None selected: all datapoints from the configuration will be included',
        selectedCount: 'Selected: {{count}} datapoints',
      },
      toasts: {
        sent: 'Campaign sent',
        cancelled: 'Campaign cancelled',
        created: 'Campaign created',
        deleted: 'Campaign deleted',
        archived: 'Campaign archived',
      },
      delete: {
        confirmTitle: 'Confirm deletion',
        confirmMsg: 'Are you sure you want to delete campaign',
        warning: 'This action is irreversible and will also delete:',
        deleteUnavailableTooltip: 'Active or closed campaigns cannot be deleted. You can archive them.',
        allDatapoints: 'All associated data points',
        allConsolidationData: 'All consolidation data',
        rolesUnchanged: 'User assignments (roles) will remain unchanged.',
      },
      ariaLabels: {
        sendCampaign: 'Send campaign',
        cancelCampaign: 'Cancel campaign',
        deleteCampaign: 'Delete campaign',
        deleteUnavailable: 'Delete unavailable',
      },
      campaignStatus: {
        draft: 'Draft',
        active: 'Active',
        completed: 'Closed',
        cancelled: 'Cancelled',
      },
      periods: {
        h1: 'H1 (Jan–Jun)',
        h2: 'H2 (Jul–Dec)',
        q1: 'Q1 (Jan–Mar)',
        q2: 'Q2 (Apr–Jun)',
        q3: 'Q3 (Jul–Sep)',
        q4: 'Q4 (Oct–Dec)',
        m1: 'M1 — January',
        m2: 'M2 — February',
        m3: 'M3 — March',
        m4: 'M4 — April',
        m5: 'M5 — May',
        m6: 'M6 — June',
        m7: 'M7 — July',
        m8: 'M8 — August',
        m9: 'M9 — September',
        m10: 'M10 — October',
        m11: 'M11 — November',
        m12: 'M12 — December',
      },
      comparisonField: {
        label: 'Comparison campaign (optional)',
        none: 'No comparison',
      },
    },
    sourceDocuments: {
      title: 'Library',
      subtitle: 'Documents backing your data: policies, methodologies, scopes',
      upload: 'Upload document',
      uploadTitle: 'New document',
      chooseFile: 'Choose file…',
      fieldName: 'Name',
      fieldDescription: 'Description',
      fieldCategory: 'Category',
      fieldYear: 'Reference year',
      fieldYearInfo: 'Reporting year: {{year}} (current working year)',
      colName: 'Document',
      colCategory: 'Category',
      colYears: 'Years',
      colFile: 'File',
      colUploadedBy: 'Uploaded by',
      open: 'Open',
      empty: 'No documents in the library yet. Upload the first one with the button above.',
      duplicateWarning: 'This file is already in the library as "{{name}}": it was not uploaded again.',
      linkedDocuments: 'Source documents',
      linkedDocumentsHelper: 'Link the documents backing this value (optional)',
      documentUnavailable: 'Document no longer in library',
      selectCategory: 'Select a category',
      uploadInLibrary: 'Missing a document? Upload it to the library',
      fieldVisibility: 'Confidentiality',
      selectVisibility: 'Choose who can see this document',
      visibilityShared: 'Shareable internally',
      visibilityRestricted: 'Restricted — contains sensitive data',
      visibilityPublic: 'Public — shareable outside the company',
      visibilityHelp: 'Required choice: shareable documents are visible to the whole library.',
      restrictedHelp: 'Visible only to you, the validator of linked datapoints, and the administrator.',
      restrictedBadge: 'Restricted',
      publicHelp: 'Visible to the whole library and usable outside the company: reports, customer questionnaires, tenders. Choose this level only if publication has been authorised.',
      publicBadge: 'Public',
      inheritedBadge: 'Inherited — to review',
      confirmYear: 'Confirm for this year',
      removeYear: 'Remove from this year',
      draftBadge: 'Draft — to be confirmed',
      draftByAgent: 'Uploaded by {{agent}} for {{name}}',
      draftPickerLabel: 'draft',
      confirmDraft: 'Confirm the document',
      confirmDraftTitle: 'Confirm the draft document',
      confirmDraftText: 'This document was uploaded by an AI agent and so far only the person who uploaded it and administrators can see it. Open it, check it is the right file and choose who can see it.',
      confirmDraftAction: 'Confirm',
      detailsTitle: 'Document details',
      draftReadOnlyText: 'Document uploaded by an AI agent, waiting for the uploader to confirm it.',
      noDescription: 'No description',
      draftVisibilityPending: 'To be chosen on confirmation',
      close: 'Close',
    },
  },
  settings: {
    sustainablePlatformPage: {
      siaTitle: 'Sustainability Impact Assessment (SIA)',
      gsfTitle: 'Green Software Principles (GSF)',
      carbonAwareTitle: 'Carbon-Aware Architecture',
      sciTitle: 'SCI Measurement (ISO/IEC 21031:2024)',
      cloudEmissionTitle: 'Cloud Emission Measurement (GHG Protocol)',
      embodiedHardware: 'Embodied (hardware)',
      locationVsMarketTitle: 'Location vs Market Method (GHG Protocol Scope 2)',
      csrdBothMethodsNote: 'EU CSRD mandates both methods. Market-based reflects Azure renewable procurement (RECs).',
      embodiedLifecycleCaption: 'Server ~{{serverKg}} kgCO2e total, 1/{{vcpu}} vCPU allocation over {{years}} years = {{userShare}} gCO2eq/year',
      biodiversityTitle: 'Digital Biodiversity (LCIA / TNFD)',
      datacenterSitingCaption: 'Azure Italy North — {{area}} m², urban/industrial site, CF = {{cf}} PDF·m²·yr per m²·yr',
      overallVerdict: 'All Environmental, Social, Economic pillars at PASS status. GSF Level 3 (Practiced). TNFD LEAP 4/4 complete. WCAG AA compliant. Bundle optimized with code splitting.',
      methodologyNotes: 'Methodology Notes',
      methodologySiaTitle: 'Sustainability Impact Assessment (SIA)',
      methodologySiaText: 'The SIA framework uses the A5 structure (Environmental, Social, Economic) with internal qualitative assessment. Each area is evaluated PASS/PARTIAL/NEEDS WORK based on evidence documented in the source code and project configuration.',
      methodologyGsfTitle: 'Green Software Principles (GSF)',
      methodologyGsfText: 'Self-assessment based on the GSF Maturity Matrix. Each principle is evaluated on a 1-5 scale with specific evidence. The overall maturity level (Level 3 — Practiced) represents the weighted average of applicable principles.',
      methodologySciTitle: 'SCI Measurement (ISO/IEC 21031:2024)',
      methodologySciText: 'SCI measurements follow ISO/IEC 21031:2024 standard. Energy data is empirically measured via DevTools (CPU profiling, Network transfer) and Lighthouse. Embodied emissions are calculated using Boavizta and Groger et al. data.',
      methodologyCloudTitle: 'Cloud Emission Measurement',
      methodologyCloudText: 'Methodology aligned with GHG Protocol Corporate Standard (Scope 2+3). Carbon intensity from EMBER 2024 (Italy: 310 gCO2eq/kWh). Azure Italy North PUE: 1.12. Both location-based and market-based methods are reported as required by CSRD.',
      methodologyBiodiversityTitle: 'Digital Biodiversity',
      methodologyBiodiversityText: 'Impact quantified via LCIA using ReCiPe 2016 Endpoint characterization factors and Ecoinvent v3+ data. TNFD LEAP framework completed across all 4 phases. Datacenter siting evaluation based on biodiversity criteria (ecological corridors, protected areas, water stress).',
      methodologyLimitationsTitle: 'Limitations and Uncertainties',
      methodologyLimitationsText: 'Data presented are estimates based on empirical measurements and published models, with an estimated uncertainty margin of ±15-25%. They have not been subjected to third-party audit. Embodied emissions use literature LCA data, not direct supply chain measurements. Water consumption data is based on WUE values published by cloud providers.',
    },
    roleManagement: {
      title: 'Data Capture Roles',
      subtitle: 'Configure company roles and assign responsible people by country.',
      addRole: 'New Role',
      seed: 'Load Defaults',
      noRoles: 'No roles configured. Click "Load Defaults" to get started.',
      principalPerson: 'Principal Person',
      principalPersonHint: 'User assigned when scope is "Centralized" or as fallback for unconfigured countries.',
      selectPerson: 'Select person...',
      columns: {
        code: 'Code',
        name: 'Name',
        nameEN: 'Name EN',
        defaultRole: 'Default',
        active: 'Active',
        actions: 'Actions',
        country: 'Country',
        person: 'Person',
        assignments: 'Assignments',
      },
      actions: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
      },
      delete: {
        confirm: 'Delete this role?',
        cannotDeleteDefault: 'Default roles cannot be deleted',
      },
      ariaLabels: {
        deleteRole: 'Delete role',
        cannotDeleteDefault: 'Default roles cannot be deleted',
      },
    },
    countries: {
      all: 'All',
      IT: 'Italy',
      ES: 'Spain',
      FR: 'France',
      CH: 'Switzerland',
      AL: 'Albania',
      DK: 'Denmark',
      TR: 'Turkey',
      IL: 'Israel',
    },
    tabs: {
      frameworkMapping: 'Framework Mapping',
      dataCaptureRoles: 'Data Capture Roles',
      apiTokens: 'API Tokens',
    },
    users: {
      title: 'User Management',
      subtitle: 'View, edit and manage platform users.',
      searchPlaceholder: 'Search by name or email...',
      searchAriaLabel: 'Search users',
      filterRole: 'Filter by role',
      filterStatus: 'Filter by status',
      allRoles: 'All roles',
      allStatuses: 'All statuses',
      nome: 'First Name',
      cognome: 'Last Name',
      email: 'Email',
      ruolo: 'Role',
      stato: 'Status',
      ultimoAccesso: 'Last Access',
      azioni: 'Actions',
      attivo: 'Active',
      inattivo: 'Inactive',
      editUser: 'Edit User',
      editUserAria: 'Edit user',
      noUsers: 'No users found.',
      userActive: 'User active',
      addUser: 'Add User / Internal Stakeholder',
      totalUsers: 'total users',
      ruoloPiattaforma: 'Platform Role',
      addUserSave: 'Add',
      requiredField: 'Required field',
      invalidEmail: 'Invalid email',
      createdSuccess: 'User created successfully',
      createError: 'Error while creating the user',
      loadError: 'Error while loading users',
      saveError: 'Error while saving',
      roles: {
        amministratore: 'Administrator',
        responsabile_esg: 'ESG Manager',
        contributore: 'Contributor',
        visualizzatore: 'Viewer',
        global_admin: 'Global Admin',
        country_admin: 'Country Admin',
        legal_reviewer: 'Legal Reviewer',
      },
    },
    frameworkMapping: {
      subtitle: 'Manage cross-framework ESG mappings',
      sourceFramework: 'Source Framework',
      targetFramework: 'Target Framework',
      matchType: 'Match Type',
      all: 'All',
      sourceCode: 'Source Code',
      targetCode: 'Target Code',
      confidence: 'Confidence',
      source: 'Source',
      actions: 'Actions',
      addMapping: 'New Mapping',
      editMapping: 'Edit Mapping',
      editMappingAria: 'Edit mapping',
      deleteMappingAria: 'Delete mapping',
      notes: 'Notes',
      officialReference: 'Official Reference',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      confirmDelete: 'Are you sure you want to delete this mapping?',
      totalMappings: 'Total Mappings',
      noMappings: 'No mappings found.',
      official: 'Official',
      seed: 'Seed',
      manual: 'Manual',
      exact: 'Exact',
      partial: 'Partial',
      related: 'Related',
    },
    tokens: {
      sectionTitle: 'API Tokens',
      newToken: 'New Token',
      newTokenApi: 'New API Token',
      loadError: 'Error while loading tokens',
      colName: 'Name',
      colPermissions: 'Permissions',
      colCreatedAt: 'Created on',
      colLastUsed: 'Last used',
      colActions: 'Actions',
      revokeTooltip: 'Revoke token',
      revokeAria: 'Revoke token {{name}}',
      noTokens: 'No active token. Create a token to connect an MCP agent.',
      never: 'Never',
      permissions: 'Permissions',
      read: 'Read',
      write: 'Write',
      agentName: 'Agent name',
      agentNamePlaceholder: 'e.g. Francesco\'s Impact Officer',
      requiredField: 'Required field',
      createError: 'Error while creating the token',
      copyWarning: 'Copy the token now. It will no longer be visible after closing.',
      tokenLabel: 'Token',
      copyAria: 'Copy token',
      copied: 'Copied!',
      close: 'Close',
      cancel: 'Cancel',
      createToken: 'Create Token',
      revokeTitle: 'Revoke Token',
      revokeError: 'Error while revoking the token',
      revokeQuestion: 'Revoke token',
      revokeConfirm: 'The agent will immediately lose access to the platform.',
      revoke: 'Revoke',
    },
    sustainablePlatform: {
      pageTitle: 'Sustainable Platform',
      downloadPdf: 'Download PDF',
      generatingPdf: 'Generating...',
      area: 'Area',
      notes: 'Notes',
      region: 'Region',
      reductionStrategies: 'Reduction Strategies',
      annualEstimate: 'Annual Estimate (20 users)',
      energyPageView: 'Energy — Page View',
      energyPdf: 'Energy — PDF Generation',
      monthlyEstimate: 'Monthly Estimate (20 active users)',
      activity: 'Activity',
      volumeMonth: 'Volume/month',
      monthlyTotal: 'Monthly Total',
      priorityActions: 'Priority Actions',
      action: 'Action',
      priority: 'Priority',
      expectedImpact: 'Expected Impact',
      cloudEmissionsLocation: 'Cloud Emissions (location)',
      cloudEmissionsMarket: 'Cloud Emissions (market)',
      waterUsage: 'Water Usage',
      infrastructureBoundary: 'Infrastructure Boundary',
      serverLifetime: 'Server Lifetime',
      years: 'years',
      decomposition: 'Decomposition',
      category: 'Category',
      detail: 'Detail',
      method: 'Method',
      value: 'Value',
      source: 'Source',
      description: 'Description',
      embodiedLifecycle: 'Embodied Emissions — Hardware Lifecycle (LCA)',
      waterConsumption: 'Water Consumption (WUE)',
      formula: 'Formula',
      datacenterCooling: 'Datacenter cooling',
      electricityProduction: 'Electricity production',
      total: 'Total',
      totalImpact: 'Total Impact',
      dominantPathway: 'Dominant Pathway',
      materials: 'Materials',
      landUse: 'Land Use',
      initiated: 'Initiated',
      biodiversityPathways: 'Biodiversity Impact Pathways',
      unit: 'Unit',
      materialExtraction: 'Material Extraction — Impact by Material',
      material: 'Material',
      impact: 'Impact',
      phase: 'Phase',
      datacenterSiting: 'Datacenter Siting Evaluation',
      criterion: 'Criterion',
      ourValue: 'Our Value',
      risk: 'Risk',
      biodiversityChecklist: 'SIA A5. Biodiversity — Checklist',
      item: 'Item',
      infrastructureConfig: 'Infrastructure Configuration',
      collapseConfig: 'Collapse configuration',
      expandConfig: 'Expand configuration',
      instanceType: 'Instance Type',
      serverLifeYears: 'Server life (yrs)',
      resetDefaults: 'Reset to Defaults',
      methodologyNotes: 'Methodology Notes',
    },
  },
  dataConfiguration: {
    searchDatapoint: 'Search by code or datapoint name...',
    noDatapointAvailable: 'No datapoint available',
  },
  kpiDashboard: {
    campaignLabel: 'Campaign:',
    clickHint: 'Click on a value to see the source datapoint',
    loadError: 'Error while loading KPIs',
    popover: {
      value: 'Value',
      status: 'Status',
      esrsStandard: 'ESRS Standard',
      campaign: 'Campaign',
      clickCodeHint: 'Click the code to open the datapoint',
    },
    sections: {
      climate: 'Climate & Energy',
      ethical: 'Ethical Conduct',
      employees: 'Employee Engagement & Inclusion',
    },
    subsections: {
      scopeEmissions: 'Scope 1+2 emissions',
      carbonIntensity: 'Carbon Intensity Index',
      energy: 'Energy',
      codeOfConduct: 'Code of Conduct',
    },
    kpi: {
      scope1: 'Scope 1 emissions',
      scope2LocationBased: 'Scope 2 emissions (location-based)',
      carbonIntensityIndex: 'Carbon Intensity Index',
      totalEnergy: 'Total energy consumption',
      renewableEnergy: 'Energy from renewable sources',
      gooCoverage: 'Scope 2 GoO coverage',
      antiCorruptionTraining: 'Anti-corruption training',
      convictionsAntiCorruption: 'Anti-corruption convictions',
      finesAntiCorruption: 'Anti-corruption fines',
      performanceReviewParticipation: 'Performance review participation',
      employeeTurnover: 'Employee turnover',
      genderPayGap: 'Gender pay gap',
      workforceHealthSafety: 'Workforce covered by H&S',
      workAccidentsRate: 'Work-related accidents rate',
    },
    caption: {
      ownOperations: 'Offices + fleet (own operations)',
      withGoO: 'With Guarantees of Origin (GoO)',
      gooBuildings: 'Buildings electricity from contractual instruments',
      functionsAtRisk: 'Functions-at-risk covered',
      recordableAccidents: 'Recordable accidents per million hours worked',
    },
    previewTitle: 'Key KPIs',
    viewAll: 'Expand',
    collapse: 'Collapse',
    noActiveCampaignShort: 'No active campaign',
  },
  dataCollection: {
    allCampaigns: 'All campaigns',
    myData: 'My Data',
    noCampaignsForYear: 'No campaign found for the selected year',
    noAssignmentsForYear: 'No datapoint assigned for the selected year',
    deadlinePrefix: 'Deadline',
    yearPrefix: 'Year',
    completedOf: '{{completed}}/{{total}} completed',
    colCode: 'Code',
    colName: 'Name',
    colStandard: 'Standard',
    colStatus: 'Status',
    colDeadline: 'Deadline',
    colAction: 'Action',
    fill: 'Fill in',
    continue: 'Continue',
    loadingDetails: 'Loading...',
    noDescription: 'No description available for this datapoint.',
    hideDetails: 'Hide details',
    details: 'Details',
    valueField: 'Value',
    booleanYes: 'Yes',
    booleanNo: 'No',
    dateField: 'Date',
    notesOptional: 'Notes (optional)',
    notesPlaceholder: 'Add notes or methodology used...',
    saveDraft: 'Save draft',
    submitForValidation: 'Submit for validation',
    notAvailable: 'Data not available',
    notAvailableShort: 'Not available',
    rejectionWarning: 'This data point was sent back by the validator. Reason:',
    comparisonCampaignValue: 'Comparison campaign value',
    ownershipReview: {
      checkbox: "I'm not the owner of this data",
      suggestedOwner: 'Who do you think owns it? (name or function)',
      suggestedOwnerHelper:
        'Optional. Applies to this campaign: the row stays open until it is reassigned.',
      report: 'Report',
      withdraw: 'Withdraw report',
      viewReport: 'View report',
      chip: 'Owner to review',
      raisedBy: 'Reported by {{name}} on {{date}}',
      raisedByNoDate: 'Reported by {{name}}',
      suggested: 'Suggested: {{name}}',
      openedByOther:
        '{{name}} reported not being the owner of this data (suggested: {{suggested}}). It is now assigned to you: if the data is yours, just fill it in.',
      perCountryBlocked:
        'This data is collected per country: an owner change cannot be requested from here. To change it, contact the administrator.',
    },
  },
  consolidation: {
    noDatapoints: 'No per-country datapoint to consolidate for this year.',
    noDatapointsHelp: 'Consolidation is needed only when datapoints are configured in "Per country" mode with multiple owners.',
    totalDatapoints: '{{count}} total datapoints',
    consolidatedCount: '{{count}} consolidated',
    toConsolidate: '{{count}} to consolidate',
    consolidatedOfTotal: '{{consolidated}}/{{total}} consolidated',
    consolidated: 'Consolidated',
    draft: 'Draft',
    toBeConsolidated: 'To consolidate',
    adminModified: 'Modified by admin',
    main: '🌍 Main',
    restore: 'Restore',
    exclude: 'Exclude',
    notRequired: 'Not required',
    statusToCompile: 'To compile',
    statusDraft: 'Draft',
    statusInValidation: 'In validation',
    statusValidated: 'Validated',
    statusApproved: 'Approved',
    consolidatedValue: 'Consolidated value',
    consolidatedAnswer: 'Consolidated answer',
    edit: 'Edit',
    notes: 'Notes',
    consolidatedBy: 'Consolidated by {{name}}',
    numericPlaceholder: 'Enter the group final value',
    textPlaceholder: 'Enter the group consolidated answer...',
    notesPlaceholder: 'Notes (optional)',
    saveDraft: 'Save draft',
    confirm: 'Confirm',
    confirmTitle: 'Consolidation confirm',
    consolidatedValueLabel: 'Consolidated value: ',
    confirmInfo: 'Once confirmed, the datapoints of the included countries will be marked as Validated.',
    yesConfirm: 'Yes, confirm',
    campaign: 'Campaign',
    campaignInfo: {
      ariaLabel: 'Campaign information',
      title: 'Campaign details',
      description: 'Description',
      noDescription: 'No description',
      period: 'Period',
      year: 'Year',
      deadline: 'Deadline',
      notSet: 'Not set',
    },
  },
  campaignComparison: {
    empty: 'This campaign has no comparison campaign set.',
    title: 'Comparison: {{current}} vs {{comparison}}',
    columns: { code: 'Code', name: 'Datapoint', variation: 'Variation' },
    filter: { all: 'All', quantitative: 'Quantitative', qualitative: 'Qualitative' },
  },
  reportAssessment: {
    title: 'Report Assessment — Year {{year}}',
    tabs: {
      progress: 'Progress',
      datapoint: 'Datapoint',
      perCountry: 'By Country',
      kpiChiave: 'Key KPIs',
      compare: 'Comparison',
    },
    toolbar: {
      exportPdf: 'Export PDF',
      filterByStatus: 'Filter by status',
      allStatuses: 'All',
      showArchived: 'Show closed',
      onlyNumeric: 'Numeric only',
      search: 'Search datapoint',
      searchPlaceholder: 'Code or name…',
      clearSearch: 'Clear search',
    },
    empty: {
      noCampaigns: 'No campaign for the selected year.',
      noDatapoints: 'No datapoint in this campaign.',
      noSearchResults: 'No datapoint matches the search.',
      noActiveCampaign: 'No active campaign to show.',
      noSnapshot: 'Snapshot not available for this milestone.',
    },
    campaign: {
      consolidated: 'Consolidated',
      compiled: 'Compiled',
      closeReport: 'Close Report',
      completionPct: '{{pct}}% completed',
      countries: '{{count}} countries',
      compiledOfTotal: '{{compiled}}/{{total}} compiled',
    },
    columns: {
      code: 'Code',
      name: 'Name',
      dataOwner: 'Data Owner',
      validatorConsolidator: 'Validator / Consolidator',
      status: 'Status',
      value: 'Value',
      action: 'Action',
      standard: 'Standard',
    },
    actions: {
      read: 'Read ▸',
      editValueTooltip: 'Edit value (admin)',
    },
    drawer: {
      value: 'Value',
      dataOwner: 'Data Owner',
      country: 'Country',
      notes: 'Notes',
      consolidationNotes: 'Consolidation note',
      compilationDate: 'Compilation date',
      approvedBy: 'Approved by',
      countryBreakdown: 'Country breakdown',
      main: 'Main',
      excludedFromConsolidation: 'Excluded from consolidation',
      sourceDocuments: 'Source documents',
      documentUnavailable: 'Document no longer in library',
    },
    editDrawer: {
      title: 'Edit — {{code}}',
      warning: 'Editing sets the status to "Modified by admin" and is recorded in the audit log.',
      valueField: 'Value',
      valueFieldUnit: 'Value ({{unit}})',
      currentValue: 'Current value: {{value}}',
      notesField: 'Notes',
      currentNotes: 'Current notes: {{notes}}',
      methodologyField: 'Methodology',
      confirmNa: 'Reset the value and mark as N/A?',
      yesMarkNa: 'Yes, mark N/A',
      markNa: 'Mark as N/A',
      save: 'Save',
    },
    milestones: {
      historyTitle: 'Period history',
      closedOnBy: 'Closed on {{date}} by {{name}}',
      completedAt: '{{pct}}% completed',
      typeQuarterly: 'Quarterly',
      typeAnnual: 'Annual',
      typeCustom: 'Custom',
    },
    milestoneDialog: {
      title: 'Close Report / Create Milestone',
      campaignInfo: 'Campaign: {{name}} — Current completion: {{pct}}% ({{consolidated}}/{{total}} consolidated)',
      typeLabel: 'Milestone type',
      typeQuarterly: 'Quarterly milestone',
      typeAnnual: 'Annual closure (blocks changes)',
      typeCustom: 'Custom milestone',
      labelField: 'Label (e.g. Q1 2026, Closure 2025)',
      annualWarning: 'The annual closure blocks all datapoints in the campaign. Only an administrator can reopen the report.',
    },
    messages: {
      editSuccess: 'Datapoint edited successfully',
      editError: 'Error while saving. Please retry.',
      naSet: 'Datapoint set as N/A',
      naError: 'Error during operation. Please retry.',
      noFieldsError: 'Please fill at least one field to edit',
      reportClosed: 'Report definitively closed',
      milestoneCreated: 'Milestone "{{label}}" created',
      datapointNotFound: 'Datapoint with code "{{code}}" not found in current campaign.',
    },
    byCountry: {
      filter: 'Filter',
      allCountries: 'All countries',
      onlyConsolidated: 'Consolidated only',
      onlyCentral: 'Central value only',
      activeFilter: 'Active filter',
      noData: 'No country data available.',
      centralOnlyTitle: 'Central data only',
      centralOnlyDesc: 'The campaign <strong>{{name}}</strong> collected datapoints as a centralized Group value, with no country delegation. The "By Country" tab is useful when the same datapoint is delegated to owners in different countries.',
      centralOnlyDescMulti: 'The selected campaigns collected datapoints as a centralized Group value, with no country delegation. The "By Country" tab is useful when the same datapoint is delegated to owners in different countries.',
      noSelection: 'No datapoint for the current selection.',
      consolidatedValue: 'Consolidated value',
      centralValue: 'Group central value',
      collectedAsCentral: 'collected as central value',
    },
  },
  reporting: {
    dmaOverviewSection: {
      totalIros: 'Total IROs',
      totalIrosAria: 'Total IROs: {{count}}',
      materialIros: 'Material IROs',
      materialIrosAria: 'Material IROs: {{count}} ({{percentage}}%)',
      ofTotal: 'of total',
      materialProgressAria: '{{percentage}}% material',
      averageScore: 'Average Score',
      averageScoreAria: 'Average Score — Impact: {{impact}}, Financial: {{financial}}',
      esrsCoverage: 'ESRS Coverage',
      esrsCoverageAria: 'ESRS Coverage: {{count}} of 10 standards',
      standards: 'standards',
    },
    macroCategorySection: {
      score: 'Score',
      scoreLower: 'score',
      material: 'Material',
      notMaterial: 'Not material',
      impact: 'Impact',
      riskOpp: 'Risk/Opp.',
    },
    materialIrosSection: {
      typeImpact: 'Impact',
      typeRisk: 'Risk',
      typeOpportunity: 'Opportunity',
      horizonShort: 'Short',
      horizonMedium: 'Medium',
      horizonLong: 'Long',
      stakeholderEmployees: 'Employees',
      stakeholderCustomers: 'Customers',
      stakeholderSuppliers: 'Suppliers',
      stakeholderInvestors: 'Investors',
      stakeholderLocalCommunities: 'Local communities',
      stakeholderRegulators: 'Regulators',
      stakeholderPartners: 'Partners',
      stakeholderOther: 'Other',
      valueChainUpstream: 'Upstream',
      valueChainOperations: 'Operations',
      valueChainDownstream: 'Downstream',
      collapse: 'Collapse',
      expand: 'Expand',
      description: 'Description',
      scores: 'Scores',
      scoreImpact: 'Impact',
      scoreFinancial: 'Financial',
      scoreOverall: 'Overall',
      affectedStakeholders: 'Affected Stakeholders',
      valueChainPosition: 'Value Chain Position',
      emptyState: 'No material IROs found for this year.',
      colCodeName: 'Code / Name',
      colType: 'Type',
      colEsrs: 'ESRS',
      colScore: 'Score',
      geographies: 'Geographies',
      horizon: 'Horizon',
      directionAsc: 'asc',
      directionDesc: 'desc',
      caption: '{{count}} material IROs — sorted by {{field}} ({{direction}})',
    },
    materialityMatrixSection: {
      iro: 'IRO',
      impact: 'Impact',
      financial: 'Financial',
      material: 'Material',
      notMaterial: 'Not material',
      priority: 'Priority',
      impactScore: 'Impact Score',
      financialScore: 'Financial Score',
      iros: 'IROs',
      materials: 'Priority (both thresholds)',
      watchList: 'Material (one threshold)',
      lowPriority: 'Not material',
      chartDescription: 'Materiality matrix: {{total}} categories on impact (X) and financial (Y) axes. {{material}} priority, {{watch}} material on one threshold only, {{low}} not material.',
      materialCategoriesAria_one: '{{count}} priority category',
      materialCategoriesAria_other: '{{count}} priority categories',
      watchListCategoriesAria_one: '{{count}} category material on one threshold',
      watchListCategoriesAria_other: '{{count}} categories material on one threshold',
      lowPriorityCategoriesAria_one: '{{count}} non-material category',
      lowPriorityCategoriesAria_other: '{{count}} non-material categories',
    },
    reportingPage: {
      title: 'DMA Report',
      doubleMateriality: 'Double Materiality',
      generating: 'Generating...',
      retry: 'Retry',
      dmaOverview: 'DMA Overview',
      esrsMacroCategories: 'ESRS Macro-Categories',
      materialityMatrix: 'Materiality Matrix',
      materialIros: 'Material IROs',
    },
    reportPdf: {
      esrsStandards: 'ESRS Standards',
      notAssessed: 'Not assessed',
      generationDate: 'Generation date',
      lastConsolidation: 'Last score consolidation',
      scoreRevisionsTitle: 'Score revisions',
      scoreRevisionsIntro: 'Scores revised by the ESG team after the assessments were consolidated, with the rationale recorded in the platform. Marked with † in the IRO list.',
      revisedMarker: '†',
      effectUnchanged: 'Materiality unchanged',
      effectBecomesMaterial: 'Becomes material',
      effectBecomesNotMaterial: 'Becomes not material',
      dimensionImpact: 'Impact',
      dimensionFinancial: 'Financial',
      colPrevious: 'Before',
      colRevised: 'After',
      colRationale: 'Rationale',
      colDate: 'Date',
      colEffect: 'Effect',
      adminAccount: 'administrator account',
      stakeholdersSummaryWithAdmin: '{{stakeholders}} internal contacts and {{admins}} administrator account received {{assessments}} assessments, of which {{completed}} completed.',
      reportTitle: 'DMA Report',
      year: 'Year',
      dmaOverview: 'DMA Overview',
      totalIros: 'Total IROs',
      materialIros: 'Material IROs',
      averageScore: 'Average Score',
      esrsCoverage: 'ESRS Coverage',
      esrsMacroCategories: 'ESRS Macro-Categories',
      material: 'Material',
      notMaterial: 'Not material',
      methodologyTitle: 'Double Materiality Methodology',
      whatIsDma: 'What is Double Materiality?',
      whatIsDmaBody: 'The Double Materiality Assessment (DMA) evaluates ESG topics from two complementary perspectives, in accordance with the ESRS standards required by the CSRD directive:',
      impactMaterialityBullet: '• Impact Materiality (Inside-Out): the impacts the company generates on the environment and society.',
      financialMaterialityBullet: '• Financial Materiality (Outside-In): ESG risks and opportunities that affect the company\'s financial position.',
      orLogicNote: 'A topic is material if it reaches or exceeds at least one of the two thresholds, impact or financial (OR logic); topics reaching both are priorities.',
      processFlowTitle: 'DMA Process Flow',
      processStepSetup: 'Setup: configuration of the assessment scope (companies, countries, value chain, stakeholders, materiality thresholds). Generation of the assessment macro-categories.',
      processStepIroCreation: 'IRO Creation: identification of impacts, risks and opportunities (IROs) mapped to the 10 thematic ESRS standards (E1-E5, S1-S4, G1) and linked to macro-categories.',
      processStepCampaign: 'Assessment Campaign: creation of campaigns with selection of IROs to evaluate, assignment of stakeholders with configurable weights and assessment type (impact, financial, or both).',
      processStepStakeholderAssessment: 'Stakeholder Assessment: each stakeholder fills in their evaluation on impact criteria (scale, scope, irremediability, probability) and/or financial criteria (likelihood, eco-financial impact, reputational, operational). Scale 1-4.',
      processStepConsolidation: 'Consolidation: auto-consolidation after each submission via weighted average of components. Calculation of impactScore, financialScore and overallScore. Materiality thresholds are applied, and the decision recorded, when materiality is recalculated.',
      processStepDashboard: 'Dashboard & Review: visualization of aggregated results in the materiality matrix, with the ability to manually force materiality decisions and modify thresholds.',
      processStepNextYear: 'Next Year: selective cloning of data to the next year for year-over-year comparison.',
      iroClassificationTitle: 'IRO Classification',
      iroClassificationBody: 'Each item in the registry is an IRO (Impact, Risk, Opportunity), classified by type:',
      iroImpactBullet: '• Impact: company\'s impact on environment/society (actual/potential, positive/negative)',
      iroRiskBullet: '• Risk: ESG risk affecting the company (physical, transition, systemic)',
      iroOpportunityBullet: '• Opportunity: ESG opportunity for the company (resource efficiency, products/services, markets, resilience, reputation)',
      iroScopeNote: 'Each IRO defines its scope: geographies, value chain (upstream/operations/downstream), time horizon (short/medium/long) and affected stakeholders.',
      scoringMethodologyTitle: 'Scoring Methodology',
      impactMaterialityScore: 'Impact Materiality Score',
      impactScoreBody: 'Impact assessment uses 4 criteria on a 1-4 scale (Minimum, Low, Moderate, High):',
      impactScaleBullet: '• Scale: severity of the impact',
      impactScopeBullet: '• Scope: extent (subjects/environment involved)',
      impactIrremediabilityBullet: '• Irremediability: difficulty of remediation (negative impacts only)',
      impactProbabilityBullet: '• Probability: likelihood of occurrence (in the current cycle applied to all impacts, actual and potential)',
      impactScoreFormula: 'Negative impact:   Severity = AVG(Scale, Scope, Irremediability)\nPositive impact:   Severity = AVG(Scale, Scope)\n\nActual and potential impact: impactScore = Severity x Probability\n\nRange: 1-16 (max = 4 x 4)',
      financialMaterialityScore: 'Financial Materiality Score',
      financialScoreBody: 'Financial assessment collects 4 criteria on a 1-4 scale; the score uses 3 of them (Eco-Financial Impact is collected but does not enter the calculation):',
      financialLikelihoodBullet: '• Likelihood: probability (Remote < 1%, Unlikely 1-10%, Possible 10-50%, Very likely > 50%)',
      financialEcoBullet: '• Eco-Financial Impact: effects on ARR, EBITDA, Cashflow (collected, not used in the score)',
      financialReputationalBullet: '• Reputational Impact: effects on stakeholders and media',
      financialOperationalBullet: '• Operational Impact: consequences on processes and continuity',
      overallScoreTitle: 'Overall Score & Materiality Decision',
      thresholdsTitle: 'Materiality Thresholds',
      thresholdsBody: 'An impact is material if its impact score reaches or exceeds the impact threshold; a risk or opportunity is material if its financial score reaches or exceeds the financial threshold. Thresholds are set in the DMA configuration of each year:',
      consolidationTitle: 'Multi-Stakeholder Consolidation',
      consolidationBody: 'When multiple stakeholders assess the same IRO, the system consolidates scores through weighted average of individual components. After each assessment submission, the system automatically performs consolidation:',
      consolidationFormula: 'For each criterion (e.g. scale, scope, likelihood):\n  weighted_avg = SUM(value_i x weight_i) / SUM(weight_i)\n\nThen standard impactScore and\nfinancialScore formulas are applied.\n\noverallScore = MAX(impactScore, financialScore)',
      manualForceNote: 'It is also possible to manually force the materiality decision with a mandatory rationale, overriding the automatic calculation.',
      thematicEsrsTitle: 'Thematic ESRS Standards',
      thematicEsrsBody: 'The system covers the 10 thematic ESRS standards: E1 (Climate change), E2 (Pollution), E3 (Water and marine resources), E4 (Biodiversity and ecosystems), E5 (Resource use and circular economy), S1 (Own workforce), S2 (Workers in the value chain), S3 (Affected communities), S4 (Consumers and end-users), G1 (Business conduct).',
      materialityMatrix: 'Materiality Matrix',
      topics_one: 'topic',
      topics_other: 'topics',
      materialPlural: 'Material',
      priorityPlural: 'Priority',
      totalTopics: 'Total topics',
      macroCategories: 'Macro-categories',
      colCodeName: 'Code / Name',
      colType: 'Type',
      colGeographies: 'Geographies',
      colHorizon: 'Horizon',
      horizonShort: 'Short',
      horizonMedium: 'Medium',
      horizonLong: 'Long',
      stakeholderEmployees: 'Employees',
      stakeholderCustomers: 'Customers',
      stakeholderSuppliers: 'Suppliers',
      stakeholderInvestors: 'Investors',
      stakeholderLocalCommunities: 'Local communities',
      stakeholderRegulators: 'Regulators',
      stakeholderPartners: 'Partners',
      stakeholderOther: 'Other',
      interviewedStakeholders: 'Internal contacts involved',
      stakeholdersSummary: '{{stakeholders}} internal contacts received {{assessments}} assessments to complete, of which {{completed}} completed.',
      colName: 'Name',
      colRole: 'Role',
      coverTitle: 'Double Materiality\nAssessment',
      coverSubtitle: 'ESG Impacts, Risks and Opportunities Assessment',
      referenceYear: 'Reference Year',
      issueDate: 'Issue Date',
      confidentialDocument: 'Confidential document — generated by TeamSystem Impact',
    },
    title: 'Reports',
    csrd: 'CSRD Report',
    dnf: 'Non-Financial Statement',
    taxonomyReport: 'Taxonomy Report',
    executiveSummary: 'Executive Summary',
  },
  taxonomy: {
    title: 'EU Green Taxonomy',
    activities: 'Economic Activities',
    assessment: 'Assessment',
    kpi: 'Taxonomy KPIs',
    eligible: 'Eligible',
    aligned: 'Aligned',
  },
  errors: {
    generic: 'An error occurred',
    network: 'Network error',
    unauthorized: 'Unauthorized',
    forbidden: 'Access denied',
    notFound: 'Resource not found',
  },
  about: {
    title: 'About',
    version: 'Version',
    buildDate: 'Build date',
    commit: 'Commit',
    changelog: 'Changelog',
    releaseTitle: 'Current release',
    accessibility: 'Accessibility',
    wcagLevel: 'WCAG Level',
    wcagBadge: 'AA — ~90% conformance',
    wcagDescription: 'The platform reaches about 90% conformance with WCAG 2.1 Level AA. Implemented: 4.5:1 text contrast, full keyboard navigation, visible focus indicators, semantic heading hierarchy and ARIA attributes on interactive components. Percentage estimated from an internal static audit; some minor items (e.g. full border contrast, persistent notifications) and dynamic screen-reader testing are still pending.',
    a11yLanguage: 'Page language declared (lang="it")',
    a11yStructure: 'Semantic HTML structure with accessible MUI components',
    a11yAria: 'ARIA attributes on main components',
    a11yKeyboard: 'Full keyboard navigation with Tab, Enter, Space support',
    a11yFocus: 'Visible focus indicators on all interactive components',
    a11yContrast: 'Text contrast compliant (4.5:1)',
    a11yHeadings: 'Semantic heading hierarchy (h1 → h2 → h3)',
    a11yLastAudit: 'Last audit: 20 July 2026 — ~90% conformance with WCAG 2.1 AA (internal static audit; dynamic testing pending)',
    changelogItems: {
      stakeholderAssessment: 'Stakeholder assessment system with grouped view by assessor',
      scoringAlgorithm: 'Materiality scoring algorithm (DMA 2025) with admin consolidation',
      materialityDashboard: 'Materiality dashboard with comparison panel',
      catalogViews: '3 IRO Catalog view modes (ESRS, Macro Theme, Flat)',
      exportImport: 'DMA export/import scripts and seed data',
      financialValidation: 'Fix for consolidated financial assessment validation',
      obsoleteCleanup: 'Obsolete assessment cleanup in autoConsolidateIRO',
      documentation: 'DMA process technical documentation',
    },
  },
  ma: {
    pageTitle: 'M&A deal files',
    confidentialityBanner:
      'Confidential: unannounced acquisitions. Always use the codename and never share this content outside the authorized people.',
    noDeals: 'You are not authorized on any deal file.',
    loadError: 'Could not load the deal files. Try again or report the problem.',
    dealNotFound: 'Deal file not found.',
    escalationOpen: 'Escalation open',
    redFlagCount_one: '{{count}} red flag',
    redFlagCount_other: '{{count}} red flags',
    updatedAt: 'Updated on {{date}}',
    severity: 'Severity {{level}}',
    companySection: 'Target details',
    companyName: 'Company',
    companySector: 'Sector',
    companyProduct: 'Product',
    companySize: 'Size',
    companyCountry: 'Country',
    escalationSection: 'Escalation to the ESG Office',
    redFlagsSection: 'Red flags',
    noRedFlags: 'No red flag recorded.',
    conclusionsSection: 'ESG team conclusions',
    noConclusions: 'No conclusion recorded.',
    actionPointsSection: 'Suggested actions',
    noActionPoints: 'No suggested action.',
    diarySection: 'Contact diary',
    noTouchpoints: 'No contact recorded.',
    touchpointType: {
      questionario_ricevuto: 'Questionnaire received',
      call: 'Call',
      richiesta_dati: 'Data request',
      escalation: 'Escalation',
      nota: 'Note',
    },
    learningSection: 'Learning',
    briefing: 'Briefing delivered',
    esgOfficeCorrection: 'ESG Office correction',
    outcome: 'Post-closing outcome',
    outcomeMaterialized: 'The risk did materialize',
    outcomeNotMaterialized: 'The risk did not materialize',
  },
  engagement: {
    pageTitle: 'Stakeholder Engagement',
    navAria: 'Stakeholder engagement navigation',
    tabCampaigns: 'Campaigns',
    tabResponses: 'Responses',
    campaigns: {
      title: 'Campaigns',
      newCampaign: 'New Campaign',
      tableAria: 'Campaigns table',
      colName: 'Name',
      colCategory: 'Category',
      colResponses: 'Responses',
      colCreated: 'Created',
      colActions: 'Actions',
      noCampaigns: 'No campaigns found',
      statusActive: 'Active',
      statusClosed: 'Closed',
      closeCampaignAria: 'Close campaign {{name}}',
      reopenCampaignAria: 'Reopen campaign {{name}}',
      name: 'Name',
      description: 'Description',
      categoryAria: 'Stakeholder category',
      assessmentYear: 'Assessment Year',
      cancel: 'Cancel',
      create: 'Create',
      categories: {
        dipendenti: 'Employees',
        investitori: 'Investors',
        clienti: 'Clients',
        fornitori: 'Suppliers',
        comunita_locali: 'Local communities',
        regolatori: 'Regulators',
        ong: 'NGOs',
        sindacati: 'Trade unions',
        altro: 'Other',
      },
    },
    entries: {
      totalResponses: 'Total responses',
      last7Days: 'Last 7 days',
      last30Days: 'Last 30 days',
      filterByCampaignAria: 'Filter by campaign',
      allCampaigns: 'All campaigns',
      tableAria: 'Stakeholder responses table',
      colUser: 'User',
      colComment: 'Comment',
      colDate: 'Date',
      colSource: 'Source',
      colAgent: 'Agent',
      noResponses: 'No responses found',
      rowsPerPage: 'Rows per page:',
    },
  },
  connections: {
    title: 'AI Connections',
    oauthClients: 'Connected Systems',
    noClients: 'No AI systems connected. OAuth clients are registered automatically when an external system connects.',
    revokeClient: 'Revoke client',
    revokeConfirm: 'Are you sure you want to revoke this OAuth client? The system will no longer be able to access the platform.',
    clientId: 'Client ID',
    registeredOn: 'Registered on',
  },
};

// Leggi lingua salvata o usa default
const savedLanguage = localStorage.getItem('teamsystem-impact-language') || 'it';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: translationsIT },
      en: { translation: translationsEN },
    },
    lng: savedLanguage, // Usa lingua salvata o default
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

// Salva lingua quando cambia
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('teamsystem-impact-language', lng);
});

export default i18n;
